(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('isomorphic-fetch'), require('md5')) :
    typeof define === 'function' && define.amd ? define(['exports', 'isomorphic-fetch', 'md5'], factory) :
    (global = global || self, factory(global['@zola-helpers/client'] = {}, global.fetch, global.md5));
}(this, (function (exports, fetch, md5) { 'use strict';

    fetch = fetch && Object.prototype.hasOwnProperty.call(fetch, 'default') ? fetch['default'] : fetch;
    md5 = md5 && Object.prototype.hasOwnProperty.call(md5, 'default') ? md5['default'] : md5;

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    var LOGIN_REQUEST = 'zola/auth/LOGGED_IN';
    var LOGIN_SUCCESS = 'zola/auth/LOGIN_SUCCESS';
    var LOGIN_FAILURE = 'zola/auth/LOGIN_FAILURE';
    var LOGOUT = 'zola/auth/LOGOUT';

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    var _arrayMap = arrayMap;

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function unwrapExports (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var check = function (it) {
      return it && it.Math == Math && it;
    };

    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global_1 =
      // eslint-disable-next-line es/no-global-this -- safe
      check(typeof globalThis == 'object' && globalThis) ||
      check(typeof window == 'object' && window) ||
      // eslint-disable-next-line no-restricted-globals -- safe
      check(typeof self == 'object' && self) ||
      check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
      // eslint-disable-next-line no-new-func -- fallback
      (function () { return this; })() || Function('return this')();

    var fails = function (exec) {
      try {
        return !!exec();
      } catch (error) {
        return true;
      }
    };

    // Detect IE8's incomplete defineProperty implementation
    var descriptors = !fails(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
    });

    var $propertyIsEnumerable = {}.propertyIsEnumerable;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
    var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor(this, V);
      return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable;

    var objectPropertyIsEnumerable = {
    	f: f
    };

    var createPropertyDescriptor = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    var toString = {}.toString;

    var classofRaw = function (it) {
      return toString.call(it).slice(8, -1);
    };

    var split = ''.split;

    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var indexedObject = fails(function () {
      // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
      // eslint-disable-next-line no-prototype-builtins -- safe
      return !Object('z').propertyIsEnumerable(0);
    }) ? function (it) {
      return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
    } : Object;

    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible = function (it) {
      if (it == undefined) throw TypeError("Can't call method on " + it);
      return it;
    };

    // toObject with fallback for non-array-like ES3 strings



    var toIndexedObject = function (it) {
      return indexedObject(requireObjectCoercible(it));
    };

    var isObject = function (it) {
      return typeof it === 'object' ? it !== null : typeof it === 'function';
    };

    // `ToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-toprimitive
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    var toPrimitive = function (input, PREFERRED_STRING) {
      if (!isObject(input)) return input;
      var fn, val;
      if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
      if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
      if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
      throw TypeError("Can't convert object to primitive value");
    };

    // `ToObject` abstract operation
    // https://tc39.es/ecma262/#sec-toobject
    var toObject = function (argument) {
      return Object(requireObjectCoercible(argument));
    };

    var hasOwnProperty = {}.hasOwnProperty;

    var has = function hasOwn(it, key) {
      return hasOwnProperty.call(toObject(it), key);
    };

    var document$1 = global_1.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS = isObject(document$1) && isObject(document$1.createElement);

    var documentCreateElement = function (it) {
      return EXISTS ? document$1.createElement(it) : {};
    };

    // Thank's IE8 for his funny defineProperty
    var ie8DomDefine = !descriptors && !fails(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
      return Object.defineProperty(documentCreateElement('div'), 'a', {
        get: function () { return 7; }
      }).a != 7;
    });

    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
    var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject(O);
      P = toPrimitive(P, true);
      if (ie8DomDefine) try {
        return $getOwnPropertyDescriptor(O, P);
      } catch (error) { /* empty */ }
      if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };

    var objectGetOwnPropertyDescriptor = {
    	f: f$1
    };

    var replacement = /#|\.prototype\./;

    var isForced = function (feature, detection) {
      var value = data[normalize(feature)];
      return value == POLYFILL ? true
        : value == NATIVE ? false
        : typeof detection == 'function' ? fails(detection)
        : !!detection;
    };

    var normalize = isForced.normalize = function (string) {
      return String(string).replace(replacement, '.').toLowerCase();
    };

    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = 'N';
    var POLYFILL = isForced.POLYFILL = 'P';

    var isForced_1 = isForced;

    var path = {};

    var aFunction = function (it) {
      if (typeof it != 'function') {
        throw TypeError(String(it) + ' is not a function');
      } return it;
    };

    // optional / simple context binding
    var functionBindContext = function (fn, that, length) {
      aFunction(fn);
      if (that === undefined) return fn;
      switch (length) {
        case 0: return function () {
          return fn.call(that);
        };
        case 1: return function (a) {
          return fn.call(that, a);
        };
        case 2: return function (a, b) {
          return fn.call(that, a, b);
        };
        case 3: return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
      }
      return function (/* ...args */) {
        return fn.apply(that, arguments);
      };
    };

    var anObject = function (it) {
      if (!isObject(it)) {
        throw TypeError(String(it) + ' is not an object');
      } return it;
    };

    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var $defineProperty = Object.defineProperty;

    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (ie8DomDefine) try {
        return $defineProperty(O, P, Attributes);
      } catch (error) { /* empty */ }
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    var objectDefineProperty = {
    	f: f$2
    };

    var createNonEnumerableProperty = descriptors ? function (object, key, value) {
      return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






    var wrapConstructor = function (NativeConstructor) {
      var Wrapper = function (a, b, c) {
        if (this instanceof NativeConstructor) {
          switch (arguments.length) {
            case 0: return new NativeConstructor();
            case 1: return new NativeConstructor(a);
            case 2: return new NativeConstructor(a, b);
          } return new NativeConstructor(a, b, c);
        } return NativeConstructor.apply(this, arguments);
      };
      Wrapper.prototype = NativeConstructor.prototype;
      return Wrapper;
    };

    /*
      options.target      - name of the target object
      options.global      - target is the global object
      options.stat        - export as static methods of target
      options.proto       - export as prototype methods of target
      options.real        - real prototype method for the `pure` version
      options.forced      - export even if the native feature is available
      options.bind        - bind methods to the target, required for the `pure` version
      options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
      options.unsafe      - use the simple assignment of property instead of delete + defineProperty
      options.sham        - add a flag to not completely full polyfills
      options.enumerable  - export as enumerable property
      options.noTargetGet - prevent calling a getter on target
    */
    var _export = function (options, source) {
      var TARGET = options.target;
      var GLOBAL = options.global;
      var STATIC = options.stat;
      var PROTO = options.proto;

      var nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype;

      var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
      var targetPrototype = target.prototype;

      var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
      var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

      for (key in source) {
        FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

        targetProperty = target[key];

        if (USE_NATIVE) if (options.noTargetGet) {
          descriptor = getOwnPropertyDescriptor$1(nativeSource, key);
          nativeProperty = descriptor && descriptor.value;
        } else nativeProperty = nativeSource[key];

        // export native or implementation
        sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

        if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

        // bind timers to global for call from export context
        if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global_1);
        // wrap global constructors for prevent changs in this version
        else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
        // make static versions for prototype methods
        else if (PROTO && typeof sourceProperty == 'function') resultProperty = functionBindContext(Function.call, sourceProperty);
        // default case
        else resultProperty = sourceProperty;

        // add a flag to not completely full polyfills
        if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
          createNonEnumerableProperty(resultProperty, 'sham', true);
        }

        target[key] = resultProperty;

        if (PROTO) {
          VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
          if (!has(path, VIRTUAL_PROTOTYPE)) {
            createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
          }
          // export virtual prototype methods
          path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
          // export real prototype methods
          if (options.real && targetPrototype && !targetPrototype[key]) {
            createNonEnumerableProperty(targetPrototype, key, sourceProperty);
          }
        }
      }
    };

    // `IsArray` abstract operation
    // https://tc39.es/ecma262/#sec-isarray
    // eslint-disable-next-line es/no-array-isarray -- safe
    var isArray = Array.isArray || function isArray(arg) {
      return classofRaw(arg) == 'Array';
    };

    var ceil = Math.ceil;
    var floor = Math.floor;

    // `ToInteger` abstract operation
    // https://tc39.es/ecma262/#sec-tointeger
    var toInteger = function (argument) {
      return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
    };

    var min = Math.min;

    // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength
    var toLength = function (argument) {
      return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    var createProperty = function (object, key, value) {
      var propertyKey = toPrimitive(key);
      if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
      else object[propertyKey] = value;
    };

    var setGlobal = function (key, value) {
      try {
        createNonEnumerableProperty(global_1, key, value);
      } catch (error) {
        global_1[key] = value;
      } return value;
    };

    var SHARED = '__core-js_shared__';
    var store = global_1[SHARED] || setGlobal(SHARED, {});

    var sharedStore = store;

    var shared = createCommonjsModule(function (module) {
    (module.exports = function (key, value) {
      return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: '3.12.1',
      mode:  'pure' ,
      copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
    });
    });

    var id = 0;
    var postfix = Math.random();

    var uid = function (key) {
      return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
    };

    var aFunction$1 = function (variable) {
      return typeof variable == 'function' ? variable : undefined;
    };

    var getBuiltIn = function (namespace, method) {
      return arguments.length < 2 ? aFunction$1(path[namespace]) || aFunction$1(global_1[namespace])
        : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
    };

    var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

    var process$1 = global_1.process;
    var versions = process$1 && process$1.versions;
    var v8 = versions && versions.v8;
    var match, version;

    if (v8) {
      match = v8.split('.');
      version = match[0] < 4 ? 1 : match[0] + match[1];
    } else if (engineUserAgent) {
      match = engineUserAgent.match(/Edge\/(\d+)/);
      if (!match || match[1] >= 74) {
        match = engineUserAgent.match(/Chrome\/(\d+)/);
        if (match) version = match[1];
      }
    }

    var engineV8Version = version && +version;

    /* eslint-disable es/no-symbol -- required for testing */



    // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
    var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
      return !String(Symbol()) ||
        // Chrome 38 Symbol has incorrect toString conversion
        // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
        !Symbol.sham && engineV8Version && engineV8Version < 41;
    });

    /* eslint-disable es/no-symbol -- required for testing */


    var useSymbolAsUid = nativeSymbol
      && !Symbol.sham
      && typeof Symbol.iterator == 'symbol';

    var WellKnownSymbolsStore = shared('wks');
    var Symbol$1 = global_1.Symbol;
    var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

    var wellKnownSymbol = function (name) {
      if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
        if (nativeSymbol && has(Symbol$1, name)) {
          WellKnownSymbolsStore[name] = Symbol$1[name];
        } else {
          WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
        }
      } return WellKnownSymbolsStore[name];
    };

    var SPECIES = wellKnownSymbol('species');

    // `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate
    var arraySpeciesCreate = function (originalArray, length) {
      var C;
      if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
        else if (isObject(C)) {
          C = C[SPECIES];
          if (C === null) C = undefined;
        }
      } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
    };

    var SPECIES$1 = wellKnownSymbol('species');

    var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
      // We can't use this feature detection in V8 since it causes
      // deoptimization and serious performance degradation
      // https://github.com/zloirock/core-js/issues/677
      return engineV8Version >= 51 || !fails(function () {
        var array = [];
        var constructor = array.constructor = {};
        constructor[SPECIES$1] = function () {
          return { foo: 1 };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
      });
    };

    var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/679
    var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
      var array = [];
      array[IS_CONCAT_SPREADABLE] = false;
      return array.concat()[0] !== array;
    });

    var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

    var isConcatSpreadable = function (O) {
      if (!isObject(O)) return false;
      var spreadable = O[IS_CONCAT_SPREADABLE];
      return spreadable !== undefined ? !!spreadable : isArray(O);
    };

    var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

    // `Array.prototype.concat` method
    // https://tc39.es/ecma262/#sec-array.prototype.concat
    // with adding support of @@isConcatSpreadable and @@species
    _export({ target: 'Array', proto: true, forced: FORCED }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      concat: function concat(arg) {
        var O = toObject(this);
        var A = arraySpeciesCreate(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for (i = -1, length = arguments.length; i < length; i++) {
          E = i === -1 ? O : arguments[i];
          if (isConcatSpreadable(E)) {
            len = toLength(E.length);
            if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
            for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
          } else {
            if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
            createProperty(A, n++, E);
          }
        }
        A.length = n;
        return A;
      }
    });

    var max = Math.max;
    var min$1 = Math.min;

    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
    var toAbsoluteIndex = function (index, length) {
      var integer = toInteger(index);
      return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
    };

    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare -- NaN check
          if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        } else for (;length > index; index++) {
          if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        } return !IS_INCLUDES && -1;
      };
    };

    var arrayIncludes = {
      // `Array.prototype.includes` method
      // https://tc39.es/ecma262/#sec-array.prototype.includes
      includes: createMethod(true),
      // `Array.prototype.indexOf` method
      // https://tc39.es/ecma262/#sec-array.prototype.indexof
      indexOf: createMethod(false)
    };

    var hiddenKeys = {};

    var indexOf = arrayIncludes.indexOf;


    var objectKeysInternal = function (object, names) {
      var O = toIndexedObject(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
      // Don't enum bug & hidden keys
      while (names.length > i) if (has(O, key = names[i++])) {
        ~indexOf(result, key) || result.push(key);
      }
      return result;
    };

    // IE8- don't enum bug keys
    var enumBugKeys = [
      'constructor',
      'hasOwnProperty',
      'isPrototypeOf',
      'propertyIsEnumerable',
      'toLocaleString',
      'toString',
      'valueOf'
    ];

    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    // eslint-disable-next-line es/no-object-keys -- safe
    var objectKeys = Object.keys || function keys(O) {
      return objectKeysInternal(O, enumBugKeys);
    };

    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    // eslint-disable-next-line es/no-object-defineproperties -- safe
    var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
      return O;
    };

    var html = getBuiltIn('document', 'documentElement');

    var keys = shared('keys');

    var sharedKey = function (key) {
      return keys[key] || (keys[key] = uid(key));
    };

    var GT = '>';
    var LT = '<';
    var PROTOTYPE = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO = sharedKey('IE_PROTO');

    var EmptyConstructor = function () { /* empty */ };

    var scriptTag = function (content) {
      return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    };

    // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
    var NullProtoObjectViaActiveX = function (activeXDocument) {
      activeXDocument.write(scriptTag(''));
      activeXDocument.close();
      var temp = activeXDocument.parentWindow.Object;
      activeXDocument = null; // avoid memory leak
      return temp;
    };

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var NullProtoObjectViaIFrame = function () {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = documentCreateElement('iframe');
      var JS = 'java' + SCRIPT + ':';
      var iframeDocument;
      iframe.style.display = 'none';
      html.appendChild(iframe);
      // https://github.com/zloirock/core-js/issues/475
      iframe.src = String(JS);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(scriptTag('document.F=Object'));
      iframeDocument.close();
      return iframeDocument.F;
    };

    // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug
    var activeXDocument;
    var NullProtoObject = function () {
      try {
        /* global ActiveXObject -- old IE */
        activeXDocument = document.domain && new ActiveXObject('htmlfile');
      } catch (error) { /* ignore */ }
      NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
      var length = enumBugKeys.length;
      while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
      return NullProtoObject();
    };

    hiddenKeys[IE_PROTO] = true;

    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    var objectCreate = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = NullProtoObject();
      return Properties === undefined ? result : objectDefineProperties(result, Properties);
    };

    var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    // eslint-disable-next-line es/no-object-getownpropertynames -- safe
    var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return objectKeysInternal(O, hiddenKeys$1);
    };

    var objectGetOwnPropertyNames = {
    	f: f$3
    };

    /* eslint-disable es/no-object-getownpropertynames -- safe */

    var $getOwnPropertyNames = objectGetOwnPropertyNames.f;

    var toString$1 = {}.toString;

    var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
      ? Object.getOwnPropertyNames(window) : [];

    var getWindowNames = function (it) {
      try {
        return $getOwnPropertyNames(it);
      } catch (error) {
        return windowNames.slice();
      }
    };

    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    var f$4 = function getOwnPropertyNames(it) {
      return windowNames && toString$1.call(it) == '[object Window]'
        ? getWindowNames(it)
        : $getOwnPropertyNames(toIndexedObject(it));
    };

    var objectGetOwnPropertyNamesExternal = {
    	f: f$4
    };

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
    var f$5 = Object.getOwnPropertySymbols;

    var objectGetOwnPropertySymbols = {
    	f: f$5
    };

    var redefine = function (target, key, value, options) {
      if (options && options.enumerable) target[key] = value;
      else createNonEnumerableProperty(target, key, value);
    };

    var f$6 = wellKnownSymbol;

    var wellKnownSymbolWrapped = {
    	f: f$6
    };

    var defineProperty = objectDefineProperty.f;

    var defineWellKnownSymbol = function (NAME) {
      var Symbol = path.Symbol || (path.Symbol = {});
      if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
        value: wellKnownSymbolWrapped.f(NAME)
      });
    };

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var test = {};

    test[TO_STRING_TAG] = 'z';

    var toStringTagSupport = String(test) === '[object z]';

    var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function (it, key) {
      try {
        return it[key];
      } catch (error) { /* empty */ }
    };

    // getting tag from ES6+ `Object.prototype.toString`
    var classof = toStringTagSupport ? classofRaw : function (it) {
      var O, tag, result;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
        // @@toStringTag case
        : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
        // builtinTag case
        : CORRECT_ARGUMENTS ? classofRaw(O)
        // ES3 arguments fallback
        : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
    };

    // `Object.prototype.toString` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.tostring
    var objectToString = toStringTagSupport ? {}.toString : function toString() {
      return '[object ' + classof(this) + ']';
    };

    var defineProperty$1 = objectDefineProperty.f;





    var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

    var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
      if (it) {
        var target = STATIC ? it : it.prototype;
        if (!has(target, TO_STRING_TAG$2)) {
          defineProperty$1(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
        }
        if (SET_METHOD && !toStringTagSupport) {
          createNonEnumerableProperty(target, 'toString', objectToString);
        }
      }
    };

    var functionToString = Function.toString;

    // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
    if (typeof sharedStore.inspectSource != 'function') {
      sharedStore.inspectSource = function (it) {
        return functionToString.call(it);
      };
    }

    var inspectSource = sharedStore.inspectSource;

    var WeakMap = global_1.WeakMap;

    var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

    var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
    var WeakMap$1 = global_1.WeakMap;
    var set, get, has$1;

    var enforce = function (it) {
      return has$1(it) ? get(it) : set(it, {});
    };

    var getterFor = function (TYPE) {
      return function (it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) {
          throw TypeError('Incompatible receiver, ' + TYPE + ' required');
        } return state;
      };
    };

    if (nativeWeakMap || sharedStore.state) {
      var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
      var wmget = store$1.get;
      var wmhas = store$1.has;
      var wmset = store$1.set;
      set = function (it, metadata) {
        if (wmhas.call(store$1, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        wmset.call(store$1, it, metadata);
        return metadata;
      };
      get = function (it) {
        return wmget.call(store$1, it) || {};
      };
      has$1 = function (it) {
        return wmhas.call(store$1, it);
      };
    } else {
      var STATE = sharedKey('state');
      hiddenKeys[STATE] = true;
      set = function (it, metadata) {
        if (has(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
      };
      get = function (it) {
        return has(it, STATE) ? it[STATE] : {};
      };
      has$1 = function (it) {
        return has(it, STATE);
      };
    }

    var internalState = {
      set: set,
      get: get,
      has: has$1,
      enforce: enforce,
      getterFor: getterFor
    };

    var push = [].push;

    // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
    var createMethod$1 = function (TYPE) {
      var IS_MAP = TYPE == 1;
      var IS_FILTER = TYPE == 2;
      var IS_SOME = TYPE == 3;
      var IS_EVERY = TYPE == 4;
      var IS_FIND_INDEX = TYPE == 6;
      var IS_FILTER_OUT = TYPE == 7;
      var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
      return function ($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self = indexedObject(O);
        var boundFunction = functionBindContext(callbackfn, that, 3);
        var length = toLength(self.length);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
        var value, result;
        for (;length > index; index++) if (NO_HOLES || index in self) {
          value = self[index];
          result = boundFunction(value, index, O);
          if (TYPE) {
            if (IS_MAP) target[index] = result; // map
            else if (result) switch (TYPE) {
              case 3: return true;              // some
              case 5: return value;             // find
              case 6: return index;             // findIndex
              case 2: push.call(target, value); // filter
            } else switch (TYPE) {
              case 4: return false;             // every
              case 7: push.call(target, value); // filterOut
            }
          }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
      };
    };

    var arrayIteration = {
      // `Array.prototype.forEach` method
      // https://tc39.es/ecma262/#sec-array.prototype.foreach
      forEach: createMethod$1(0),
      // `Array.prototype.map` method
      // https://tc39.es/ecma262/#sec-array.prototype.map
      map: createMethod$1(1),
      // `Array.prototype.filter` method
      // https://tc39.es/ecma262/#sec-array.prototype.filter
      filter: createMethod$1(2),
      // `Array.prototype.some` method
      // https://tc39.es/ecma262/#sec-array.prototype.some
      some: createMethod$1(3),
      // `Array.prototype.every` method
      // https://tc39.es/ecma262/#sec-array.prototype.every
      every: createMethod$1(4),
      // `Array.prototype.find` method
      // https://tc39.es/ecma262/#sec-array.prototype.find
      find: createMethod$1(5),
      // `Array.prototype.findIndex` method
      // https://tc39.es/ecma262/#sec-array.prototype.findIndex
      findIndex: createMethod$1(6),
      // `Array.prototype.filterOut` method
      // https://github.com/tc39/proposal-array-filtering
      filterOut: createMethod$1(7)
    };

    var $forEach = arrayIteration.forEach;

    var HIDDEN = sharedKey('hidden');
    var SYMBOL = 'Symbol';
    var PROTOTYPE$1 = 'prototype';
    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
    var setInternalState = internalState.set;
    var getInternalState = internalState.getterFor(SYMBOL);
    var ObjectPrototype = Object[PROTOTYPE$1];
    var $Symbol = global_1.Symbol;
    var $stringify = getBuiltIn('JSON', 'stringify');
    var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var nativeDefineProperty = objectDefineProperty.f;
    var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
    var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
    var AllSymbols = shared('symbols');
    var ObjectPrototypeSymbols = shared('op-symbols');
    var StringToSymbolRegistry = shared('string-to-symbol-registry');
    var SymbolToStringRegistry = shared('symbol-to-string-registry');
    var WellKnownSymbolsStore$1 = shared('wks');
    var QObject = global_1.QObject;
    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
    var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
    var setSymbolDescriptor = descriptors && fails(function () {
      return objectCreate(nativeDefineProperty({}, 'a', {
        get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
      })).a != 7;
    }) ? function (O, P, Attributes) {
      var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
      if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
      nativeDefineProperty(O, P, Attributes);
      if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
        nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
      }
    } : nativeDefineProperty;

    var wrap = function (tag, description) {
      var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
      setInternalState(symbol, {
        type: SYMBOL,
        tag: tag,
        description: description
      });
      if (!descriptors) symbol.description = description;
      return symbol;
    };

    var isSymbol = useSymbolAsUid ? function (it) {
      return typeof it == 'symbol';
    } : function (it) {
      return Object(it) instanceof $Symbol;
    };

    var $defineProperty$1 = function defineProperty(O, P, Attributes) {
      if (O === ObjectPrototype) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
      anObject(O);
      var key = toPrimitive(P, true);
      anObject(Attributes);
      if (has(AllSymbols, key)) {
        if (!Attributes.enumerable) {
          if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
          O[HIDDEN][key] = true;
        } else {
          if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
          Attributes = objectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
        } return setSymbolDescriptor(O, key, Attributes);
      } return nativeDefineProperty(O, key, Attributes);
    };

    var $defineProperties = function defineProperties(O, Properties) {
      anObject(O);
      var properties = toIndexedObject(Properties);
      var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
      $forEach(keys, function (key) {
        if (!descriptors || $propertyIsEnumerable$1.call(properties, key)) $defineProperty$1(O, key, properties[key]);
      });
      return O;
    };

    var $create = function create(O, Properties) {
      return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
    };

    var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
      var P = toPrimitive(V, true);
      var enumerable = nativePropertyIsEnumerable.call(this, P);
      if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
      return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
    };

    var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(O, P) {
      var it = toIndexedObject(O);
      var key = toPrimitive(P, true);
      if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
      var descriptor = nativeGetOwnPropertyDescriptor(it, key);
      if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
        descriptor.enumerable = true;
      }
      return descriptor;
    };

    var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
      var names = nativeGetOwnPropertyNames(toIndexedObject(O));
      var result = [];
      $forEach(names, function (key) {
        if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
      });
      return result;
    };

    var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
      var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
      var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
      var result = [];
      $forEach(names, function (key) {
        if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
          result.push(AllSymbols[key]);
        }
      });
      return result;
    };

    // `Symbol` constructor
    // https://tc39.es/ecma262/#sec-symbol-constructor
    if (!nativeSymbol) {
      $Symbol = function Symbol() {
        if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
        var tag = uid(description);
        var setter = function (value) {
          if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
          if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
          setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
        };
        if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
        return wrap(tag, description);
      };

      redefine($Symbol[PROTOTYPE$1], 'toString', function toString() {
        return getInternalState(this).tag;
      });

      redefine($Symbol, 'withoutSetter', function (description) {
        return wrap(uid(description), description);
      });

      objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
      objectDefineProperty.f = $defineProperty$1;
      objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$1;
      objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1;
      objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

      wellKnownSymbolWrapped.f = function (name) {
        return wrap(wellKnownSymbol(name), name);
      };

      if (descriptors) {
        // https://github.com/tc39/proposal-Symbol-description
        nativeDefineProperty($Symbol[PROTOTYPE$1], 'description', {
          configurable: true,
          get: function description() {
            return getInternalState(this).description;
          }
        });
      }
    }

    _export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, {
      Symbol: $Symbol
    });

    $forEach(objectKeys(WellKnownSymbolsStore$1), function (name) {
      defineWellKnownSymbol(name);
    });

    _export({ target: SYMBOL, stat: true, forced: !nativeSymbol }, {
      // `Symbol.for` method
      // https://tc39.es/ecma262/#sec-symbol.for
      'for': function (key) {
        var string = String(key);
        if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
        var symbol = $Symbol(string);
        StringToSymbolRegistry[string] = symbol;
        SymbolToStringRegistry[symbol] = string;
        return symbol;
      },
      // `Symbol.keyFor` method
      // https://tc39.es/ecma262/#sec-symbol.keyfor
      keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
        if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
      },
      useSetter: function () { USE_SETTER = true; },
      useSimple: function () { USE_SETTER = false; }
    });

    _export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
      // `Object.create` method
      // https://tc39.es/ecma262/#sec-object.create
      create: $create,
      // `Object.defineProperty` method
      // https://tc39.es/ecma262/#sec-object.defineproperty
      defineProperty: $defineProperty$1,
      // `Object.defineProperties` method
      // https://tc39.es/ecma262/#sec-object.defineproperties
      defineProperties: $defineProperties,
      // `Object.getOwnPropertyDescriptor` method
      // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
      getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1
    });

    _export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
      // `Object.getOwnPropertyNames` method
      // https://tc39.es/ecma262/#sec-object.getownpropertynames
      getOwnPropertyNames: $getOwnPropertyNames$1,
      // `Object.getOwnPropertySymbols` method
      // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
      getOwnPropertySymbols: $getOwnPropertySymbols
    });

    // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
    // https://bugs.chromium.org/p/v8/issues/detail?id=3443
    _export({ target: 'Object', stat: true, forced: fails(function () { objectGetOwnPropertySymbols.f(1); }) }, {
      getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return objectGetOwnPropertySymbols.f(toObject(it));
      }
    });

    // `JSON.stringify` method behavior with symbols
    // https://tc39.es/ecma262/#sec-json.stringify
    if ($stringify) {
      var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
        var symbol = $Symbol();
        // MS Edge converts symbol values to JSON as {}
        return $stringify([symbol]) != '[null]'
          // WebKit converts symbol values to JSON as null
          || $stringify({ a: symbol }) != '{}'
          // V8 throws on boxed symbols
          || $stringify(Object(symbol)) != '{}';
      });

      _export({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        stringify: function stringify(it, replacer, space) {
          var args = [it];
          var index = 1;
          var $replacer;
          while (arguments.length > index) args.push(arguments[index++]);
          $replacer = replacer;
          if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
          if (!isArray(replacer)) replacer = function (key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return $stringify.apply(null, args);
        }
      });
    }

    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) {
      createNonEnumerableProperty($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
    }
    // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
    setToStringTag($Symbol, SYMBOL);

    hiddenKeys[HIDDEN] = true;

    // `Symbol.asyncIterator` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.asynciterator
    defineWellKnownSymbol('asyncIterator');

    // `Symbol.hasInstance` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.hasinstance
    defineWellKnownSymbol('hasInstance');

    // `Symbol.isConcatSpreadable` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
    defineWellKnownSymbol('isConcatSpreadable');

    // `Symbol.iterator` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.iterator
    defineWellKnownSymbol('iterator');

    // `Symbol.match` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.match
    defineWellKnownSymbol('match');

    // `Symbol.matchAll` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.matchall
    defineWellKnownSymbol('matchAll');

    // `Symbol.replace` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.replace
    defineWellKnownSymbol('replace');

    // `Symbol.search` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.search
    defineWellKnownSymbol('search');

    // `Symbol.species` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.species
    defineWellKnownSymbol('species');

    // `Symbol.split` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.split
    defineWellKnownSymbol('split');

    // `Symbol.toPrimitive` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.toprimitive
    defineWellKnownSymbol('toPrimitive');

    // `Symbol.toStringTag` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.tostringtag
    defineWellKnownSymbol('toStringTag');

    // `Symbol.unscopables` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.unscopables
    defineWellKnownSymbol('unscopables');

    // JSON[@@toStringTag] property
    // https://tc39.es/ecma262/#sec-json-@@tostringtag
    setToStringTag(global_1.JSON, 'JSON', true);

    var symbol = path.Symbol;

    // `Symbol.asyncDispose` well-known symbol
    // https://github.com/tc39/proposal-using-statement
    defineWellKnownSymbol('asyncDispose');

    // `Symbol.dispose` well-known symbol
    // https://github.com/tc39/proposal-using-statement
    defineWellKnownSymbol('dispose');

    // `Symbol.matcher` well-known symbol
    // https://github.com/tc39/proposal-pattern-matching
    defineWellKnownSymbol('matcher');

    // `Symbol.metadata` well-known symbol
    // https://github.com/tc39/proposal-decorators
    defineWellKnownSymbol('metadata');

    // `Symbol.observable` well-known symbol
    // https://github.com/tc39/proposal-observable
    defineWellKnownSymbol('observable');

    // TODO: remove from `core-js@4`


    // `Symbol.patternMatch` well-known symbol
    // https://github.com/tc39/proposal-pattern-matching
    defineWellKnownSymbol('patternMatch');

    // TODO: remove from `core-js@4`


    defineWellKnownSymbol('replaceAll');

    // TODO: Remove from `core-js@4`

    // TODO: Remove from `core-js@4`


    var symbol$1 = symbol;

    var symbol$2 = symbol$1;

    // `String.prototype.{ codePointAt, at }` methods implementation
    var createMethod$2 = function (CONVERT_TO_STRING) {
      return function ($this, pos) {
        var S = String(requireObjectCoercible($this));
        var position = toInteger(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size
          || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
            ? CONVERT_TO_STRING ? S.charAt(position) : first
            : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
      };
    };

    var stringMultibyte = {
      // `String.prototype.codePointAt` method
      // https://tc39.es/ecma262/#sec-string.prototype.codepointat
      codeAt: createMethod$2(false),
      // `String.prototype.at` method
      // https://github.com/mathiasbynens/String.prototype.at
      charAt: createMethod$2(true)
    };

    var correctPrototypeGetter = !fails(function () {
      function F() { /* empty */ }
      F.prototype.constructor = null;
      // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
      return Object.getPrototypeOf(new F()) !== F.prototype;
    });

    var IE_PROTO$1 = sharedKey('IE_PROTO');
    var ObjectPrototype$1 = Object.prototype;

    // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof
    // eslint-disable-next-line es/no-object-getprototypeof -- safe
    var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      } return O instanceof Object ? ObjectPrototype$1 : null;
    };

    var ITERATOR = wellKnownSymbol('iterator');
    var BUGGY_SAFARI_ITERATORS = false;

    var returnThis = function () { return this; };

    // `%IteratorPrototype%` object
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

    /* eslint-disable es/no-array-prototype-keys -- safe */
    if ([].keys) {
      arrayIterator = [].keys();
      // Safari 8 has buggy iterators w/o `next`
      if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
      else {
        PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
      }
    }

    var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
      var test = {};
      // FF44- legacy iterators case
      return IteratorPrototype[ITERATOR].call(test) !== test;
    });

    if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    if (( NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
      createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
    }

    var iteratorsCore = {
      IteratorPrototype: IteratorPrototype,
      BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
    };

    var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

    var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
      var TO_STRING_TAG = NAME + ' Iterator';
      IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
      setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
      return IteratorConstructor;
    };

    var aPossiblePrototype = function (it) {
      if (!isObject(it) && it !== null) {
        throw TypeError("Can't set " + String(it) + ' as a prototype');
      } return it;
    };

    /* eslint-disable no-proto -- safe */



    // `Object.setPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    // eslint-disable-next-line es/no-object-setprototypeof -- safe
    var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
      var CORRECT_SETTER = false;
      var test = {};
      var setter;
      try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
        setter.call(test, []);
        CORRECT_SETTER = test instanceof Array;
      } catch (error) { /* empty */ }
      return function setPrototypeOf(O, proto) {
        anObject(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter.call(O, proto);
        else O.__proto__ = proto;
        return O;
      };
    }() : undefined);

    var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR$1 = wellKnownSymbol('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';

    var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
      createIteratorConstructor(IteratorConstructor, NAME, next);

      var getIterationMethod = function (KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch (KIND) {
          case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
          case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
          case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
        } return function () { return new IteratorConstructor(this); };
      };

      var TO_STRING_TAG = NAME + ' Iterator';
      var INCORRECT_VALUES_NAME = false;
      var IterablePrototype = Iterable.prototype;
      var nativeIterator = IterablePrototype[ITERATOR$1]
        || IterablePrototype['@@iterator']
        || DEFAULT && IterablePrototype[DEFAULT];
      var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
      var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
      var CurrentIteratorPrototype, methods, KEY;

      // fix native
      if (anyNativeIterator) {
        CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
          // Set @@toStringTag to native iterators
          setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
        }
      }

      // fix Array#{values, @@iterator}.name in V8 / FF
      if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() { return nativeIterator.call(this); };
      }

      // define iterator
      if (( FORCED) && IterablePrototype[ITERATOR$1] !== defaultIterator) {
        createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
      }

      // export additional methods
      if (DEFAULT) {
        methods = {
          values: getIterationMethod(VALUES),
          keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
          entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) for (KEY in methods) {
          if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
            redefine(IterablePrototype, KEY, methods[KEY]);
          }
        } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
      }

      return methods;
    };

    var charAt = stringMultibyte.charAt;



    var STRING_ITERATOR = 'String Iterator';
    var setInternalState$1 = internalState.set;
    var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);

    // `String.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
    defineIterator(String, 'String', function (iterated) {
      setInternalState$1(this, {
        type: STRING_ITERATOR,
        string: String(iterated),
        index: 0
      });
    // `%StringIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
      var state = getInternalState$1(this);
      var string = state.string;
      var index = state.index;
      var point;
      if (index >= string.length) return { value: undefined, done: true };
      point = charAt(string, index);
      state.index += point.length;
      return { value: point, done: false };
    });

    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState$2 = internalState.set;
    var getInternalState$2 = internalState.getterFor(ARRAY_ITERATOR);

    // `Array.prototype.entries` method
    // https://tc39.es/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.es/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.es/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.es/ecma262/#sec-createarrayiterator
    var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
      setInternalState$2(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated), // target
        index: 0,                          // next index
        kind: kind                         // kind
      });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
    }, function () {
      var state = getInternalState$2(this);
      var target = state.target;
      var kind = state.kind;
      var index = state.index++;
      if (!target || index >= target.length) {
        state.target = undefined;
        return { value: undefined, done: true };
      }
      if (kind == 'keys') return { value: index, done: false };
      if (kind == 'values') return { value: target[index], done: false };
      return { value: [index, target[index]], done: false };
    }, 'values');

    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };

    var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');

    for (var COLLECTION_NAME in domIterables) {
      var Collection = global_1[COLLECTION_NAME];
      var CollectionPrototype = Collection && Collection.prototype;
      if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG$3) {
        createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
      }
    }

    var iterator = wellKnownSymbolWrapped.f('iterator');

    var iterator$1 = iterator;

    var iterator$2 = iterator$1;

    var _typeof_1 = createCommonjsModule(function (module) {
    function _typeof(obj) {
      "@babel/helpers - typeof";

      if (typeof symbol$2 === "function" && typeof iterator$2 === "symbol") {
        module.exports = _typeof = function _typeof(obj) {
          return typeof obj;
        };

        module.exports["default"] = module.exports, module.exports.__esModule = true;
      } else {
        module.exports = _typeof = function _typeof(obj) {
          return obj && typeof symbol$2 === "function" && obj.constructor === symbol$2 && obj !== symbol$2.prototype ? "symbol" : typeof obj;
        };

        module.exports["default"] = module.exports, module.exports.__esModule = true;
      }

      return _typeof(obj);
    }

    module.exports = _typeof;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    });

    var _typeof = unwrapExports(_typeof_1);

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    var _listCacheClear = listCacheClear;

    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

    var max$1 = Math.max;
    var min$2 = Math.min;
    var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

    // `Array.prototype.splice` method
    // https://tc39.es/ecma262/#sec-array.prototype.splice
    // with adding support of @@species
    _export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
      splice: function splice(start, deleteCount /* , ...items */) {
        var O = toObject(this);
        var len = toLength(O.length);
        var actualStart = toAbsoluteIndex(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) {
          insertCount = actualDeleteCount = 0;
        } else if (argumentsLength === 1) {
          insertCount = 0;
          actualDeleteCount = len - actualStart;
        } else {
          insertCount = argumentsLength - 2;
          actualDeleteCount = min$2(max$1(toInteger(deleteCount), 0), len - actualStart);
        }
        if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER$1) {
          throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
        }
        A = arraySpeciesCreate(O, actualDeleteCount);
        for (k = 0; k < actualDeleteCount; k++) {
          from = actualStart + k;
          if (from in O) createProperty(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
          for (k = actualStart; k < len - actualDeleteCount; k++) {
            from = k + actualDeleteCount;
            to = k + insertCount;
            if (from in O) O[to] = O[from];
            else delete O[to];
          }
          for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
        } else if (insertCount > actualDeleteCount) {
          for (k = len - actualDeleteCount; k > actualStart; k--) {
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else delete O[to];
          }
        }
        for (k = 0; k < insertCount; k++) {
          O[k + actualStart] = arguments[k + 2];
        }
        O.length = len - actualDeleteCount + insertCount;
        return A;
      }
    });

    var entryVirtual = function (CONSTRUCTOR) {
      return path[CONSTRUCTOR + 'Prototype'];
    };

    var splice = entryVirtual('Array').splice;

    var ArrayPrototype = Array.prototype;

    var splice_1 = function (it) {
      var own = it.splice;
      return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.splice) ? splice : own;
    };

    var splice$1 = splice_1;

    var splice$2 = splice$1;

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var eq_1 = eq;

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq_1(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    var _assocIndexOf = assocIndexOf;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype;

    /** Built-in value references. */
    var splice$3 = splice$2(arrayProto);

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
        index = _assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice$3.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    var _listCacheDelete = listCacheDelete;

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
        index = _assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    var _listCacheGet = listCacheGet;

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return _assocIndexOf(this.__data__, key) > -1;
    }
    var _listCacheHas = listCacheHas;

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = _assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    var _listCacheSet = listCacheSet;

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = _listCacheClear;
    ListCache.prototype['delete'] = _listCacheDelete;
    ListCache.prototype.get = _listCacheGet;
    ListCache.prototype.has = _listCacheHas;
    ListCache.prototype.set = _listCacheSet;
    var _ListCache = ListCache;

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new _ListCache();
      this.size = 0;
    }
    var _stackClear = stackClear;

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
        result = data['delete'](key);
      this.size = data.size;
      return result;
    }
    var _stackDelete = stackDelete;

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }
    var _stackGet = stackGet;

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }
    var _stackHas = stackHas;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var _freeGlobal = freeGlobal;

    /** Detect free variable `self`. */
    var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = _freeGlobal || freeSelf || Function('return this')();
    var _root = root;

    /** Built-in value references. */
    var _Symbol2 = _root.Symbol;
    var _Symbol = _Symbol2;

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$1 = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Built-in value references. */
    var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty$1.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    var _getRawTag = getRawTag;

    /** Used for built-in method references. */
    var objectProto$1 = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString$1 = objectProto$1.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString$1(value) {
      return nativeObjectToString$1.call(value);
    }
    var _objectToString = objectToString$1;

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
    }
    var _baseGetTag = baseGetTag;

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject$1(value) {
      var type = _typeof(value);
      return value != null && (type == 'object' || type == 'function');
    }
    var isObject_1 = isObject$1;

    /** `Object#toString` result references. */
    var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject_1(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = _baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    var isFunction_1 = isFunction;

    var keys$1 = entryVirtual('Array').keys;

    var keys$2 = keys$1;

    var ArrayPrototype$1 = Array.prototype;

    var DOMIterables = {
      DOMTokenList: true,
      NodeList: true
    };

    var keys_1 = function (it) {
      var own = it.keys;
      return it === ArrayPrototype$1 || (it instanceof Array && own === ArrayPrototype$1.keys)
        // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables.hasOwnProperty(classof(it)) ? keys$2 : own;
    };

    var keys$3 = keys_1;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = _root['__core-js_shared__'];
    var _coreJsData = coreJsData;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(_coreJsData && keys$3(_coreJsData) && keys$3(_coreJsData).IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    var _isMasked = isMasked;

    /** Used for built-in method references. */
    var funcProto = Function.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + '';
        } catch (e) {}
      }
      return '';
    }
    var _toSource = toSource;

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used for built-in method references. */
    var funcProto$1 = Function.prototype,
      objectProto$2 = Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString$1 = funcProto$1.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject_1(value) || _isMasked(value)) {
        return false;
      }
      var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
      return pattern.test(_toSource(value));
    }
    var _baseIsNative = baseIsNative;

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    var _getValue = getValue;

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = _getValue(object, key);
      return _baseIsNative(value) ? value : undefined;
    }
    var _getNative = getNative;

    /* Built-in method references that are verified to be native. */
    var Map = _getNative(_root, 'Map');
    var _Map = Map;

    /* Built-in method references that are verified to be native. */
    var nativeCreate = _getNative(Object, 'create');
    var _nativeCreate = nativeCreate;

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
      this.size = 0;
    }
    var _hashClear = hashClear;

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    var _hashDelete = hashDelete;

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used for built-in method references. */
    var objectProto$3 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (_nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
    }
    var _hashGet = hashGet;

    /** Used for built-in method references. */
    var objectProto$4 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return _nativeCreate ? data[key] !== undefined : hasOwnProperty$4.call(data, key);
    }
    var _hashHas = hashHas;

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
      return this;
    }
    var _hashSet = hashSet;

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = _hashClear;
    Hash.prototype['delete'] = _hashDelete;
    Hash.prototype.get = _hashGet;
    Hash.prototype.has = _hashHas;
    Hash.prototype.set = _hashSet;
    var _Hash = Hash;

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new _Hash(),
        'map': new (_Map || _ListCache)(),
        'string': new _Hash()
      };
    }
    var _mapCacheClear = mapCacheClear;

    var $map = arrayIteration.map;


    var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');

    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    // with adding support of @@species
    _export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
      map: function map(callbackfn /* , thisArg */) {
        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    var map = entryVirtual('Array').map;

    var ArrayPrototype$2 = Array.prototype;

    var map_1 = function (it) {
      var own = it.map;
      return it === ArrayPrototype$2 || (it instanceof Array && own === ArrayPrototype$2.map) ? map : own;
    };

    var map$1 = map_1;

    var map$2 = map$1;

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = _typeof(value);
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    var _isKeyable = isKeyable;

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : map$2(data);
    }
    var _getMapData = getMapData;

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = _getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    var _mapCacheDelete = mapCacheDelete;

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return _getMapData(this, key).get(key);
    }
    var _mapCacheGet = mapCacheGet;

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return _getMapData(this, key).has(key);
    }
    var _mapCacheHas = mapCacheHas;

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = _getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    var _mapCacheSet = mapCacheSet;

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = _mapCacheClear;
    MapCache.prototype['delete'] = _mapCacheDelete;
    MapCache.prototype.get = _mapCacheGet;
    MapCache.prototype.has = _mapCacheHas;
    MapCache.prototype.set = _mapCacheSet;
    var _MapCache = MapCache;

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof _ListCache) {
        var pairs = data.__data__;
        if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new _MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    var _stackSet = stackSet;

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new _ListCache(entries);
      this.size = data.size;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = _stackClear;
    Stack.prototype['delete'] = _stackDelete;
    Stack.prototype.get = _stackGet;
    Stack.prototype.has = _stackHas;
    Stack.prototype.set = _stackSet;
    var _Stack = Stack;

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED$2);
      return this;
    }
    var _setCacheAdd = setCacheAdd;

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    var _setCacheHas = setCacheHas;

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
        length = values == null ? 0 : values.length;
      this.__data__ = new _MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
    SetCache.prototype.has = _setCacheHas;
    var _SetCache = SetCache;

    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    var _arraySome = arraySome;

    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    var _cacheHas = cacheHas;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new _SetCache() : undefined;
      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!_arraySome(other, function (othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }
    var _equalArrays = equalArrays;

    /** Built-in value references. */
    var Uint8Array = _root.Uint8Array;
    var _Uint8Array = Uint8Array;

    var arrayMethodIsStrict = function (METHOD_NAME, argument) {
      var method = [][METHOD_NAME];
      return !!method && fails(function () {
        // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
        method.call(null, argument || function () { throw 1; }, 1);
      });
    };

    var $forEach$1 = arrayIteration.forEach;


    var STRICT_METHOD = arrayMethodIsStrict('forEach');

    // `Array.prototype.forEach` method implementation
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
      return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    } : [].forEach;

    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    _export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
      forEach: arrayForEach
    });

    var forEach = entryVirtual('Array').forEach;

    var forEach$1 = forEach;

    var ArrayPrototype$3 = Array.prototype;

    var DOMIterables$1 = {
      DOMTokenList: true,
      NodeList: true
    };

    var forEach_1 = function (it) {
      var own = it.forEach;
      return it === ArrayPrototype$3 || (it instanceof Array && own === ArrayPrototype$3.forEach)
        // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$1.hasOwnProperty(classof(it)) ? forEach$1 : own;
    };

    var forEach$2 = forEach_1;

    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      forEach$2(map).call(map, function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    var _mapToArray = mapToArray;

    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      forEach$2(set).call(set, function (value) {
        result[++index] = value;
      });
      return result;
    }
    var _setToArray = setToArray;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG$1 = 1,
      COMPARE_UNORDERED_FLAG$1 = 2;

    /** `Object#toString` result references. */
    var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = _Symbol ? _Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq_1(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == other + '';
        case mapTag:
          var convert = _mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
          convert || (convert = _setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG$1;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    var _equalByTag = equalByTag;

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    var _arrayPush = arrayPush;

    // `Array.isArray` method
    // https://tc39.es/ecma262/#sec-array.isarray
    _export({ target: 'Array', stat: true }, {
      isArray: isArray
    });

    var isArray$1 = path.Array.isArray;

    var isArray$2 = isArray$1;

    var isArray$3 = isArray$2;

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray$4 = isArray$3;
    var isArray_1 = isArray$4;

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
    }
    var _baseGetAllKeys = baseGetAllKeys;

    var getOwnPropertySymbols = path.Object.getOwnPropertySymbols;

    var getOwnPropertySymbols$1 = getOwnPropertySymbols;

    var getOwnPropertySymbols$2 = getOwnPropertySymbols$1;

    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    var _arrayFilter = arrayFilter;

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }
    var stubArray_1 = stubArray;

    /** Used for built-in method references. */
    var objectProto$5 = Object.prototype;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeGetSymbols = getOwnPropertySymbols$2;

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return _arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    var _getSymbols = getSymbols;

    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    var _baseTimes = baseTimes;

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && _typeof(value) == 'object';
    }
    var isObjectLike_1 = isObjectLike;

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]';

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
    }
    var _baseIsArguments = baseIsArguments;

    /** Used for built-in method references. */
    var objectProto$6 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

    /** Built-in value references. */
    var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = _baseIsArguments(function () {
      return arguments;
    }()) ? _baseIsArguments : function (value) {
      return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
    };
    var isArguments_1 = isArguments;

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }
    var stubFalse_1 = stubFalse;

    var isBuffer_1 = createCommonjsModule(function (module, exports) {
      /** Detect free variable `exports`. */
      var freeExports =  exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Built-in value references. */
      var Buffer = moduleExports ? _root.Buffer : undefined;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse_1;
      module.exports = isBuffer;
    });

    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER$2 = 9007199254740991;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = _typeof(value);
      length = length == null ? MAX_SAFE_INTEGER$2 : length;
      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    var _isIndex = isIndex;

    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER$3 = 9007199254740991;

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
    }
    var isLength_1 = isLength;

    /** `Object#toString` result references. */
    var argsTag$1 = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag$1 = '[object Boolean]',
      dateTag$1 = '[object Date]',
      errorTag$1 = '[object Error]',
      funcTag$1 = '[object Function]',
      mapTag$1 = '[object Map]',
      numberTag$1 = '[object Number]',
      objectTag = '[object Object]',
      regexpTag$1 = '[object RegExp]',
      setTag$1 = '[object Set]',
      stringTag$1 = '[object String]',
      weakMapTag = '[object WeakMap]';
    var arrayBufferTag$1 = '[object ArrayBuffer]',
      dataViewTag$1 = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = false;

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
    }
    var _baseIsTypedArray = baseIsTypedArray;

    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    var _baseUnary = baseUnary;

    var _nodeUtil = createCommonjsModule(function (module, exports) {
      /** Detect free variable `exports`. */
      var freeExports =  exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Detect free variable `process` from Node.js. */
      var freeProcess = moduleExports && _freeGlobal.process;

      /** Used to access faster Node.js helpers. */
      var nodeUtil = function () {
        try {
          // Use `util.types` for Node.js 10+.
          var types = freeModule && freeModule.require && freeModule.require('util').types;
          if (types) {
            return types;
          }

          // Legacy `process.binding('util')` for Node.js < 10.
          return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
      }();
      module.exports = nodeUtil;
    });

    /* Node.js helper references. */
    var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
    var isTypedArray_1 = isTypedArray;

    /** Used for built-in method references. */
    var objectProto$7 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray_1(value),
        isArg = !isArr && isArguments_1(value),
        isBuff = !isArr && !isArg && isBuffer_1(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? _baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
        // Skip index properties.
        _isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    var _arrayLikeKeys = arrayLikeKeys;

    /** Used for built-in method references. */
    var objectProto$8 = Object.prototype;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
      return value === proto;
    }
    var _isPrototype = isPrototype;

    var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    _export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
      keys: function keys(it) {
        return objectKeys(toObject(it));
      }
    });

    var keys$4 = path.Object.keys;

    var keys$5 = keys$4;

    var keys$6 = keys$5;

    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    var _overArg = overArg;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeKeys = _overArg(keys$6, Object);
    var _nativeKeys = nativeKeys;

    /** Used for built-in method references. */
    var objectProto$9 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!_isPrototype(object)) {
        return _nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }
    var _baseKeys = baseKeys;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength_1(value.length) && !isFunction_1(value);
    }
    var isArrayLike_1 = isArrayLike;

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys$7(object) {
      return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
    }
    var keys_1$1 = keys$7;

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return _baseGetAllKeys(object, keys_1$1, _getSymbols);
    }
    var _getAllKeys = getAllKeys;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG$2 = 1;

    /** Used for built-in method references. */
    var objectProto$a = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
        objProps = _getAllKeys(object),
        objLength = objProps.length,
        othProps = _getAllKeys(other),
        othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }
    var _equalObjects = equalObjects;

    /* Built-in method references that are verified to be native. */
    var DataView = _getNative(_root, 'DataView');
    var _DataView = DataView;

    /* Built-in method references that are verified to be native. */
    var Promise$1 = _getNative(_root, 'Promise');
    var _Promise = Promise$1;

    /* Built-in method references that are verified to be native. */
    var Set = _getNative(_root, 'Set');
    var _Set = Set;

    /* Built-in method references that are verified to be native. */
    var WeakMap$2 = _getNative(_root, 'WeakMap');
    var _WeakMap = WeakMap$2;

    /** `Object#toString` result references. */
    var mapTag$2 = '[object Map]',
      objectTag$1 = '[object Object]',
      promiseTag = '[object Promise]',
      setTag$2 = '[object Set]',
      weakMapTag$1 = '[object WeakMap]';
    var dataViewTag$2 = '[object DataView]';

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = _toSource(_DataView),
      mapCtorString = _toSource(_Map),
      promiseCtorString = _toSource(_Promise),
      setCtorString = _toSource(_Set),
      weakMapCtorString = _toSource(_WeakMap);

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = _baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$2 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$2 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
      getTag = function getTag(value) {
        var result = _baseGetTag(value),
          Ctor = result == objectTag$1 ? value.constructor : undefined,
          ctorString = Ctor ? _toSource(Ctor) : '';
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag$2;
            case mapCtorString:
              return mapTag$2;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag$2;
            case weakMapCtorString:
              return weakMapTag$1;
          }
        }
        return result;
      };
    }
    var _getTag = getTag;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG$3 = 1;

    /** `Object#toString` result references. */
    var argsTag$2 = '[object Arguments]',
      arrayTag$1 = '[object Array]',
      objectTag$2 = '[object Object]';

    /** Used for built-in method references. */
    var objectProto$b = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray_1(object),
        othIsArr = isArray_1(other),
        objTag = objIsArr ? arrayTag$1 : _getTag(object),
        othTag = othIsArr ? arrayTag$1 : _getTag(other);
      objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
      othTag = othTag == argsTag$2 ? objectTag$2 : othTag;
      var objIsObj = objTag == objectTag$2,
        othIsObj = othTag == objectTag$2,
        isSameTag = objTag == othTag;
      if (isSameTag && isBuffer_1(object)) {
        if (!isBuffer_1(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new _Stack());
        return objIsArr || isTypedArray_1(object) ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack) : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
        var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new _Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new _Stack());
      return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    var _baseIsEqualDeep = baseIsEqualDeep;

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike_1(value) && !isObjectLike_1(other)) {
        return value !== value && other !== other;
      }
      return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    var _baseIsEqual = baseIsEqual;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG$4 = 1,
      COMPARE_UNORDERED_FLAG$2 = 2;

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
        length = index,
        noCustomizer = !customizer;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
          objValue = object[key],
          srcValue = data[1];
        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new _Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    var _baseIsMatch = baseIsMatch;

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject_1(value);
    }
    var _isStrictComparable = isStrictComparable;

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys_1$1(object),
        length = result.length;
      while (length--) {
        var key = result[length],
          value = object[key];
        result[length] = [key, value, _isStrictComparable(value)];
      }
      return result;
    }
    var _getMatchData = getMatchData;

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function (object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
      };
    }
    var _matchesStrictComparable = matchesStrictComparable;

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = _getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function (object) {
        return object === source || _baseIsMatch(object, source, matchData);
      };
    }
    var _baseMatches = baseMatches;

    /** `Object#toString` result references. */
    var symbolTag$1 = '[object Symbol]';

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol$1(value) {
      return _typeof(value) == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1;
    }
    var isSymbol_1 = isSymbol$1;

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray_1(value)) {
        return false;
      }
      var type = _typeof(value);
      if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    var _isKey = isKey;

    /** Error message constants. */
    var FUNC_ERROR_TEXT = 'Expected a function';

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function memoized() {
        var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || _MapCache)();
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = _MapCache;
    var memoize_1 = memoize;

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize_1(func, function (key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });
      var cache = result.cache;
      return result;
    }
    var _memoizeCapped = memoizeCapped;

    /** Used to match property names within property paths. */
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = _memoizeCapped(function (string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
      });
      return result;
    });
    var _stringToPath = stringToPath;

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /** Used to convert symbols to primitives and strings. */
    var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
      symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray_1(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return _arrayMap(value, baseToString) + '';
      }
      if (isSymbol_1(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }
    var _baseToString = baseToString;

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString$2(value) {
      return value == null ? '' : _baseToString(value);
    }
    var toString_1 = toString$2;

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray_1(value)) {
        return value;
      }
      return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
    }
    var _castPath = castPath;

    /** Used as references for various `Number` constants. */
    var INFINITY$1 = 1 / 0;

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol_1(value)) {
        return value;
      }
      var result = value + '';
      return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
    }
    var _toKey = toKey;

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = _castPath(path, object);
      var index = 0,
        length = path.length;
      while (object != null && index < length) {
        object = object[_toKey(path[index++])];
      }
      return index && index == length ? object : undefined;
    }
    var _baseGet = baseGet;

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get$1(object, path, defaultValue) {
      var result = object == null ? undefined : _baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }
    var get_1 = get$1;

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }
    var _baseHasIn = baseHasIn;

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = _castPath(path, object);
      var index = -1,
        length = path.length,
        result = false;
      while (++index < length) {
        var key = _toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength_1(length) && _isIndex(key, length) && (isArray_1(object) || isArguments_1(object));
    }
    var _hasPath = hasPath;

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && _hasPath(object, path, _baseHasIn);
    }
    var hasIn_1 = hasIn;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG$5 = 1,
      COMPARE_UNORDERED_FLAG$3 = 2;

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (_isKey(path) && _isStrictComparable(srcValue)) {
        return _matchesStrictComparable(_toKey(path), srcValue);
      }
      return function (object) {
        var objValue = get_1(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn_1(object, path) : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
      };
    }
    var _baseMatchesProperty = baseMatchesProperty;

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }
    var identity_1 = identity;

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined : object[key];
      };
    }
    var _baseProperty = baseProperty;

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function (object) {
        return _baseGet(object, path);
      };
    }
    var _basePropertyDeep = basePropertyDeep;

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
    }
    var property_1 = property;

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity_1;
      }
      if (_typeof(value) == 'object') {
        return isArray_1(value) ? _baseMatchesProperty(value[0], value[1]) : _baseMatches(value);
      }
      return property_1(value);
    }
    var _baseIteratee = baseIteratee;

    var defineProperty$2 = function () {
      try {
        var func = _getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }();
    var _defineProperty = defineProperty$2;

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && _defineProperty) {
        _defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }
    var _baseAssignValue = baseAssignValue;

    /** Used for built-in method references. */
    var objectProto$c = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$a = objectProto$c.hasOwnProperty;

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty$a.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
        _baseAssignValue(object, key, value);
      }
    }
    var _assignValue = assignValue;

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject_1(object)) {
        return object;
      }
      path = _castPath(path, object);
      var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;
      while (nested != null && ++index < length) {
        var key = _toKey(path[index]),
          newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }
        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject_1(objValue) ? objValue : _isIndex(path[index + 1]) ? [] : {};
          }
        }
        _assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }
    var _baseSet = baseSet;

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
        length = paths.length,
        result = {};
      while (++index < length) {
        var path = paths[index],
          value = _baseGet(object, path);
        if (predicate(value, path)) {
          _baseSet(result, _castPath(path, object), value);
        }
      }
      return result;
    }
    var _basePickBy = basePickBy;

    var FAILS_ON_PRIMITIVES$1 = fails(function () { objectGetPrototypeOf(1); });

    // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof
    _export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1, sham: !correctPrototypeGetter }, {
      getPrototypeOf: function getPrototypeOf(it) {
        return objectGetPrototypeOf(toObject(it));
      }
    });

    var getPrototypeOf = path.Object.getPrototypeOf;

    var getPrototypeOf$1 = getPrototypeOf;

    var getPrototypeOf$2 = getPrototypeOf$1;

    /** Built-in value references. */
    var getPrototype = _overArg(getPrototypeOf$2, Object);
    var _getPrototype = getPrototype;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeGetSymbols$1 = getOwnPropertySymbols$2;

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
      var result = [];
      while (object) {
        _arrayPush(result, _getSymbols(object));
        object = _getPrototype(object);
      }
      return result;
    };
    var _getSymbolsIn = getSymbolsIn;

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    var _nativeKeysIn = nativeKeysIn;

    /** Used for built-in method references. */
    var objectProto$d = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$b = objectProto$d.hasOwnProperty;

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject_1(object)) {
        return _nativeKeysIn(object);
      }
      var isProto = _isPrototype(object),
        result = [];
      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    var _baseKeysIn = baseKeysIn;

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
    }
    var keysIn_1 = keysIn;

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
    }
    var _getAllKeysIn = getAllKeysIn;

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = _arrayMap(_getAllKeysIn(object), function (prop) {
        return [prop];
      });
      predicate = _baseIteratee(predicate);
      return _basePickBy(object, props, function (value, path) {
        return predicate(value, path[0]);
      });
    }
    var pickBy_1 = pickBy;

    /* eslint-disable es/no-array-prototype-indexof -- required for testing */

    var $indexOf = arrayIncludes.indexOf;


    var nativeIndexOf = [].indexOf;

    var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
    var STRICT_METHOD$1 = arrayMethodIsStrict('indexOf');

    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    _export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD$1 }, {
      indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
        return NEGATIVE_ZERO
          // convert -0 to +0
          ? nativeIndexOf.apply(this, arguments) || 0
          : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    var indexOf$1 = entryVirtual('Array').indexOf;

    var ArrayPrototype$4 = Array.prototype;

    var indexOf_1 = function (it) {
      var own = it.indexOf;
      return it === ArrayPrototype$4 || (it instanceof Array && own === ArrayPrototype$4.indexOf) ? indexOf$1 : own;
    };

    var indexOf$2 = indexOf_1;

    var indexOf$3 = indexOf$2;

    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    var _baseFindIndex = baseFindIndex;

    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */
    function baseIsNaN(value) {
      return value !== value;
    }
    var _baseIsNaN = baseIsNaN;

    /**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
    var _strictIndexOf = strictIndexOf;

    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? _strictIndexOf(array, value, fromIndex) : _baseFindIndex(array, _baseIsNaN, fromIndex);
    }
    var _baseIndexOf = baseIndexOf;

    /** `Object#toString` result references. */
    var stringTag$2 = '[object String]';

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || !isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$2;
    }
    var isString_1 = isString;

    // a string of all valid unicode whitespaces
    var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
      '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

    var whitespace = '[' + whitespaces + ']';
    var ltrim = RegExp('^' + whitespace + whitespace + '*');
    var rtrim = RegExp(whitespace + whitespace + '*$');

    // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
    var createMethod$3 = function (TYPE) {
      return function ($this) {
        var string = String(requireObjectCoercible($this));
        if (TYPE & 1) string = string.replace(ltrim, '');
        if (TYPE & 2) string = string.replace(rtrim, '');
        return string;
      };
    };

    var stringTrim = {
      // `String.prototype.{ trimLeft, trimStart }` methods
      // https://tc39.es/ecma262/#sec-string.prototype.trimstart
      start: createMethod$3(1),
      // `String.prototype.{ trimRight, trimEnd }` methods
      // https://tc39.es/ecma262/#sec-string.prototype.trimend
      end: createMethod$3(2),
      // `String.prototype.trim` method
      // https://tc39.es/ecma262/#sec-string.prototype.trim
      trim: createMethod$3(3)
    };

    var trim = stringTrim.trim;


    var $parseInt = global_1.parseInt;
    var hex = /^[+-]?0[Xx]/;
    var FORCED$1 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

    // `parseInt` method
    // https://tc39.es/ecma262/#sec-parseint-string-radix
    var numberParseInt = FORCED$1 ? function parseInt(string, radix) {
      var S = trim(String(string));
      return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
    } : $parseInt;

    // `parseInt` method
    // https://tc39.es/ecma262/#sec-parseint-string-radix
    _export({ global: true, forced: parseInt != numberParseInt }, {
      parseInt: numberParseInt
    });

    var _parseInt = path.parseInt;

    var _parseInt$1 = _parseInt;

    var _parseInt$2 = _parseInt$1;

    var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('slice');

    var SPECIES$2 = wellKnownSymbol('species');
    var nativeSlice = [].slice;
    var max$2 = Math.max;

    // `Array.prototype.slice` method
    // https://tc39.es/ecma262/#sec-array.prototype.slice
    // fallback for not array-like ES3 strings and DOM objects
    _export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
      slice: function slice(start, end) {
        var O = toIndexedObject(this);
        var length = toLength(O.length);
        var k = toAbsoluteIndex(start, length);
        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if (isArray(O)) {
          Constructor = O.constructor;
          // cross-realm fallback
          if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
            Constructor = undefined;
          } else if (isObject(Constructor)) {
            Constructor = Constructor[SPECIES$2];
            if (Constructor === null) Constructor = undefined;
          }
          if (Constructor === Array || Constructor === undefined) {
            return nativeSlice.call(O, k, fin);
          }
        }
        result = new (Constructor === undefined ? Array : Constructor)(max$2(fin - k, 0));
        for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
        result.length = n;
        return result;
      }
    });

    var slice = entryVirtual('Array').slice;

    var ArrayPrototype$5 = Array.prototype;

    var slice_1 = function (it) {
      var own = it.slice;
      return it === ArrayPrototype$5 || (it instanceof Array && own === ArrayPrototype$5.slice) ? slice : own;
    };

    var slice$1 = slice_1;

    var slice$2 = slice$1;

    /** Used to match a single whitespace character. */
    var reWhitespace = /\s/;

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
     * character of `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the index of the last non-whitespace character.
     */
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }
    var _trimmedEndIndex = trimmedEndIndex;

    /** Used to match leading whitespace. */
    var reTrimStart = /^\s+/;

    /**
     * The base implementation of `_.trim`.
     *
     * @private
     * @param {string} string The string to trim.
     * @returns {string} Returns the trimmed string.
     */
    function baseTrim(string) {
      return string ? slice$2(string).call(string, 0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    var _baseTrim = baseTrim;

    /** Used as references for various `Number` constants. */
    var NAN = 0 / 0;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Built-in method references without a dependency on `root`. */
    var freeParseInt = _parseInt$2;

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol_1(value)) {
        return NAN;
      }
      if (isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject_1(other) ? other + '' : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = _baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(slice$2(value).call(value, 2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    var toNumber_1 = toNumber;

    /** Used as references for various `Number` constants. */
    var INFINITY$2 = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber_1(value);
      if (value === INFINITY$2 || value === -INFINITY$2) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }
    var toFinite_1 = toFinite;

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger$1(value) {
      var result = toFinite_1(value),
        remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    var toInteger_1 = toInteger$1;

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      return _arrayMap(props, function (key) {
        return object[key];
      });
    }
    var _baseValues = baseValues;

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : _baseValues(object, keys_1$1(object));
    }
    var values_1 = values;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max;

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike_1(collection) ? collection : values_1(collection);
      fromIndex = fromIndex && !guard ? toInteger_1(fromIndex) : 0;
      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString_1(collection) ? fromIndex <= length && indexOf$3(collection).call(collection, value, fromIndex) > -1 : !!length && _baseIndexOf(collection, value, fromIndex) > -1;
    }
    var includes_1 = includes;

    function isResponseType(response) {
        var _a;
        return Boolean(response.errorMessage || ((_a = response.error) === null || _a === void 0 ? void 0 : _a.message));
    }

    var STATUS_CODES = {
        // CONTINUE: 100,
        // SWITCHING_PROTOCOLS: 101,
        // PROCESSING: 102,
        // EARLY_HINTS: 103,
        OK: 200,
        CREATED: 201,
        ACCEPTED: 202,
        // NON_AUTHORITATIVE_INFORMATION: 203,
        // NO_CONTENT: 204,
        // RESET_CONTENT: 205,
        // PARTIAL_CONTENT: 206,
        // MULTI_STATUS: 207,
        // ALREADY_REPORTED: 208,
        // IM_USED: 226,
        // MULTIPLE_CHOICES: 300,
        MOVED_PERMANENTLY: 301,
        // FOUND: 302,
        // SEE_OTHER: 303,
        // NOT_MODIFIED: 304,
        // USE_PROXY: 305,
        // SWITCH_PROXY: 306,
        // TEMPORARY_REDIRECT: 307,
        // PERMANENT_REDIRECT: 308,
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        // PAYMENT_REQUIRED: 402,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        // METHOD_NOT_ALLOWED: 405,
        NOT_ACCEPTABLE: 406,
        // PROXY_AUTHENTICATION_REQUIRED: 407,
        // REQUEST_TIMEOUT: 408,
        // CONFLICT: 409, // 2FA Triggered
        TWO_FACTOR: 409,
        // GONE: 410,
        // LENGTH_REQUIRED: 411,
        // PRECONDITION_FAILED: 412,
        // PAYLOAD_TOO_LARGE: 413,
        // URI_TOO_LONG: 414,
        // UNSUPPORTED_MEDIA_TYPE: 415,
        // RANGE_NOT_SATISFIABLE: 416,
        // EXPECTATION_FAILED: 417,
        // IM_A_TEAPOT: 418,
        // MISDIRECTED_REQUEST: 421,
        // UNPROCESSABLE_ENTITY: 422,
        // LOCKED: 423,
        // FAILED_DEPENDENCY: 424,
        // TOO_EARLY: 425,
        // UPGRADE_REQUIRED: 426,
        // PRECONDITION_REQUIRED: 428,
        TOO_MANY_REQUESTS: 429,
        // REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
        // UNAVAILABLE_FOR_LEGAL_REASONS: 451,
        INTERNAL_SERVER_ERROR: 500,
        // NOT_IMPLEMENTED: 501,
        BAD_GATEWAY: 502,
        SERVICE_UNAVAILABLE: 503,
        GATEWAY_TIMEOUT: 504,
        // HTTP_VERSION_NOT_SUPPORTED: 505,
        // VARIANT_ALSO_NEGOTIATES: 506,
        // INSUFFICIENT_STORAGE: 507,
        // LOOP_DETECTED: 508,
        // NOT_EXTENDED: 510,
        // NETWORK_AUTHENTICATION_REQUIRED: 511,
    };

    var CONTENT_TYPE_JSON = 'application/json';
    var CONTENT_TYPE_MULTIPART_FORM = 'multipart/form-data';
    var handleErrors = function (_a) {
        var ok = _a[0], response = _a[1], status = _a[2], statusText = _a[3];
        if (!ok) {
            var errorMessage = (isResponseType(response) &&
                ((response.error && response.error.message) || response.errorMessage)) ||
                'An error has occurred';
            var error = new Error(errorMessage);
            error.response = response;
            error.status = status;
            error.statusText = statusText;
            throw error;
        }
        return response;
    };
    var handlePromise = function (response) {
        var contentType = response.headers && response.headers.get('Content-Type');
        if (includes_1(contentType, CONTENT_TYPE_JSON)) {
            return Promise.all([response.ok, response.json(), response.status, response.statusText]);
        }
        return Promise.all([response.ok, response.text(), response.status, response.statusText]);
    };
    // Requires web-nav on the page for proper handling
    // Will fallback to an error if it does not exist
    var handleTwoFactor = function (e, callback) {
        if (e.status === STATUS_CODES.TWO_FACTOR && typeof window !== undefined && window.zolaNav) {
            var twoFactorResponse = e.response;
            window.zolaNav.openTwoFAModal({
                verificationCopy: twoFactorResponse.verification_copy,
                notifiedValue: twoFactorResponse.notified_value,
                verifiedCallback: callback,
            });
        }
        else {
            throw e;
        }
    };

    var LOCAL_STORAGE_SUPPORT = Boolean(typeof window !== 'undefined' && window.localStorage);
    var SESSION_STORAGE_SUPPORT = Boolean(typeof window !== 'undefined' && window.sessionStorage);
    /**
     * set a cookie
     *
     * @param key - cookie key
     * @param value - cookie value
     * @param durationDays - expiration date
     */
    function setCookie(key, value, durationDays) {
        var cookieString = "".concat(key, "=").concat(value);
        if (durationDays) {
            var d = new Date();
            d.setTime(d.getTime() + durationDays * 24 * 3600 * 1000);
            cookieString += "; expires=".concat(d.toUTCString());
        }
        document.cookie = "".concat(cookieString, "; path=/");
    }
    /**
     * get a cookie
     */
    function getCookie(key) {
        var name = "".concat(key, "=");
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i += 1) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    /**
     * delete a cookie
     *
     * @param key - name of cookie
     */
    function deleteCookie(key) {
        setCookie(key, '', -1);
    }
    /**
     * get a value from localStorage
     *
     * @param key - name of property to retrieve
     */
    function getLocalStorage(key) {
        if (LOCAL_STORAGE_SUPPORT) {
            return window.localStorage.getItem(key);
        }
        return getCookie(key);
    }
    /**
     * set a value in localStorage
     *
     * @param key - name of property
     * @param value - value of property
     */
    function setLocalStorage(key, value) {
        if (LOCAL_STORAGE_SUPPORT) {
            window.localStorage.setItem(key, value);
        }
        else {
            setCookie(key, value, 365);
        }
    }
    /**
     * remove a value in localStorage
     *
     * @param key - name of property
     */
    function deleteLocalStorage(key) {
        if (LOCAL_STORAGE_SUPPORT) {
            window.localStorage.removeItem(key);
        }
        else {
            deleteCookie(key);
        }
    }
    /**
     * set a value in sessionStorage
     *
     * @param key - name of property
     * @param value - value of property
     */
    function setSessionStorage(key, value) {
        if (SESSION_STORAGE_SUPPORT) {
            window.sessionStorage.setItem(key, value);
        }
        else {
            setCookie(key, value);
        }
    }
    /**
     * get a value from sessionStorage
     *
     * @param key - name of property to retrieve
     */
    function getSessionStorage(key) {
        if (SESSION_STORAGE_SUPPORT) {
            return window.sessionStorage.getItem(key);
        }
        return getCookie(key);
    }
    /**
     * remove a value in sessionStorage
     *
     * @param key - name of property
     */
    function deleteSessionStorage(key) {
        if (SESSION_STORAGE_SUPPORT) {
            window.sessionStorage.removeItem(key);
        }
        else {
            deleteCookie(key);
        }
    }
    function setAllStorage(key, value) {
        setCookie(key, value);
        setLocalStorage(key, value);
    }
    function getAllStorage(key) {
        var cookieValue = getCookie(key);
        var localStorageValue = getLocalStorage(key);
        if (cookieValue) {
            return cookieValue;
        }
        if (localStorageValue) {
            return localStorageValue;
        }
        return null;
    }
    function deleteAllStorage(key) {
        deleteLocalStorage(key);
        deleteCookie(key);
    }

    var LOG_ROCKET_COOKIE = 'zola-lgrkt';

    var Method = {
        get: 'GET',
        post: 'POST',
        put: 'PUT',
        patch: 'PATCH',
        delete: 'DELETE',
    };
    var CSRF_TOKEN_HEADER = 'x-csrf-token';
    var CSRF_TOKEN_COOKIE = 'CSRF-TOKEN';
    var LOG_ROCKET_HEADER = 'x-record-request-body';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var request = function (url, options) {
        var requestChainFn = function () { return fetch(url, options).then(handlePromise).then(handleErrors); };
        var requestPromise = new Promise(function (resolve, reject) {
            requestChainFn()
                .then(resolve)
                .catch(function (e) {
                try {
                    handleTwoFactor(e, function () { return resolve(requestChainFn()); });
                }
                catch (e2) {
                    reject(e2);
                }
            });
        });
        return requestPromise;
    };
    var get$2 = function (url, options, headers) {
        var _a;
        if (options === void 0) { options = {}; }
        if (headers === void 0) { headers = {}; }
        var finalHeaders = __assign(__assign({ 'Content-Type': CONTENT_TYPE_JSON }, (getCookie(LOG_ROCKET_COOKIE) ? (_a = {}, _a[LOG_ROCKET_HEADER] = 'true', _a) : {})), headers);
        var finalOptions = __assign({ method: Method.get, credentials: 'same-origin', headers: finalHeaders }, options);
        return request(url, finalOptions);
    };
    var post = function (url, body, options, headers) {
        var _a, _b;
        if (options === void 0) { options = {}; }
        if (headers === void 0) { headers = {}; }
        var combinedHeaders = __assign(__assign((_a = { 'Content-Type': body instanceof FormData ? CONTENT_TYPE_MULTIPART_FORM : CONTENT_TYPE_JSON }, _a[CSRF_TOKEN_HEADER] = getCookie(CSRF_TOKEN_COOKIE), _a), (getCookie(LOG_ROCKET_COOKIE) ? (_b = {}, _b[LOG_ROCKET_HEADER] = 'true', _b) : {})), headers);
        var finalHeaders = pickBy_1(combinedHeaders, function (value) { return value !== undefined; });
        var finalBody = finalHeaders['Content-Type'] === CONTENT_TYPE_JSON ? JSON.stringify(body) : body;
        var finalOptions = __assign({ method: Method.post, credentials: 'same-origin', body: finalBody, headers: finalHeaders }, options);
        return request(url, finalOptions);
    };
    var put = function (url, body, options, headers) {
        var _a, _b;
        if (options === void 0) { options = {}; }
        if (headers === void 0) { headers = {}; }
        var finalHeaders = __assign(__assign((_a = { 'Content-Type': CONTENT_TYPE_JSON }, _a[CSRF_TOKEN_HEADER] = getCookie(CSRF_TOKEN_COOKIE), _a), (getCookie(LOG_ROCKET_COOKIE) ? (_b = {}, _b[LOG_ROCKET_HEADER] = 'true', _b) : {})), headers);
        var finalBody = JSON.stringify(body);
        var finalOptions = __assign({ method: Method.put, credentials: 'same-origin', body: finalBody, headers: finalHeaders }, options);
        return request(url, finalOptions);
    };
    var patch = function (url, body, options, headers) {
        var _a, _b;
        if (options === void 0) { options = {}; }
        if (headers === void 0) { headers = {}; }
        var finalHeaders = __assign(__assign((_a = { 'Content-Type': CONTENT_TYPE_JSON }, _a[CSRF_TOKEN_HEADER] = getCookie(CSRF_TOKEN_COOKIE), _a), (getCookie(LOG_ROCKET_COOKIE) ? (_b = {}, _b[LOG_ROCKET_HEADER] = 'true', _b) : {})), headers);
        var finalBody = JSON.stringify(body);
        var finalOptions = __assign({ method: Method.patch, credentials: 'same-origin', body: finalBody, headers: finalHeaders }, options);
        return request(url, finalOptions);
    };
    var deleteMethod = function (url, options, headers) {
        var _a, _b;
        if (options === void 0) { options = {}; }
        if (headers === void 0) { headers = {}; }
        var finalHeaders = __assign(__assign((_a = { 'Content-Type': CONTENT_TYPE_JSON }, _a[CSRF_TOKEN_HEADER] = getCookie(CSRF_TOKEN_COOKIE), _a), (getCookie(LOG_ROCKET_COOKIE) ? (_b = {}, _b[LOG_ROCKET_HEADER] = 'true', _b) : {})), headers);
        var finalOptions = __assign({ method: Method.delete, credentials: 'same-origin', headers: finalHeaders }, options);
        return request(url, finalOptions);
    };
    var ApiService = {
        request: request,
        get: get$2,
        post: post,
        put: put,
        patch: patch,
        delete: deleteMethod,
    };

    function pushToDataLayer(payload) {
        if (window.analytics && window.dataLayer) {
            window.dataLayer.push(payload);
        }
    }
    /**
     *
     */
    function setGTMLoggedIn() {
        pushToDataLayer({
            LoginStatus: 'Logged In',
        });
    }
    /**
     *
     */
    function setGTMLoggedOut() {
        pushToDataLayer({
            LoginStatus: 'Not Logged In',
        });
    }

    /**
     * A Business Unit Component (Feature on the BE) represents a component within a Business Unit.
     *
     * The original use case originated from the need to differentiate the component
     * within a Business Unit during onboarding.
     *
     * This is a copy of the BusinessUnitFeature enum in commons.
     * TODO: We need better code splitting on web-api-ts-client before we can import values directly.
     * Currently the generated JS file is too big.
     */
    var BusinessUnitComponent;
    (function (BusinessUnitComponent) {
        BusinessUnitComponent["BUDGET_TOOL"] = "BUDGET_TOOL";
        BusinessUnitComponent["CHANGE_THE_DATE"] = "CHANGE_THE_DATE";
        BusinessUnitComponent["COMMUNITY"] = "COMMUNITY";
        BusinessUnitComponent["DAY_OF_PAPER"] = "DAY_OF_PAPER";
        BusinessUnitComponent["DIGITAL_SAVE_THE_DATE"] = "DIGITAL_SAVE_THE_DATE";
        BusinessUnitComponent["HOLIDAY"] = "HOLIDAY";
        BusinessUnitComponent["INSPIRATION"] = "INSPIRATION";
        BusinessUnitComponent["INVITATIONS"] = "INVITATIONS";
        BusinessUnitComponent["MARKETPLACE"] = "MARKETPLACE";
        BusinessUnitComponent["REGISTRY"] = "REGISTRY";
        BusinessUnitComponent["SAVE_THE_DATE"] = "SAVE_THE_DATE";
        BusinessUnitComponent["STORE"] = "STORE";
        BusinessUnitComponent["THANK_YOU_CARDS"] = "THANK_YOU_CARDS";
        BusinessUnitComponent["WEDDING_ALBUM"] = "WEDDING_ALBUM";
        BusinessUnitComponent["WEDDING_CHECKLIST"] = "WEDDING_CHECKLIST";
        BusinessUnitComponent["WEDDING_GUEST_LIST"] = "WEDDING_GUEST_LIST";
        BusinessUnitComponent["WEDDING_PLANNING"] = "WEDDING_PLANNING";
        BusinessUnitComponent["WEDDING_SHOWER_INVITATION"] = "WEDDING_SHOWER_INVITATION";
        BusinessUnitComponent["WEDDING_WEBSITE"] = "WEDDING_WEBSITE";
        BusinessUnitComponent["WEDDINGS"] = "WEDDINGS";
    })(BusinessUnitComponent || (BusinessUnitComponent = {}));
    var BusinessUnit;
    (function (BusinessUnit) {
        BusinessUnit["BUDGET_TOOL"] = "BUDGET_TOOL";
        BusinessUnit["COMMUNITY"] = "COMMUNITY";
        BusinessUnit["DIGITAL_SAVE_THE_DATE"] = "DIGITAL_SAVE_THE_DATE";
        BusinessUnit["INSPIRATION"] = "INSPIRATION";
        BusinessUnit["INVITATIONS"] = "INVITATIONS";
        BusinessUnit["MARKETPLACE"] = "MARKETPLACE";
        BusinessUnit["MARKETPLACE_VENDORS"] = "MARKETPLACE_VENDORS";
        BusinessUnit["PHOTOBOOK"] = "PHOTOBOOK";
        BusinessUnit["STORE"] = "STORE";
        BusinessUnit["WEDDING_REGISTRY"] = "WEDDING_REGISTRY";
        BusinessUnit["WEDDINGS"] = "WEDDINGS";
    })(BusinessUnit || (BusinessUnit = {}));

    // gets the business resource from either a window level object or the url
    function detectBusinessUnit() {
        var businessResource = BusinessUnit.WEDDING_REGISTRY;
        var isWeddingSignup = window.zolaNav && window.zolaNav.isWeddingSignup;
        var isRegistrySignup = window.zolaNav && window.zolaNav.isRegistrySignup;
        var isInvitationsSignup = window.zolaNav && window.zolaNav.isInvitationsSignup;
        var _a = window.location, hostname = _a.hostname, path = _a.pathname;
        var isInvitationsUrl = path.indexOf('wedding-planning/invites-paper') > -1 ||
            path.indexOf('wedding-planning/paper') > -1 ||
            path.indexOf('wedding-planning/universal') > -1 ||
            path.indexOf('wedding-planning/invitations') > -1 ||
            path.indexOf('wedding-planning/save-the-date') > -1 ||
            path.indexOf('wedding-planning/change-the-date') > -1 ||
            path.indexOf('wedding-planning/projects') > -1 ||
            path.indexOf('/wedding-planning/thank-you-cards') > -1 ||
            path.indexOf('/wedding-planning/menus') > -1 ||
            path.indexOf('/wedding-planning/enclosures') > -1 ||
            path.indexOf('/wedding-planning/place-cards') > -1 ||
            path.indexOf('/wedding-planning/holiday-cards') > -1 ||
            path.indexOf('/wedding-planning/programs') > -1 ||
            path.indexOf('/wedding-planning/bridal-shower') > -1 ||
            path.indexOf('/wedding-planning/suites/shop') > -1;
        var isDigitalUrl = path.indexOf('/wedding-planning/digital/save-the-date') > -1;
        var isAlbumsUrl = path.indexOf('wedding-albums') !== -1;
        var isShopOrSearchUrl = path.indexOf('/shop') > -1 || path.indexOf('/search') > -1;
        var isWeddingUrl = path.indexOf('wedding') > -1 &&
            !(path.indexOf('wedding-registry') > -1) &&
            !isInvitationsUrl &&
            !isShopOrSearchUrl;
        var isMarketplaceUrl = path.indexOf('/wedding-vendors') === 0 ||
            path.indexOf('/inspiration/onboard') === 0 ||
            path.indexOf('/inspire') === 0;
        var isInspirationUrl = path.indexOf('/inspiration') === 0;
        var isHomeStore = hostname.indexOf('homestore') > -1;
        var isCommunityUrl = path.indexOf('/community') === 0;
        // if the url is wedding or we've set the window bool to wedding
        // check flags first and then url, break href checks into separate booleans
        if (isDigitalUrl) {
            businessResource = BusinessUnit.DIGITAL_SAVE_THE_DATE;
        }
        else if (isWeddingSignup) {
            businessResource = BusinessUnit.WEDDINGS;
        }
        else if (isRegistrySignup) {
            businessResource = BusinessUnit.WEDDING_REGISTRY;
        }
        else if (isInvitationsSignup) {
            businessResource = BusinessUnit.INVITATIONS;
        }
        else if (isInvitationsUrl) {
            businessResource = BusinessUnit.INVITATIONS;
        }
        else if (isAlbumsUrl) {
            businessResource = BusinessUnit.PHOTOBOOK;
        }
        else if (isMarketplaceUrl) {
            businessResource = BusinessUnit.MARKETPLACE;
        }
        else if (isInspirationUrl) {
            businessResource = BusinessUnit.INSPIRATION;
        }
        else if (isWeddingUrl) {
            businessResource = BusinessUnit.WEDDINGS;
        }
        else if (isHomeStore) {
            businessResource = BusinessUnit.STORE;
        }
        else if (isCommunityUrl) {
            businessResource = BusinessUnit.COMMUNITY;
        }
        return businessResource;
    }

    var REQUEST_USER = 'zola/user/REQUEST_USER';
    var RECEIVE_USER = 'zola/user/RECEIVE_USER';
    var IDENTIFY_USER = 'zola/user/IDENTIFY_USER';
    var IDENTIFY_GUEST_USER = 'zola/user/IDENTIFY_GUEST_USER';
    var RECEIVE_USER_STATUS = 'zola/user/RECEIVE_USER_STATUS';
    var REQUEST_PARTNER_STATUS = 'zola/user/REQUEST_PARTNER_STATUS';
    var RECEIVE_PARTNER_STATUS = 'zola/user/RECEIVE_PARTNER_STATUS';

    var ACCESSORIES_TAXONOMY_KEY = 'wedding-accessories';
    var ACCOMMODATIONS_TAXONOMY_KEY = 'wedding-accommodations';
    var ALTERATIONS_PRESERVATION_TAXONOMY_KEY = 'wedding-alterations-preservation';
    var BANDS_DJS_TAXONOMY_KEY = 'wedding-bands-djs';
    var BAR_SERVICES_TAXONOMY_KEY = 'wedding-bar-services';
    var BRIDAL_SHOPS_TAXONOMY_KEY = 'wedding-bridal-shops';
    var CAKES_DESSERTS_TAXONOMY_KEY = 'wedding-cakes-desserts';
    var CATERING_TAXONOMY_KEY = 'wedding-catering';
    var CELEBRANTS_OFFICIANTS_TAXONOMY_KEY = 'wedding-celebrants-officiants';
    var CHILDCARE_SERVICES_TAXONOMY_KEY = 'wedding-childcare-services';
    var CLOTHING_RENTALS_TAXONOMY_KEY = 'wedding-clothing-rentals';
    var FLORISTS_TAXONOMY_KEY = 'wedding-florists';
    var GENERAL_SERVICES_TAXONOMY_KEY = 'wedding-general-services';
    var GIFT_FAVORS_TAXONOMY_KEY = 'wedding-gift-favors';
    var HAIR_MAKEUP_TAXONOMY_KEY = 'wedding-hair-makeup';
    var INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY = 'wedding-invitations-calligraphy';
    var JEWELERS_TAXONOMY_KEY = 'wedding-jewelers';
    var LIGHTING_AV_TAXONOMY_KEY = 'wedding-lighting-av';
    var PHOTOBOOTHS_TAXONOMY_KEY = 'wedding-photobooths';
    var PHOTOGRAPHERS_TAXONOMY_KEY = 'wedding-photographers';
    var PLANNERS_TAXONOMY_KEY = 'wedding-planners';
    var RENTALS_DECOR_TAXONOMY_KEY = 'wedding-tents-rentals-decor';
    var SERVICE_STAFF_TAXONOMY_KEY = 'wedding-service-staff';
    var TRANSPORTATION_PROVIDERS_TAXONOMY_KEY = 'wedding-transportation-providers';
    var VARIETY_ACTS_TAXONOMY_KEY = 'wedding-variety-acts';
    var VENUES_TAXONOMY_KEY = 'wedding-venues';
    var VIDEOGRAPHERS_TAXONOMY_KEY = 'wedding-videographers';
    /**
     * List of vendor categories that are searchable, including subcategories
     */
    var SEARCHABLE_VENDOR_TAXONOMY_KEYS = [
        VENUES_TAXONOMY_KEY,
        PHOTOGRAPHERS_TAXONOMY_KEY,
        VIDEOGRAPHERS_TAXONOMY_KEY,
        FLORISTS_TAXONOMY_KEY,
        CATERING_TAXONOMY_KEY,
        BAR_SERVICES_TAXONOMY_KEY,
        CAKES_DESSERTS_TAXONOMY_KEY,
        BANDS_DJS_TAXONOMY_KEY,
        HAIR_MAKEUP_TAXONOMY_KEY,
        PLANNERS_TAXONOMY_KEY,
    ];
    /**
     * Ordered list of vendor categories that are searchable, not including subcategories
     *
     * Does not include bar services
     */
    var SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS = [
        VENUES_TAXONOMY_KEY,
        PHOTOGRAPHERS_TAXONOMY_KEY,
        VIDEOGRAPHERS_TAXONOMY_KEY,
        FLORISTS_TAXONOMY_KEY,
        CATERING_TAXONOMY_KEY,
        CAKES_DESSERTS_TAXONOMY_KEY,
        BANDS_DJS_TAXONOMY_KEY,
        HAIR_MAKEUP_TAXONOMY_KEY,
        PLANNERS_TAXONOMY_KEY,
    ];
    /**
     * Ordered list of vendor categories that are onboardable
     */
    var ONBOARDABLE_VENDOR_TAXONOMY_KEYS = [
        HAIR_MAKEUP_TAXONOMY_KEY,
        CATERING_TAXONOMY_KEY,
        FLORISTS_TAXONOMY_KEY,
        CAKES_DESSERTS_TAXONOMY_KEY,
        BANDS_DJS_TAXONOMY_KEY,
        PHOTOGRAPHERS_TAXONOMY_KEY,
        PLANNERS_TAXONOMY_KEY,
        VENUES_TAXONOMY_KEY,
        VIDEOGRAPHERS_TAXONOMY_KEY,
    ];
    /**
     * List of all vendor categories
     */
    var VENDOR_TAXONOMY_KEYS = __spreadArray(__spreadArray([], SEARCHABLE_VENDOR_TAXONOMY_KEYS, true), [
        ACCESSORIES_TAXONOMY_KEY,
        ACCOMMODATIONS_TAXONOMY_KEY,
        ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
        BRIDAL_SHOPS_TAXONOMY_KEY,
        CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
        CHILDCARE_SERVICES_TAXONOMY_KEY,
        CLOTHING_RENTALS_TAXONOMY_KEY,
        GENERAL_SERVICES_TAXONOMY_KEY,
        GIFT_FAVORS_TAXONOMY_KEY,
        INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
        JEWELERS_TAXONOMY_KEY,
        LIGHTING_AV_TAXONOMY_KEY,
        PHOTOBOOTHS_TAXONOMY_KEY,
        RENTALS_DECOR_TAXONOMY_KEY,
        SERVICE_STAFF_TAXONOMY_KEY,
        TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
        VARIETY_ACTS_TAXONOMY_KEY,
    ], false);
    /**
     * Determines whether the given string is a vendor taxonomy key
     */
    var isVendorTaxonomyKey = function (s) {
        return SEARCHABLE_VENDOR_TAXONOMY_KEYS.some(function (typeKey) { return typeKey === s; });
    };

    /**
     * Get a function that returns a value based on a given vendor taxonomy key.
     *
     * @param vendorTaxonomyKeyMap Map that associates a vendor taxonomy key with a value of type `ReturnType`
     * @returns A function that accepts a vendor taxonomy key and returns the associated value
     * @example
     * const getVendorAnimal = getVendorTaxonomySwitchFunc({
     *   [VENUES_TAXONOMY_KEY]: 'Horse',
     *   [PHOTOGRAPHERS_TAXONOMY_KEY]: 'Zebra',
     * });
     *
     * getVendorAnimal(VENUES_TAXONOMY_KEY); // Horse
     * getVendorAnimal(PHOTOGRAPHERS_TAXONOMY_KEY); // Zebra
     * getVendorAnimal(FLORISTS_TAXONOMY_KEY); // undefined
     */
    var getVendorTaxonomySwitchFunc = function (vendorTaxonomyKeyMap) { return function (vendorTaxonomyKey) {
        return vendorTaxonomyKeyMap[vendorTaxonomyKey];
    }; };
    /**
     * Gets the vendor taxonomy key for a vendor category string.
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The vendor taxonomy key
     * @example
     * getVendorTaxonomyKey('catering'); // wedding-catering
     * getVendorTaxonomyKey('caterer'); // wedding-catering
     * getVendorTaxonomyKey('caterers'); // wedding-catering
     * getVendorTaxonomyKey(CATERING_TAXONOMY_KEY); // wedding-catering
     */
    var getVendorTaxonomyKey = function (categoryString) {
        if (VENDOR_TAXONOMY_KEYS.find(function (key) { return key === categoryString; })) {
            return categoryString;
        }
        switch ((categoryString || '').toLowerCase()) {
            case 'accessories':
                return ACCESSORIES_TAXONOMY_KEY;
            case 'accommodations':
                return ACCOMMODATIONS_TAXONOMY_KEY;
            case 'alterations':
                return ALTERATIONS_PRESERVATION_TAXONOMY_KEY;
            case 'attire':
            case 'clothing rental':
            case 'attire rentals':
                return CLOTHING_RENTALS_TAXONOMY_KEY;
            case 'bar services & beverages':
            case 'bar services':
            case 'bar-services':
            case 'bar_services':
                return BAR_SERVICES_TAXONOMY_KEY;
            case 'bridal shops':
            case 'bridal_shop':
            case 'bridal gown':
                return BRIDAL_SHOPS_TAXONOMY_KEY;
            case 'cakes & desserts':
            case 'cakes_desserts':
            case 'cakes-desserts':
            case 'baker':
                return CAKES_DESSERTS_TAXONOMY_KEY;
            case 'catering':
            case 'caterer':
            case 'caterers':
                return CATERING_TAXONOMY_KEY;
            case 'celebrants':
            case 'celebrant':
            case 'officiant':
                return CELEBRANTS_OFFICIANTS_TAXONOMY_KEY;
            case 'child care':
            case 'childcare':
            case 'childcare services':
                return CHILDCARE_SERVICES_TAXONOMY_KEY;
            case 'lighting':
            case 'lighting & av':
            case 'lighting-av':
                return LIGHTING_AV_TAXONOMY_KEY;
            case 'gift-favors':
            case 'gift & favors':
            case 'gifts':
            case 'gifts & favors':
                return GIFT_FAVORS_TAXONOMY_KEY;
            case 'florist':
            case 'florists':
                return FLORISTS_TAXONOMY_KEY;
            case 'general_services':
            case 'general services':
                return GENERAL_SERVICES_TAXONOMY_KEY;
            case 'beauticians':
            case 'hair-makeup':
            case 'hair':
            case 'hair & makeup':
            case 'hair_makeup':
            case 'beauty professional':
                return HAIR_MAKEUP_TAXONOMY_KEY;
            case 'invitations':
            case 'calligrapher':
                return INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY;
            case 'jewelers':
            case 'jeweler':
            case 'jewelry':
                return JEWELERS_TAXONOMY_KEY;
            case 'musicians':
            case 'musician_dj':
            case 'bands':
            case 'bands & djs':
            case 'bands-djs':
            case 'musician':
                return BANDS_DJS_TAXONOMY_KEY;
            case 'photo booth':
            case 'photobooth':
                return PHOTOBOOTHS_TAXONOMY_KEY;
            case 'photographer':
            case 'photographers':
                return PHOTOGRAPHERS_TAXONOMY_KEY;
            case 'planner':
            case 'planners':
            case 'wedding planner':
                return PLANNERS_TAXONOMY_KEY;
            case 'tents-rentals-decor':
            case 'tents, rentals & decor':
            case 'rentals_decor':
            case 'decor':
                return RENTALS_DECOR_TAXONOMY_KEY;
            case 'staff':
            case 'service_staff':
            case 'service staff':
                return SERVICE_STAFF_TAXONOMY_KEY;
            case 'transportation':
                return TRANSPORTATION_PROVIDERS_TAXONOMY_KEY;
            case 'variety_act':
            case 'entertainment':
                return VARIETY_ACTS_TAXONOMY_KEY;
            case 'venue':
            case 'venues':
                return VENUES_TAXONOMY_KEY;
            case 'videographer':
            case 'videographers':
                return VIDEOGRAPHERS_TAXONOMY_KEY;
            default:
                return undefined;
        }
    };
    /**
     * Get the vendor taxonomy ID for a vendor category
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The vendor taxonomy ID
     */
    var getVendorTaxonomyId = function (categoryString) {
        var _a;
        var vendorTaxonomyKey = getVendorTaxonomyKey(categoryString);
        if (!vendorTaxonomyKey) {
            return undefined;
        }
        return getVendorTaxonomySwitchFunc((_a = {},
            _a[VENUES_TAXONOMY_KEY] = 1,
            _a[PHOTOGRAPHERS_TAXONOMY_KEY] = 2,
            _a[VIDEOGRAPHERS_TAXONOMY_KEY] = 3,
            _a[FLORISTS_TAXONOMY_KEY] = 4,
            _a[PHOTOBOOTHS_TAXONOMY_KEY] = 5,
            _a[TRANSPORTATION_PROVIDERS_TAXONOMY_KEY] = 6,
            _a[PLANNERS_TAXONOMY_KEY] = 7,
            _a[RENTALS_DECOR_TAXONOMY_KEY] = 8,
            _a[BANDS_DJS_TAXONOMY_KEY] = 9,
            _a[HAIR_MAKEUP_TAXONOMY_KEY] = 10,
            _a[INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY] = 11,
            _a[ACCESSORIES_TAXONOMY_KEY] = 12,
            _a[GIFT_FAVORS_TAXONOMY_KEY] = 13,
            _a[SERVICE_STAFF_TAXONOMY_KEY] = 14,
            _a[ALTERATIONS_PRESERVATION_TAXONOMY_KEY] = 15,
            _a[LIGHTING_AV_TAXONOMY_KEY] = 16,
            _a[CLOTHING_RENTALS_TAXONOMY_KEY] = 17,
            _a[CATERING_TAXONOMY_KEY] = 18,
            _a[CAKES_DESSERTS_TAXONOMY_KEY] = 19,
            _a[CELEBRANTS_OFFICIANTS_TAXONOMY_KEY] = 20,
            _a[BRIDAL_SHOPS_TAXONOMY_KEY] = 21,
            _a[JEWELERS_TAXONOMY_KEY] = 22,
            _a[CHILDCARE_SERVICES_TAXONOMY_KEY] = 23,
            _a[VARIETY_ACTS_TAXONOMY_KEY] = 24,
            _a[GENERAL_SERVICES_TAXONOMY_KEY] = 25,
            _a[ACCOMMODATIONS_TAXONOMY_KEY] = 26,
            _a[BAR_SERVICES_TAXONOMY_KEY] = 28,
            _a))(vendorTaxonomyKey);
    };
    /**
     * Get the vendor taxonomy key for a vendor taxonomy ID
     */
    var getVendorTaxonomyKeyFromId = function (id) {
        var vendorTaxonomyKeyById = {
            1: VENUES_TAXONOMY_KEY,
            2: PHOTOGRAPHERS_TAXONOMY_KEY,
            3: VIDEOGRAPHERS_TAXONOMY_KEY,
            4: FLORISTS_TAXONOMY_KEY,
            5: PHOTOBOOTHS_TAXONOMY_KEY,
            6: TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
            7: PLANNERS_TAXONOMY_KEY,
            8: RENTALS_DECOR_TAXONOMY_KEY,
            9: BANDS_DJS_TAXONOMY_KEY,
            10: HAIR_MAKEUP_TAXONOMY_KEY,
            11: INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
            12: ACCESSORIES_TAXONOMY_KEY,
            13: GIFT_FAVORS_TAXONOMY_KEY,
            14: SERVICE_STAFF_TAXONOMY_KEY,
            15: ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
            16: LIGHTING_AV_TAXONOMY_KEY,
            17: CLOTHING_RENTALS_TAXONOMY_KEY,
            18: CATERING_TAXONOMY_KEY,
            19: CAKES_DESSERTS_TAXONOMY_KEY,
            20: CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
            21: BRIDAL_SHOPS_TAXONOMY_KEY,
            22: JEWELERS_TAXONOMY_KEY,
            23: CHILDCARE_SERVICES_TAXONOMY_KEY,
            24: VARIETY_ACTS_TAXONOMY_KEY,
            25: GENERAL_SERVICES_TAXONOMY_KEY,
            26: ACCOMMODATIONS_TAXONOMY_KEY,
            28: BAR_SERVICES_TAXONOMY_KEY,
        };
        return vendorTaxonomyKeyById[id];
    };
    /**
     * Get the vendor taxonomy key for a vendor type enum string
     *
     * @param vendorType The vendor type enum used in search and booked vendors
     * @returns The vendor taxonomy key
     */
    var getVendorTaxonomyKeyFromVendorType = function (vendorType) {
        var vendorTaxonomyKeyByVendorType = {
            ACCESSORIES: ACCESSORIES_TAXONOMY_KEY,
            ACCOMMODATIONS: ACCOMMODATIONS_TAXONOMY_KEY,
            ALTERATIONS: ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
            ATTIRE: CLOTHING_RENTALS_TAXONOMY_KEY,
            BAR_SERVICES: BAR_SERVICES_TAXONOMY_KEY,
            BRIDAL_SHOP: BRIDAL_SHOPS_TAXONOMY_KEY,
            CAKES_DESSERTS: CAKES_DESSERTS_TAXONOMY_KEY,
            CATERER: CATERING_TAXONOMY_KEY,
            CELEBRANT: CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
            CHILDCARE: CHILDCARE_SERVICES_TAXONOMY_KEY,
            FLORIST: FLORISTS_TAXONOMY_KEY,
            GENERAL_SERVICES: GENERAL_SERVICES_TAXONOMY_KEY,
            GIFTS: GIFT_FAVORS_TAXONOMY_KEY,
            HAIR_MAKEUP: HAIR_MAKEUP_TAXONOMY_KEY,
            INVITATIONS: INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
            JEWELER: JEWELERS_TAXONOMY_KEY,
            LIGHTING_AV: LIGHTING_AV_TAXONOMY_KEY,
            MUSICIAN_DJ: BANDS_DJS_TAXONOMY_KEY,
            PHOTOBOOTH: PHOTOBOOTHS_TAXONOMY_KEY,
            PHOTOGRAPHER: PHOTOGRAPHERS_TAXONOMY_KEY,
            PLANNER: PLANNERS_TAXONOMY_KEY,
            RENTALS_DECOR: RENTALS_DECOR_TAXONOMY_KEY,
            SERVICE_STAFF: SERVICE_STAFF_TAXONOMY_KEY,
            TRANSPORTATION: TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
            VARIETY_ACT: VARIETY_ACTS_TAXONOMY_KEY,
            VENUE: VENUES_TAXONOMY_KEY,
            VIDEOGRAPHER: VIDEOGRAPHERS_TAXONOMY_KEY,
        };
        return vendorTaxonomyKeyByVendorType[vendorType];
    };
    /**
     * Get the vendor type for a vendor category string
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The vendor type enum
     */
    var getVendorType = function (categoryString) {
        var _a;
        var vendorTaxonomyKey = getVendorTaxonomyKey(categoryString);
        if (!vendorTaxonomyKey) {
            return undefined;
        }
        return getVendorTaxonomySwitchFunc((_a = {},
            _a[ACCESSORIES_TAXONOMY_KEY] = 'ACCESSORIES',
            _a[ACCOMMODATIONS_TAXONOMY_KEY] = 'ACCOMMODATIONS',
            _a[ALTERATIONS_PRESERVATION_TAXONOMY_KEY] = 'ALTERATIONS',
            _a[BANDS_DJS_TAXONOMY_KEY] = 'MUSICIAN_DJ',
            _a[BAR_SERVICES_TAXONOMY_KEY] = 'BAR_SERVICES',
            _a[BRIDAL_SHOPS_TAXONOMY_KEY] = 'BRIDAL_SHOP',
            _a[CAKES_DESSERTS_TAXONOMY_KEY] = 'CAKES_DESSERTS',
            _a[CATERING_TAXONOMY_KEY] = 'CATERER',
            _a[CELEBRANTS_OFFICIANTS_TAXONOMY_KEY] = 'CELEBRANT',
            _a[CHILDCARE_SERVICES_TAXONOMY_KEY] = 'CHILDCARE',
            _a[CLOTHING_RENTALS_TAXONOMY_KEY] = 'ATTIRE',
            _a[FLORISTS_TAXONOMY_KEY] = 'FLORIST',
            _a[GENERAL_SERVICES_TAXONOMY_KEY] = 'GENERAL_SERVICES',
            _a[GIFT_FAVORS_TAXONOMY_KEY] = 'GIFTS',
            _a[HAIR_MAKEUP_TAXONOMY_KEY] = 'HAIR_MAKEUP',
            _a[INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY] = 'INVITATIONS',
            _a[JEWELERS_TAXONOMY_KEY] = 'JEWELER',
            _a[LIGHTING_AV_TAXONOMY_KEY] = 'LIGHTING_AV',
            _a[PHOTOBOOTHS_TAXONOMY_KEY] = 'PHOTOBOOTH',
            _a[PHOTOGRAPHERS_TAXONOMY_KEY] = 'PHOTOGRAPHER',
            _a[PLANNERS_TAXONOMY_KEY] = 'PLANNER',
            _a[RENTALS_DECOR_TAXONOMY_KEY] = 'RENTALS_DECOR',
            _a[SERVICE_STAFF_TAXONOMY_KEY] = 'SERVICE_STAFF',
            _a[TRANSPORTATION_PROVIDERS_TAXONOMY_KEY] = 'TRANSPORTATION',
            _a[VARIETY_ACTS_TAXONOMY_KEY] = 'VARIETY_ACT',
            _a[VENUES_TAXONOMY_KEY] = 'VENUE',
            _a[VIDEOGRAPHERS_TAXONOMY_KEY] = 'VIDEOGRAPHER',
            _a))(vendorTaxonomyKey);
    };
    /**
     * Get the recommended booking window for a vendor category
     *
     * @see https://docs.google.com/document/d/1jbPdCGElVDpE8WcfCneHUkolNIctHQZhE6CjuPrvPoM/edit
     */
    var getRecommendedBookingWindow = function (vendorTaxonomyKey) {
        var _a;
        var threeToSixMonths = '3\u20136 months';
        var sixToNineMonths = '6\u20139 months';
        var nineToTwelveMonths = '9\u201312 months';
        var twelvePlusMonths = '12+ months';
        return getVendorTaxonomySwitchFunc((_a = {},
            _a[ACCESSORIES_TAXONOMY_KEY] = threeToSixMonths,
            _a[ACCOMMODATIONS_TAXONOMY_KEY] = sixToNineMonths,
            _a[ALTERATIONS_PRESERVATION_TAXONOMY_KEY] = threeToSixMonths,
            _a[BANDS_DJS_TAXONOMY_KEY] = sixToNineMonths,
            _a[BAR_SERVICES_TAXONOMY_KEY] = nineToTwelveMonths,
            _a[BRIDAL_SHOPS_TAXONOMY_KEY] = nineToTwelveMonths,
            _a[CAKES_DESSERTS_TAXONOMY_KEY] = sixToNineMonths,
            _a[CATERING_TAXONOMY_KEY] = nineToTwelveMonths,
            _a[CELEBRANTS_OFFICIANTS_TAXONOMY_KEY] = sixToNineMonths,
            _a[CHILDCARE_SERVICES_TAXONOMY_KEY] = sixToNineMonths,
            _a[CLOTHING_RENTALS_TAXONOMY_KEY] = threeToSixMonths,
            _a[FLORISTS_TAXONOMY_KEY] = sixToNineMonths,
            _a[GENERAL_SERVICES_TAXONOMY_KEY] = sixToNineMonths,
            _a[GIFT_FAVORS_TAXONOMY_KEY] = threeToSixMonths,
            _a[HAIR_MAKEUP_TAXONOMY_KEY] = sixToNineMonths,
            _a[INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY] = sixToNineMonths,
            _a[JEWELERS_TAXONOMY_KEY] = threeToSixMonths,
            _a[LIGHTING_AV_TAXONOMY_KEY] = sixToNineMonths,
            _a[PHOTOBOOTHS_TAXONOMY_KEY] = sixToNineMonths,
            _a[PHOTOGRAPHERS_TAXONOMY_KEY] = nineToTwelveMonths,
            _a[PLANNERS_TAXONOMY_KEY] = nineToTwelveMonths,
            _a[RENTALS_DECOR_TAXONOMY_KEY] = sixToNineMonths,
            _a[SERVICE_STAFF_TAXONOMY_KEY] = sixToNineMonths,
            _a[TRANSPORTATION_PROVIDERS_TAXONOMY_KEY] = sixToNineMonths,
            _a[VARIETY_ACTS_TAXONOMY_KEY] = sixToNineMonths,
            _a[VENUES_TAXONOMY_KEY] = twelvePlusMonths,
            _a[VIDEOGRAPHERS_TAXONOMY_KEY] = sixToNineMonths,
            _a))(vendorTaxonomyKey);
    };

    var _a;
    (function (BadgeValue) {
        BadgeValue["QUICK_RESPONDER"] = "quick_responder";
    })(exports.BadgeValue || (exports.BadgeValue = {}));
    function getPageContext() {
        var _a;
        return {
            path: window.location.pathname,
            search: window.location.search,
            referrer: ((_a = window === null || window === void 0 ? void 0 : window.zola) === null || _a === void 0 ? void 0 : _a.referrer) || document.referrer,
            url: window.location.href,
            title: document.title,
        };
    }
    /**
     * Guard / gatekeeper to blacklist certain events.
     *
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function canTrack(eventName, payload) {
        if (eventName === 'CTA Viewed') {
            // If we want to allowlist some CTA viewed events, we can do that with the payload
            return false;
        }
        return true;
    }
    function trackEvent(eventName, payload, options) {
        var _a;
        if (options === void 0) { options = {}; }
        var optionsFinal = options || {};
        optionsFinal.page = getPageContext();
        if (((_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.track) && canTrack(eventName)) {
            window.analytics.track(eventName, payload, optionsFinal);
        }
    }
    function trackIdentifyUser(userId, traits, options) {
        var optionsFinal = options || {};
        optionsFinal.page = getPageContext();
        if (window && window.analytics) {
            window.analytics.identify(userId, traits, optionsFinal);
        }
    }
    /**
     * Sends an event to GA through Segment.  Does not go ot other Segment destinations.
     * https://segment.com/docs/connections/destinations/catalog/google-analytics/#track
     * @param eventName The Event name will become the action in GA
     * @param payload
     */
    function trackGoogleAnalyticsEvent(eventName, payload) {
        var options = {
            integrations: {
                All: false,
                'Google Analytics': true,
            },
        };
        trackEvent(eventName, payload, options);
    }
    /**
     * Fires a GTM event.  Does not go to other Segment destinations.
     * @param eventName
     * @param payload payload data will be pushed to the dataLayer
     */
    function trackGoogleTagManagerEvent(eventName, payload) {
        var options = {
            integrations: {
                All: false,
                'Google Tag Manager': true,
            },
        };
        trackEvent(eventName, payload, options);
    }
    function getCampaignContext() {
        if (document === null || document === void 0 ? void 0 : document.cookie) {
            var utm_source = getCookie('utm_source') || undefined;
            var utm_campaign = getCookie('utm_campaign') || undefined;
            var utm_term = getCookie('utm_term') || undefined;
            var utm_content = getCookie('utm_content') || undefined;
            var utm_medium = getCookie('utm_medium') || undefined;
            var hasUtmCookies = [utm_source, utm_campaign, utm_term, utm_content, utm_medium].reduce(function (acc, cur) { return acc || Boolean(cur); }, false);
            if (hasUtmCookies) {
                return {
                    content: utm_content,
                    medium: utm_medium,
                    name: utm_campaign,
                    source: utm_source,
                    term: utm_term,
                };
            }
        }
        return undefined;
    }
    function trackUserCreated(email, pkey) {
        var payload = { email: email, pkey: pkey };
        var campaignContext = getCampaignContext();
        var options = campaignContext
            ? { campaign: campaignContext }
            : undefined;
        trackEvent('User Created', payload, options);
    }
    var getBusinessCategory = getVendorTaxonomySwitchFunc((_a = {},
        _a[VENUES_TAXONOMY_KEY] = 'VENUE',
        _a[BANDS_DJS_TAXONOMY_KEY] = 'MUSICIAN_DJ',
        _a[BAR_SERVICES_TAXONOMY_KEY] = 'BAR_SERVICES',
        _a[CAKES_DESSERTS_TAXONOMY_KEY] = 'CAKES_DESSERTS',
        _a[CATERING_TAXONOMY_KEY] = 'CATERER',
        _a[FLORISTS_TAXONOMY_KEY] = 'FLORIST',
        _a[HAIR_MAKEUP_TAXONOMY_KEY] = 'HAIR_MAKEUP',
        _a[PHOTOGRAPHERS_TAXONOMY_KEY] = 'PHOTOGRAPHER',
        _a[PLANNERS_TAXONOMY_KEY] = 'PLANNER',
        _a[VIDEOGRAPHERS_TAXONOMY_KEY] = 'VIDEOGRAPHER',
        _a));

    function detectMobileDevice() {
        if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) // to detect iPad iOS 13 or later
        ) {
            return true;
        }
        return false;
    }
    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }
        if (/android/i.test(userAgent)) {
            return 'Android';
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }
        return 'unknown';
    }
    function detectIOS() {
        return getMobileOperatingSystem() === 'iOS';
    }
    function detectAndroid() {
        return getMobileOperatingSystem() === 'Android';
    }
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
    function detectTouchScreen() {
        var hasTouchScreen = false;
        if ('maxTouchPoints' in navigator) {
            hasTouchScreen = navigator.maxTouchPoints > 0;
        }
        else if ('msMaxTouchPoints' in navigator) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            hasTouchScreen = navigator.msMaxTouchPoints > 0;
        }
        else {
            var mQ = typeof window.matchMedia !== 'undefined' && matchMedia('(pointer:coarse)');
            if (mQ && mQ.media === '(pointer:coarse)') {
                hasTouchScreen = !!mQ.matches;
            }
            else if ('orientation' in window) {
                hasTouchScreen = true; // deprecated, but good fallback
            }
            else {
                // Only as a last resort, fall back to user agent sniffing
                hasTouchScreen = detectMobileDevice();
            }
        }
        return hasTouchScreen;
    }

    var EnvironmentTypes;
    (function (EnvironmentTypes) {
        EnvironmentTypes["DEVELOPMENT"] = "development";
        EnvironmentTypes["STAGING"] = "staging";
        EnvironmentTypes["PRODUCTION"] = "production";
    })(EnvironmentTypes || (EnvironmentTypes = {}));
    /**
     * Fallback to get the environment based on the hostname
     *
     * @returns {Environment} - The environment based on the hostname
     */
    var getEnvironmentByHostname = function () {
        var _a;
        var hostname = typeof window !== 'undefined' ? ((_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname) || '' : '';
        hostname = hostname.toLowerCase();
        if (hostname.startsWith('dev') || hostname === 'localhost') {
            return EnvironmentTypes.DEVELOPMENT;
        }
        if (hostname.startsWith('qa')) {
            return EnvironmentTypes.STAGING;
        }
        return EnvironmentTypes.PRODUCTION;
    };
    /**
     * Gets the environment based on the zola environment or hostname
     *
     * @memberof client
     *
     * @returns {EnvironmentTypes} - The environment
     */
    var getEnvironment = (function () {
        var _a;
        var zolaEnv = typeof window !== 'undefined'
            ? (_a = window.zola) === null || _a === void 0 ? void 0 : _a.env
            : process.env.ZOLA_ENV || process.env.NODE_ENV;
        if (!zolaEnv) {
            zolaEnv = getEnvironmentByHostname();
        }
        switch (zolaEnv) {
            case 'development':
            case 'dev':
                return EnvironmentTypes.DEVELOPMENT;
            case 'staging':
            case 'stage':
                return EnvironmentTypes.STAGING;
            case 'production':
            case 'prod':
                return EnvironmentTypes.PRODUCTION;
            default:
                return EnvironmentTypes.PRODUCTION;
        }
    });

    function logRocketTrack(eventName) {
        var logRocketActive = getCookie(LOG_ROCKET_COOKIE);
        if (logRocketActive) {
            if (window !== undefined && window.LogRocket) {
                window.LogRocket.track(eventName);
            }
        }
    }

    function mapUserContextToLogRocketIdentify(userContext, traits) {
        var objectId = userContext.object_id, email = userContext.email, firstName = userContext.first_name, lastName = userContext.last_name;
        var name = firstName && lastName ? "".concat(firstName, " ").concat(lastName) : undefined;
        var traitsFinal = __assign({ name: name, email: email }, traits);
        var isActiveSession = Boolean(getCookie(LOG_ROCKET_COOKIE));
        if (!userContext.is_guest && objectId && isActiveSession) {
            if (window !== undefined && window.LogRocket) {
                window.LogRocket.identify(objectId, traitsFinal);
            }
        }
        return Promise.resolve(userContext);
    }

    function requestUser() {
        return {
            type: REQUEST_USER,
        };
    }
    function receiveUser(response) {
        return {
            type: RECEIVE_USER,
            payload: response,
        };
    }
    function receiveIdentifyUser() {
        return {
            type: IDENTIFY_USER,
        };
    }
    function receiveIdentifyGuestUser() {
        return {
            type: IDENTIFY_GUEST_USER,
        };
    }
    function identifyUser(_a) {
        var _b;
        var userContext = _a.userContext, hasIdentified = _a.hasIdentified, forceIdentify = _a.forceIdentify;
        if (!(userContext === null || userContext === void 0 ? void 0 : userContext.is_guest) && (!hasIdentified || forceIdentify)) {
            var userId = userContext.object_id;
            var traits = {
                email: userContext.email || '',
                first_name: userContext.first_name || '',
                last_name: userContext.last_name || '',
                role: (_b = userContext.user_role_account_weddings) === null || _b === void 0 ? void 0 : _b[0].role,
                name: userContext.first_name ? "".concat(userContext.first_name, " ").concat(userContext.last_name) : '',
            };
            if (!userId)
                throw new Error('Missig userId');
            else
                trackIdentifyUser(userId, traits);
            if (window.analytics && window.dataLayer) {
                window.dataLayer.push({
                    event: 'User Identified',
                    userId: userId,
                    created_at: userContext.created_at,
                });
            }
        }
    }
    function identifyGuestUser(_a) {
        var userContext = _a.userContext, hasGuestIdentified = _a.hasGuestIdentified, forceIdentify = _a.forceIdentify;
        if (userContext.is_guest && (!hasGuestIdentified || forceIdentify)) {
            var userId = userContext.object_id;
            var traits = { role: 'VISITOR' };
            if (!userId)
                throw new Error('Missig userId');
            else
                trackIdentifyUser(userId, traits);
        }
    }
    /**
     * Identify a user within Sailthru.
     * Result sets sailthru_hid with a SHA256 hash of the email
     * SEE: https://getstarted.sailthru.com/developers/api-client/javascript/#userSignUp
     * @param {string} email Users email
     * @returns {Promise<any>}
     */
    function identifyUserSailthru(email, newUserData) {
        return new Promise(function (resolve) {
            // Ignore if Sailthru is not available
            if (typeof window.Sailthru === 'undefined') {
                resolve();
                return;
            }
            // In case something goes terribly wrong
            var forceResolveTimeout = window.setTimeout(resolve, 1000);
            var vars = { email: email };
            var newSailthruUserVarsFeature = window.zola && window.zola.feature && window.zola.feature.newSailthruUserVars;
            if (newUserData && newSailthruUserVarsFeature) {
                vars.first_account_created = newUserData.business_unit_source;
                // TODO: Sailthru tracking should probably be moved entirely to the BE.
                vars.first_component = newUserData.business_unit_feature;
                vars.first_account_device_type = detectMobileDevice() ? 'Mobile Web' : 'Desktop';
            }
            var sailthruRequest = {
                email: email,
                vars: vars,
                onSuccess: function () {
                    clearTimeout(forceResolveTimeout);
                    resolve();
                },
                onError: function () {
                    clearTimeout(forceResolveTimeout);
                    resolve();
                },
            };
            try {
                window.Sailthru.integration('userSignUp', sailthruRequest);
            }
            catch (error) {
                resolve();
            }
        });
    }
    function fetchUserContext() {
        return ApiService.get('/website-nav/web-api/v1/user/get')
            .then(function (json) {
            var isGuest = json.is_guest, email = json.email;
            if (isGuest) {
                deleteCookie('zolaLoggedIn');
            }
            else {
                setCookie('zolaLoggedIn', true);
            }
            // Temporarily set email for BounceX usage
            window.zola = window.zola || {};
            window.zola.tracking = {
                email: email || '',
            };
            return json;
        })
            .then(mapUserContextToLogRocketIdentify)
            .catch(function (err) {
            throw err;
        });
    }
    var createStoreAccount = function () { return function () {
        return ApiService.get('/website-nav/web-api/v1/user/create_store_account');
    }; };
    function updateUserStatus() {
        return ApiService.get('/web-api/v1/user/status');
    }
    function requestPartnerStatus() {
        return {
            type: REQUEST_PARTNER_STATUS,
        };
    }
    function receivePartnerStatus(response) {
        return {
            type: RECEIVE_PARTNER_STATUS,
            payload: response,
        };
    }
    function getPartnerAccount() {
        return ApiService.get('/web-api/v1/account-invitation/list');
    }
    function invitePartner(request) {
        return ApiService.post('/web-api/v1/account-invitation/send', request);
    }
    var removeOrRevokePartner = function (uuid, removeOrRevoke) {
        return ApiService.post("/web-api/v1/account-invitation/uuid/".concat(uuid, "/").concat(removeOrRevoke));
    };

    var userActions = /*#__PURE__*/Object.freeze({
        __proto__: null,
        requestUser: requestUser,
        receiveUser: receiveUser,
        receiveIdentifyUser: receiveIdentifyUser,
        receiveIdentifyGuestUser: receiveIdentifyGuestUser,
        identifyUser: identifyUser,
        identifyGuestUser: identifyGuestUser,
        identifyUserSailthru: identifyUserSailthru,
        fetchUserContext: fetchUserContext,
        createStoreAccount: createStoreAccount,
        updateUserStatus: updateUserStatus,
        requestPartnerStatus: requestPartnerStatus,
        receivePartnerStatus: receivePartnerStatus,
        getPartnerAccount: getPartnerAccount,
        invitePartner: invitePartner,
        removeOrRevokePartner: removeOrRevokePartner
    });

    /** `Object#toString` result references. */
    var mapTag$3 = '[object Map]',
      setTag$3 = '[object Set]';

    /** Used for built-in method references. */
    var objectProto$e = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$c = objectProto$e.hasOwnProperty;

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike_1(value) && (isArray_1(value) || typeof value == 'string' || typeof splice$2(value) == 'function' || isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
        return !value.length;
      }
      var tag = _getTag(value);
      if (tag == mapTag$3 || tag == setTag$3) {
        return !value.size;
      }
      if (_isPrototype(value)) {
        return !_baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty$c.call(value, key)) {
          return false;
        }
      }
      return true;
    }
    var isEmpty_1 = isEmpty;

    /**
     * @param eventData - Custom experiment viewed event data
     */
    function trackCustomExperimentViewed(_a) {
        var _b = _a.vendor, vendor = _b === void 0 ? 'ZOLA' : _b, variationKey = _a.variationKey, experimentName = _a.experimentName;
        var eventData = {
            vendor: vendor,
            variation_name: variationKey,
            experiment_name: experimentName,
        };
        logRocketTrack("".concat(experimentName, "-").concat(variationKey));
        trackEvent('Custom Experiment Viewed', eventData);
    }

    var EXP_STORAGE_KEY = 'zola_user_experiments';
    var OVERRIDES_KEY = 'zola_flag_overrides';
    /**
     * Enum for test values.
     *
     * @readonly
     * @enum {string}
     * @memberof client
     */
    var experimentStates = {
        NOT_IN_TEST: 'NOT_IN_TEST',
        TEST: 'TEST',
        CONTROL: 'TEST-0', // The control group of an enabled A/B/n experiment
    };
    /**
     * @param experimentName - Experiment name
     * @returns indicating if the user has been placed in the experiment
     * @memberof client
     */
    function hasTriggeredExperiment(experimentName) {
        var storedExperiments = getSessionStorage(EXP_STORAGE_KEY);
        if (!storedExperiments)
            return false;
        var parsed = JSON.parse(storedExperiments);
        if (parsed)
            return Boolean(parsed[experimentName]);
        return false;
    }
    /**
     * Fires a Custom Experiment Viewed segment event and saves the experiment in session storage
     *
     * @param experimentName - Experiment name
     * @param variationKey - Experiment variation
     * @memberof client
     */
    function triggerExperiment(experimentName, variationKey) {
        if (variationKey !== experimentStates.NOT_IN_TEST) {
            // Don't track the view for single-variation experiments (i.e. feature flags)
            if (variationKey !== experimentStates.TEST) {
                trackCustomExperimentViewed({ experimentName: experimentName, variationKey: variationKey });
            }
            // Add to session storage
            var triggeredExperiments = JSON.parse(getSessionStorage(EXP_STORAGE_KEY) || '{}') || {};
            triggeredExperiments[experimentName] = true;
            setSessionStorage(EXP_STORAGE_KEY, JSON.stringify(triggeredExperiments));
        }
    }
    /**
     * Fires a Custom Experiment Viewed segment event and saves the experiment in session storage
     *
     * @function getUserExperiments
     * @param experimentName - Experiment name
     * @param userContext - userContext for this user
     * @returns List of experiments for this user
     * @memberof client
     */
    function getUserExperiments(experimentName, userContext) {
        return get_1(userContext, "user_experiments.".concat(experimentName), {});
    }
    /**
     * @param config - User experiment config
     * @memberof client
     */
    function getUserExperimentVariation(_a) {
        var experimentName = _a.experimentName, userContext = _a.userContext, fallbackValue = _a.fallbackValue, _b = _a.triggerExperimentViewed, triggerExperimentViewed = _b === void 0 ? false : _b;
        var experimentState = getUserExperiments(experimentName, userContext);
        var variationKey = experimentState.variation_key;
        var usingFallbackValue = false;
        if (!variationKey) {
            variationKey = fallbackValue;
            usingFallbackValue = true;
        }
        var noStateError = new Error('No experiment state found, please ensure new experiments have a fallback config.');
        if (!variationKey)
            throw noStateError;
        // Make sure a user context is present so we don't fire prematurely.
        var userContextExists = !isEmpty_1(userContext);
        var shouldTriggerExperiment = !usingFallbackValue &&
            !hasTriggeredExperiment(experimentName) &&
            triggerExperimentViewed &&
            userContextExists;
        if (shouldTriggerExperiment) {
            triggerExperiment(experimentName, variationKey);
        }
        return variationKey;
    }
    /**
     * Clear experiemnt storage
     *
     * @memberof client
     */
    function clearExperimentStorage() {
        deleteSessionStorage(EXP_STORAGE_KEY);
    }
    var getExperimentOverrides = function () {
        return JSON.parse(getCookie(OVERRIDES_KEY) || '{}') || {};
    };
    var setExperimentOverrides = function (experimentName, variation) {
        if (!experimentName)
            return;
        var flagOverrides = getExperimentOverrides();
        flagOverrides[experimentName] = variation;
        setCookie(OVERRIDES_KEY, JSON.stringify(flagOverrides));
    };

    /**
     * An constant that stores error message and type in key value pair
     */
    var ERROR_MESSAGE = {
        invalid_password: 'Your email and password do not match.',
        invalid_email: 'You have entered an invalid email.',
        user_locked: 'Looks like you have forgotten your password. Please click the forgot password link above to reset your password and continue.',
        'facebook-missing-email': 'You must provide Zola access to your Facebook email address to create your account.',
        default: 'There was a problem processing your request. Please try again or contact customer support for assistance.',
    };
    /**
     * Construct an error message base on error message types. If no match for the error type, return default.
     */
    function getDetailedMessage(error) {
        var errorMessage = error && error.category && ERROR_MESSAGE[error.category.reason];
        return errorMessage || ERROR_MESSAGE.default;
    }
    /**
     * Construct an error message that contains the error response and user friendly message
     */
    function createError(error) {
        var errorData = Object.assign({ detailedMessage: getDetailedMessage(error === null || error === void 0 ? void 0 : error.response) }, error);
        throw errorData;
    }
    /**
     * Construct an error object if the status is a error, otherwise return the same response
     */
    function checkWAFErrors(response) {
        if (response.status === STATUS_CODES.FORBIDDEN) {
            var error = new Error(response.statusText);
            error.response = response;
            error.detailedMessage = 'Please contact support@zola.com and we will assist you.';
            throw error;
        }
        if (response.status === STATUS_CODES.NOT_ACCEPTABLE) {
            var error = new Error(response.statusText);
            error.response = response;
            error.detailedMessage =
                'Your account has been locked due to too many failed login attempts. Please wait 1 hour and try again.';
            throw error;
        }
        if (response.status === STATUS_CODES.TOO_MANY_REQUESTS) {
            var error = new Error(response.statusText);
            error.response = response;
            error.detailedMessage = 'Please wait a few moments ...';
            throw error;
        }
    }
    /**
     * Action Creator: dispatch LOGIN_SUCCESS event
     */
    function loginSuccess(email) {
        return {
            type: LOGIN_SUCCESS,
            payload: { email: email },
        };
    }
    /**
     * Action Creator: dispatch LOGIN_FAILURE event
     */
    function loginFailure(error) {
        var _a, _b;
        return {
            type: LOGIN_FAILURE,
            payload: {
                status: (_a = error.response) === null || _a === void 0 ? void 0 : _a.status,
                statusText: (_b = error.response) === null || _b === void 0 ? void 0 : _b.statusText,
            },
        };
    }
    /**
     * Action Creator: dispatch LOGIN_REQUEST event
     */
    function loginRequest() {
        return {
            type: LOGIN_REQUEST,
        };
    }
    /**
     * Action Creator: dispatch LOGOUT event
     */
    function logout() {
        return {
            type: LOGOUT,
        };
    }
    /**
     * Send login request to the server (web-nav) then notify GTM the user is logged in.
     *
     * @param loginFormRequest - Login Parameters
     * @returns A promise, when resolved, will have the user logged in.
     */
    function sendLoginRequest(loginFormRequest) {
        return ApiService.post('/website-nav/web-api/v1/auth/login', loginFormRequest)
            .then(function (data) {
            setGTMLoggedIn();
            clearExperimentStorage();
            return data;
        })
            .then(function (data) { return identifyUserSailthru(loginFormRequest.email).then(function () { return data; }); })
            .catch(function (error) {
            checkWAFErrors(error);
            createError(error);
        });
    }
    /**
     * Send signup request to the server. Notify GTM the user is logged in
     */
    function sendSignupRequest(createUserRequest) {
        var businessUnit = detectBusinessUnit();
        var finalRequest = __assign(__assign({}, createUserRequest), { business_unit_source: businessUnit });
        return ApiService.post('/website-nav/web-api/v1/user/create', finalRequest)
            .then(function (data) {
            setAllStorage('zolaUserCreatedAt', new Date().toISOString());
            setGTMLoggedIn();
            var cookie = getCookie('pkey');
            if (cookie === '')
                cookie = null;
            trackUserCreated(createUserRequest.email, cookie);
            return data;
        })
            .then(function (data) { return identifyUserSailthru(finalRequest.email).then(function () { return data; }); })
            .catch(function (error) { return createError(error); });
    }
    /**
     * Send logout request to the server. Notify GTM the user is logged out
     */
    function sendSignOutRequest() {
        return ApiService.get('/website-nav/web-api/v1/auth/signout')
            .then(function () {
            setGTMLoggedOut();
        })
            .catch(function (error) { return createError(error); });
    }
    /**
     * Send reset password request to reset user password.
     *
     * @returns reset password callback
     */
    function sendResetPassword(email) {
        var createResetPasswordRequest = {
            email: email,
            expires_in_num_days: 1,
            send_email: true,
            business_unit: detectBusinessUnit(),
        };
        return ApiService.post('/website-nav/web-api/v1/user/reset_password', createResetPasswordRequest);
    }
    function sendFacebookLoginRequest(fbLoginRequest) {
        return ApiService.post('/website-nav/web-api/v1/auth/facebook-login', fbLoginRequest);
    }
    function sendAppleLoginRequest(appleLoginRequest) {
        return ApiService.post('/website-nav/web-api/v1/auth/apple-login', appleLoginRequest);
    }
    function send2FAResendRequest(resendCodeRequest) {
        return ApiService.post('/website-nav/web-api/v1/twoFA/resend', resendCodeRequest);
    }
    function send2FAVerifyRequest(verifyRequest) {
        return ApiService.post('/website-nav/web-api/v1/twoFA/verify', verifyRequest).catch(function (error) { return createError(error); });
    }
    function send2FAVerifyActionRequest(verifyRequest) {
        return ApiService.post('/website-nav/web-api/v1/twoFA/action/verify', verifyRequest).catch(function (error) { return createError(error); });
    }
    function send2FAResendActionRequest() {
        return ApiService.post('/website-nav/web-api/v1/twoFA/action/resend');
    }

    var initialState = {
        busy: false,
        userContext: {},
        partnerContext: [],
        hasIdentified: false,
        hasGuestIdentified: false,
    };
    var userReducer = function (state, action) {
        if (state === void 0) { state = initialState; }
        switch (action.type) {
            case REQUEST_PARTNER_STATUS:
            case REQUEST_USER: {
                return __assign(__assign({}, state), { busy: true });
            }
            case RECEIVE_USER: {
                return __assign(__assign({}, state), { busy: false, userContext: action.payload });
            }
            case IDENTIFY_USER: {
                return __assign(__assign({}, state), { hasIdentified: true });
            }
            case IDENTIFY_GUEST_USER: {
                return __assign(__assign({}, state), { hasGuestIdentified: true });
            }
            case RECEIVE_USER_STATUS: {
                var updatedUserContext = Object.assign({}, state.userContext, {
                    status: action.payload.status,
                });
                return Object.assign({}, state, { busy: false, userContext: updatedUserContext });
            }
            case RECEIVE_PARTNER_STATUS: {
                return __assign(__assign({}, state), { busy: false, partnerContext: action.payload });
            }
            default:
                return state;
        }
    };

    var parseQueryString = function (queryString, paramName, trimValue) {
        if (trimValue === void 0) { trimValue = true; }
        if (queryString.length > 1) {
            var queryStringParts = queryString.substring(1).split('&');
            for (var i = 0; i < queryStringParts.length; i += 1) {
                var partPair = queryStringParts[i].split('=');
                if (partPair[0] === paramName) {
                    var paramValue = decodeURIComponent(partPair[1]);
                    return trimValue ? paramValue.trim() : paramValue;
                }
            }
        }
        return '';
    };
    /**
     * get query param by name
     *
     * @param paramName - name of parameter to retrieve
     * @param trimValue - should trim string value
     */
    function getQueryParam(paramName, trimValue) {
        if (trimValue === void 0) { trimValue = true; }
        var queryString = window.location.search.trim();
        return parseQueryString(queryString, paramName, trimValue);
    }

    var defaultNegative = function () { return null; };
    /**
     * util for rendering jsx if conditional is met
     *
     * @param conditional - conditional to evaluate
     * @param affirmative - function to execute if conditional === true
     * @param negative - function to execute if conditional === false
     */
    function renderIf(conditional, affirmative, negative) {
        if (negative === void 0) { negative = defaultNegative; }
        return conditional ? affirmative() : negative();
    }

    var BUSINESS_UNIT = {
        INSPIRATION: 'INSPIRATION',
        INVITATIONS: 'INVITATIONS',
        DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATE',
        MARKETPLACE: 'MARKETPLACE',
        MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
        MARKETPLACE_VENDORS: 'MARKETPLACE_VENDORS',
        REAL_WEDDINGS: 'REAL_WEDDINGS',
        REGISTRY: 'REGISTRY',
        WEDDINGS: 'WEDDINGS',
        WEDDING_REGISTRY: 'WEDDING_REGISTRY',
        STORE: 'STORE',
        PHOTOBOOK: 'PHOTOBOOK',
    };
    var COMPONENT = {
        DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATE',
        CHANGE_THE_DATE: 'CHANGE_THE_DATE',
        DAY_OF_PAPER: 'DAY_OF_PAPER',
        FAVORITE: 'FAVORITE',
        HOLIDAY: 'HOLIDAY',
        WEDDING_SHOWER_INVITATION: 'WEDDING_SHOWER_INVITATION',
        INQUIRY: 'INQUIRY',
        INSPIRATION: 'INSPIRATION',
        INVITATIONS: 'INVITATIONS',
        MARKETPLACE: 'MARKETPLACE',
        MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
        MARKETPLACE_MATCH: 'MARKETPLACE_MATCH',
        MARKETPLACE_QUIZ: 'MARKETPLACE_QUIZ',
        MARKETPLACE_SIGNUP_BOOKED_VENDOR: 'SIGNUP_BOOKED_VENDOR',
        MARKETPLACE_SIGNUP_VALUE_PROP: 'SIGNUP_VALUE_PROP',
        REAL_WEDDINGS: 'REAL_WEDDINGS',
        REGISTRY: 'REGISTRY',
        SAVE_THE_DATE: 'SAVE_THE_DATE',
        THANK_YOU_CARDS: 'THANK_YOU_CARDS',
        WEDDINGS: 'WEDDINGS',
        WEDDING_CHECKLIST: 'WEDDING_CHECKLIST',
        WEDDING_GUEST_LIST: 'WEDDING_GUEST_LIST',
        WEDDING_PLANNING: 'WEDDING_PLANNING',
        WEDDING_WEBSITE: 'WEDDING_WEBSITE',
        // For marketplace vendors
        BANDS_DJS: 'BANDS_DJS',
        CAKES_DESSERTS: 'CAKES_DESSERTS',
        CATERING: 'CATERING',
        FLORIST: 'FLORIST',
        HAIR_MAKEUP: 'HAIR_MAKEUP',
        PHOTOGRAPHER: 'PHOTOGRAPHER',
        VENUE: 'VENUE',
        VIDEOGRAPHER: 'VIDEOGRAPHER',
        STORE: 'STORE',
        LOCATION_MODULE: 'LOCATION_MODULE',
        QUIZLET: 'QUIZLET',
        STYLE_QUIZ: 'STYLE_QUIZ',
        SIGNUP_SAVED_SEARCH: 'SIGNUP_SAVED_SEARCH',
        VENDOR_MARKETPLACE: 'VENDOR_MARKETPLACE',
        VENDOR_EXPERIENCE: 'VENDOR_EXPERIENCE',
    };
    var PLANNING_STAGE;
    (function (PLANNING_STAGE) {
        PLANNING_STAGE["NOT_ENGAGED"] = "NOT_ENGAGED";
        PLANNING_STAGE["NEWLY_ENGAGED"] = "NEWLY_ENGAGED";
        PLANNING_STAGE["PLANNING_NO_VENUE_BOOKED"] = "PLANNING_NO_VENUE_BOOKED";
        PLANNING_STAGE["PLANNING_VENUE_BOOKED"] = "PLANNING_VENUE_BOOKED";
        PLANNING_STAGE["ALMOST_DONE"] = "ALMOST_DONE";
    })(PLANNING_STAGE || (PLANNING_STAGE = {}));
    var onboardTrackingConstants = {
        BUSINESS_UNIT: BUSINESS_UNIT,
        COMPONENT: COMPONENT,
        PLANNING_STAGE: PLANNING_STAGE,
    };

    function trackOnboardingStarted(businessUnit, component, isExistingUser, onboardingFlowId, flowStepCount) {
        if (isExistingUser === void 0) { isExistingUser = null; }
        // isExistingUser used by some tags in GTM
        if (window.analytics && window.dataLayer) {
            window.dataLayer.push({ is_existing_user: isExistingUser });
        }
        var payload = {
            business_unit: businessUnit,
            component: component,
            onboarding_flow_id: onboardingFlowId,
            flow_step_count: flowStepCount,
        };
        trackEvent('Onboarding Started', payload);
    }
    function trackOnboardingCompleted(businessUnit, component, options, onboardingFlowId) {
        if (options === void 0) { options = {}; }
        var defaultOptions = {
            isExistingUser: null,
            weddingDate: null, // Should be 'YYYY-MM-DD' format.
        };
        var combinedOptions = Object.assign({}, defaultOptions, options);
        var isExistingUser = combinedOptions.isExistingUser, weddingDate = combinedOptions.weddingDate;
        // let { weddingDate } = combinedOptions;
        // Impact Radius should only receive Registry First Onboarding Completed events
        var registryFirst = businessUnit === 'WEDDING_REGISTRY' && !isExistingUser;
        var clickId = getAllStorage('clickId');
        var trackEventOptions = {
            integrations: {
                'Impact Radius': false,
            },
        };
        if (clickId && registryFirst) {
            trackEventOptions.context = {
                referrer: {
                    type: 'impactRadius',
                    id: clickId,
                },
            };
            trackEventOptions.integrations['Impact Radius'] = true;
        }
        // TODO: Decide if the moment.js library should exist in zola-helpers. Date param must be formatted correctly when passed in.
        // if (weddingDate) weddingDate = moment(weddingDate).format('YYYY-MM-DD');
        if (window.analytics && window.dataLayer) {
            window.dataLayer.push({ is_existing_user: isExistingUser, wedding_date: weddingDate });
        }
        var payload = {
            business_unit: businessUnit,
            component: component,
            onboarding_flow_id: onboardingFlowId,
        };
        logRocketTrack("".concat(businessUnit, "-").concat(component));
        trackEvent('Onboarding Completed', payload, trackEventOptions);
    }
    var trackOnboardingStepCompleted = function (businessUnit, component, stepKey, stepName, questionnaireVersion, stepUserResponse, onboardingFlowId) {
        var payload = {
            business_unit: businessUnit,
            component: component,
            step_key: stepKey,
            step_name: stepName,
            questionnaire_version: questionnaireVersion,
            onboarding_flow_id: onboardingFlowId,
        };
        if (stepUserResponse) {
            // To keep things backwards compatible
            payload.step_user_response = stepUserResponse;
        }
        trackEvent('Onboarding Step Completed', payload);
    };
    var trackOnboardingStepViewed = function (businessUnit, component, stepKey, stepName, questionnaireVersion, onboardingFlowId) {
        var payload = {
            business_unit: businessUnit,
            component: component,
            step_key: stepKey,
            step_name: stepName,
            questionnaire_version: questionnaireVersion,
            onboarding_flow_id: onboardingFlowId,
        };
        trackEvent('Onboarding Step Viewed', payload);
    };
    var trackOnboardingStepSkipped = function (businessUnit, component, stepKey, stepName, questionnaireVersion, onboardingFlowId) {
        var payload = {
            business_unit: businessUnit,
            component: component,
            step_key: stepKey,
            step_name: stepName,
            questionnaire_version: questionnaireVersion,
            onboarding_flow_id: onboardingFlowId,
        };
        trackEvent('Onboarding Step Skipped', payload);
    };

    /**
     * Load JavaScript from source
     * This helper comes from htmlScriptLoader.jsx in web-registry
     * src is a String, attributes is an Object
     */
    function loadSrc(src, attributes, callback) {
        var script = document.createElement('script');
        script.src = src;
        script.async = false;
        if (attributes) {
            var keys = Object.keys(attributes);
            keys.forEach(function (key) {
                var value = attributes[key];
                script.setAttribute(key, value.toString());
            });
        }
        script.onload = function () {
            if (typeof callback === 'function')
                callback();
        };
        document.body.appendChild(script);
    }

    // @ts-check
    (function (CtaType) {
        CtaType["BUTTON"] = "BUTTON";
        CtaType["CHECKOUT"] = "CHECKOUT";
        CtaType["DEEP_LINK"] = "DEEP_LINK";
        CtaType["ICON"] = "ICON";
        CtaType["IMAGE"] = "IMAGE";
        CtaType["MODULE"] = "MODULE";
        CtaType["LINK"] = "LINK";
        CtaType["MARKETING_MODULE"] = "MARKETING_MODULE";
        CtaType["MARKETING_MODULE_LARGE"] = "MARKETING_MODULE_LARGE";
        CtaType["SAMPLES_PREVIEW"] = "SAMPLES_PREVIEW";
        CtaType["SHOW_MORE"] = "SHOW_MORE";
        CtaType["STARTING_TOOLS"] = "STARTING_TOOLS";
        CtaType["TOGGLE"] = "TOGGLE";
        CtaType["SHARE"] = "SHARE";
    })(exports.CtaType || (exports.CtaType = {}));
    var CTA_TYPES = {
        BUTTON: exports.CtaType.BUTTON,
        CHECKOUT: exports.CtaType.CHECKOUT,
        DEEP_LINK: exports.CtaType.DEEP_LINK,
        ICON: exports.CtaType.ICON,
        IMAGE: exports.CtaType.IMAGE,
        MODULE: exports.CtaType.MODULE,
        LINK: exports.CtaType.LINK,
        MARKETING_MODULE: exports.CtaType.MARKETING_MODULE,
        MARKETING_MODULE_LARGE: exports.CtaType.MARKETING_MODULE_LARGE,
        SAMPLES_PREVIEW: exports.CtaType.SAMPLES_PREVIEW,
        SHOW_MORE: exports.CtaType.SHOW_MORE,
        STARTING_TOOLS: exports.CtaType.STARTING_TOOLS,
        TOGGLE: exports.CtaType.TOGGLE,
        SHARE: exports.CtaType.SHARE,
    };
    /**
     * @param eventData - Event data
     */
    function trackCtaClicked(eventData) {
        trackEvent('CTA Clicked', eventData);
    }
    /**
     * @param eventData - Event data
     */
    function trackCtaViewed(eventData) {
        trackEvent('CTA Viewed', eventData);
    }
    function trackCtaListViewed(eventData) {
        if (JSON.stringify(eventData.ctas).length > 1024) {
            // eslint-disable-next-line no-console
            console.debug('CTA List Viewed event is over the character limit.');
        }
        else {
            trackEvent('CTA List Viewed', eventData);
        }
    }

    var FlowTags = {
        /**
         * These tags are defined on the backend, nicely exposed as enumerations in
         * typescript. Programmatically defining this would be amazing, but unless they
         * are listed here, they seem to be compiled out of the built code.
         */
        GOLD: 'GOLD',
        SILVER: 'SILVER',
        STANDARD: 'STANDARD',
        // Tags from here down are defined in the FE apps, they don't have a corresponding
        // backend database table that defines them.
        FROM_INQUIRY: 'FROM_INQUIRY',
        FROM_FAVORITE: 'FROM_FAVORITE',
        UNREAD: 'UNREAD',
        READ: 'READ',
        INVITED_TO_INQUIRE: 'INVITED_TO_INQUIRE',
    };
    var FlowTagKeys = Object.keys(FlowTags);
    var isFlowTag = function (tag) { return FlowTagKeys.includes(tag); };
    var filterFlowTags = function (tags) { return tags.filter(isFlowTag); };

    /**
     * Helper to make sure the flog tags we are passing into the tracking db are
     * in the allowed list of tags.  If our apps were all 100% typescript, we wouldn't
     * need this, but as soon as one place calls trackFlowStarted or trackFlowCompleted
     * in JavaScript with a tag that isn't allow, then we've polluted our tracking
     * database forever.
     */
    var filterFlowPayload = function (payload) {
        return 'tags' in payload
            ? __assign(__assign({}, payload), { tags: filterFlowTags(payload.tags) }) : payload;
    };
    /**
     * Fire when a multi-step action is started.  This
     *
     */
    function trackFlowStarted(payload) {
        trackEvent('Flow Started', filterFlowPayload(payload));
    }
    function trackFlowCompleted(payload) {
        trackEvent('Flow Completed', filterFlowPayload(payload));
    }
    /**
     * Indicates that the step in the flow has been completed.  The flow step completed
     * events let us know where in a multi-step flow the user drops off.
     *
     * Note: this method must be sent to ensure correct funnel analysis of user behavior
     */
    function trackFlowStepCompleted(payload) {
        trackEvent('Flow Step Completed', payload);
    }
    /**
     * Note: this method is not used to analyze user drop-off. Be sure to send trackFlowStepCompleted
     *
     * @deprecated We are no longer using flow step viewed for analysis.
     */
    function trackFlowStepViewed(payload) {
        trackEvent('Flow Step Viewed', payload);
    }
    /**
     * When an optional step in the flow is skipped instead of completed, fire this.
     */
    function trackFlowStepSkipped(payload) {
        trackEvent('Flow Step Skipped', payload);
    }

    // /**
    /**
     * Gets the category for a product, if available.
     * Returns null if none is available.
     * @param {*} product the product
     */
    function getProductCategory(product) {
        var categoryChain = product.category_chain;
        if (categoryChain && categoryChain.length) {
            return categoryChain[categoryChain.length - 1];
        }
        return null;
    }
    var getFormattedProductProperties = function (product) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var quantityMultiplier = (_c = (_b = (_a = product === null || product === void 0 ? void 0 : product.product_look_views) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.sku_previews) === null || _c === void 0 ? void 0 : _c[0].quantity_multiplier;
        var name = product.display_name;
        var brand = (_d = product.brand) === null || _d === void 0 ? void 0 : _d.name;
        var price_cents = (_h = (_g = (_f = (_e = product === null || product === void 0 ? void 0 : product.product_look_views) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.sku_previews) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.price_cents;
        var price = typeof price_cents === 'number' && typeof quantityMultiplier === 'number'
            ? (price_cents * quantityMultiplier) / 100
            : undefined;
        var quantity = 1;
        var sku = (_k = (_j = product.product_look_views) === null || _j === void 0 ? void 0 : _j[0].sku_previews) === null || _k === void 0 ? void 0 : _k[0].id;
        var imageUrl = (_o = (_m = (_l = product.product_look_views) === null || _l === void 0 ? void 0 : _l[0].images) === null || _m === void 0 ? void 0 : _m[0].aspect_ratios) === null || _o === void 0 ? void 0 : _o['1x1'].medium;
        var category = getProductCategory(product);
        return {
            product_id: product.id,
            sku: sku,
            sku_id: sku,
            category: category === null || category === void 0 ? void 0 : category.name,
            name: name,
            brand: brand,
            variant: (_p = product.product_look_views) === null || _p === void 0 ? void 0 : _p[0].id,
            price: price,
            quantity: quantity,
            url: ((_q = product.product_look_views) === null || _q === void 0 ? void 0 : _q[0].key)
                ? "/shop/product/".concat((_r = product.product_look_views) === null || _r === void 0 ? void 0 : _r[0].key)
                : undefined,
            image_url: imageUrl,
        };
    };

    /*
      This file contains events from the Zola Web Analytics tracking plan related to shop products:
      'Product Added': https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=164175519
    */
    function trackProductAdded(eventData) {
        if (!eventData) {
            // eslint-disable-next-line no-console
            console.warn('Product Added event called with falsy value.');
            return;
        }
        if (Object.keys(eventData).length === 0)
            // eslint-disable-next-line no-console
            console.warn('Product Added event called without properties.');
        // if the brand is not defined - clear it on the GTM data layer becuase we check for it to determine if the product added is a cash gift.
        if (!eventData.brand && window.dataLayer && window.dataLayer.push) {
            window.dataLayer.push({
                brand: undefined,
            });
        }
        trackEvent('Product Added', eventData);
    }
    function trackProductListViewed(_a) {
        var products = _a.products, location = _a.location, section = _a.section;
        var productsTrackingData = products.map(function (product, index) {
            var _a = getFormattedProductProperties(product), product_id = _a.product_id, sku = _a.sku, category = _a.category, name = _a.name, brand = _a.brand, variant = _a.variant, price = _a.price, quantity = _a.quantity, url = _a.url, image_url = _a.image_url;
            return {
                product_id: product_id,
                sku_id: sku,
                category: category,
                name: name,
                brand: brand,
                variant: variant,
                price: price,
                quantity: quantity,
                position: index + 1,
                url: url,
                image_url: image_url,
            };
        });
        var trackingData = {
            location: location,
            section: section,
            products: productsTrackingData,
        };
        trackEvent('Product List Viewed', trackingData);
    }
    var trackProduct = function (eventType, _a) {
        var product = _a.product, position = _a.position, location = _a.location, section = _a.section, registry_id = _a.registry_id, recommendation_source = _a.recommendation_source, endpoint_variant = _a.endpoint_variant;
        var _b = getFormattedProductProperties(product), product_id = _b.product_id, sku = _b.sku, category = _b.category, name = _b.name, brand = _b.brand, variant = _b.variant, price = _b.price, quantity = _b.quantity, url = _b.url, image_url = _b.image_url;
        var payload = {
            registry_id: eventType === 'Clicked' ? registry_id : undefined,
            product_id: product_id,
            sku: sku,
            category: category,
            name: name,
            brand: brand,
            variant: variant,
            price: price,
            quantity: quantity,
            position: position,
            url: url,
            image_url: image_url,
            location: location,
            section: section,
            recommendation_source: recommendation_source,
            endpoint_variant: endpoint_variant,
        };
        trackEvent("Product ".concat(eventType), payload);
    };
    var trackProductViewed = function (eventProps) {
        trackProduct('Viewed', eventProps);
    };
    var trackProductClicked = function (eventProps) {
        trackProduct('Clicked', eventProps);
    };
    var trackProductDismissed = function (eventProps) {
        trackProduct('Dismissed', eventProps);
    };
    // TODO: Add additional eventProps as needed.
    /**
     * https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1421749706
     */
    var trackRegistryItemAdded = function (_a) {
        var product = _a.product, location = _a.location, section = _a.section, recommendation_source = _a.recommendation_source, endpoint_variant = _a.endpoint_variant;
        var _b = getFormattedProductProperties(product), sku = _b.sku, name = _b.name, brand = _b.brand, price = _b.price, quantity = _b.quantity, image_url = _b.image_url;
        trackEvent('Registry Item Added', {
            sku: sku,
            name: name,
            brand: brand,
            price: price,
            quantity: quantity,
            image_url: image_url,
            location: location,
            section: section,
            recommendation_source: recommendation_source,
            endpoint_variant: endpoint_variant,
        });
    };

    var isNotString = function (text) { return !text || typeof text !== 'string'; };

    /**
     * capitalize the first letter of a string, rest to lower
     *
     * @param str
     * @param lowerRest - lowerCase rest of string
     * @example
     * capitalizeFirst('some word') => 'Some word'
     */
    var capitalizeFirst = function (str, lowerRest) {
        if (lowerRest === void 0) { lowerRest = 0; }
        if (isNotString(str))
            return '';
        return "".concat(str[0].toUpperCase()).concat(lowerRest ? str.slice(1).toLowerCase() : str.slice(1));
    };

    /**
     * convert a string to pascal casing and treat - and _ as word delimiters
     *
     * @example
     * pascalize('some_snake_case') => 'SomeSnakeCase'
     * pascalize('some-pipe-case') => 'SomePipeCase'
     * pascalize('some word') => 'SomeWord'
     * pascalize('someCamelCase') => 'SomeCamelCase'
     */
    var pascalize = function (str) {
        if (isNotString(str))
            return '';
        return str
            .split(/[-_\s]/)
            .map(capitalizeFirst) // TODO: is this very clever or a bug?
            .join('');
    };

    /**
     * convert a string to camel casing and treat - and _ as word delimiters
     *
     * @example
     * camelize('some_snake_case') => 'someSnakeCase'
     * camelize('some-pipe-case') => 'somePipeCase'
     * camelize('some word') => 'someWord'
     * camelize('SomePascalCase') => 'somePascalCase'
     */
    var camelize = function (str) {
        if (isNotString(str))
            return '';
        var pascal = pascalize(str);
        return "".concat(pascal[0].toLowerCase()).concat(pascal.slice(1));
    };

    /**
     * capitalize all letters of a string
     *
     * @example
     * capitalizeAll('some word') => 'SOME WORD'
     */
    var capitalizeAll = function (str) {
        if (isNotString(str))
            return '';
        return str.toUpperCase();
    };

    /**
     * conditionally render the singular or plural of a noun
     *
     * @param singularForm - of word
     * @param pluralForm - of word
     * @param count
     * @param includeCount - whether to prepend the count
     * @returns either the singular or plural noun
     * @example
     * pluralize('product', 'products', 1, false) => '1 product'
     * pluralize('product', 'products', 4) => '4 products'
     * pluralize('product', 'products', 4, false) => 'products'
     */
    var pluralize = function (singularForm, pluralForm, count, includeCount) {
        if (includeCount === void 0) { includeCount = true; }
        var isSingular = count === 1 || count === -1;
        var form = isSingular ? singularForm : pluralForm;
        return includeCount ? "".concat(count, " ").concat(form) : form;
    };

    /**
     * remove a subString from a string
     *
     * @returns replacementStr
     * @example
     * removeSubString("There is no curse in Elvish, Entish, or the tongues of Orcs for this treachery.", "Orcs", "Men")  =>
     * 'There is no curse in Elvish, Entish, or the tongues of Men for this treachery.'
     */
    var removeSubString = function (str, subStrToRemove, replacementStr) {
        if (subStrToRemove === void 0) { subStrToRemove = ''; }
        if (replacementStr === void 0) { replacementStr = ''; }
        if (isNotString(str))
            return '';
        return str.replace(subStrToRemove, replacementStr).trim();
    };

    /**
     * truncate a string and add ellipses
     *
     * @param str - text string
     * @param length - # of characters to truncate to
     * @param ell - should append ellipses
     * @example
     * truncate("I thought up an ending for my book. 'And he lives happily ever after, till the end of his days.", 35, false) =>
     * 'I thought up an ending for my book.'
     */
    var truncate = function (str, length, ell) {
        if (ell === void 0) { ell = true; }
        if (isNotString(str))
            return '';
        var copyLength = length;
        if (str.length <= copyLength)
            return str;
        // Remove character if last character would be space
        if (str[length - 1] === ' ')
            copyLength -= 1;
        var string = str.substring(0, copyLength);
        return ell ? string.concat('…') : string;
    };

    var camelize$1 = camelize;
    var capitalizeAll$1 = capitalizeAll;
    var capitalizeFirst$1 = capitalizeFirst;
    var pascalize$1 = pascalize;
    var pluralize$1 = pluralize;
    var removeSubString$1 = removeSubString;
    var truncate$1 = truncate;

    // @ts-check
    /**
     * insert at index if conditional is met
     * const arr = [
     *  ...insertInArrayIf(boolean, { key: prop }),
     *  { key: prop },
     * ];
     *
     * @function insertInArrayIf
     * @param {string}  condition - boolean evaluation
     * @param {object[]} elements - the elements being added to the array
     * @returns {object[]}
     */
    function insertInArrayIf(condition) {
        var elements = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            elements[_i - 1] = arguments[_i];
        }
        return condition ? elements : [];
    }

    var MASSIVE_DESKTOP_MIN = 1920;
    var XL_DESKTOP_MAX = MASSIVE_DESKTOP_MIN - 1;
    var XL_DESKTOP_MIN = 1440;
    var LG_DESKTOP_MAX = XL_DESKTOP_MIN - 1;
    var LG_DESKTOP_MIN = 1200;
    var DESKTOP_MAX = LG_DESKTOP_MIN - 1;
    var DESKTOP_MIN = 992;
    var TABLET_MAX = DESKTOP_MIN - 1;
    var TABLET_MIN = 768;
    var MOBILE_MAX = TABLET_MIN - 1;
    var XS_MOBILE_MAX = 480;
    /**
     * @returns true when browser width <= 480px
     */
    function isXsMobile() {
        return window.matchMedia("(max-width: ".concat(XS_MOBILE_MAX, "px)")).matches;
    }
    /**
     * @returns true when browser width <= 767px
     */
    function isMobile() {
        return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 768px && browser width <= 991px
     */
    function isTablet() {
        return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px) and (max-width: ").concat(TABLET_MAX, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 992px
     */
    function isDesktop() {
        return window.matchMedia("(min-width: ".concat(DESKTOP_MIN, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 1200px
     */
    function isLargeDesktop() {
        return window.matchMedia("(min-width: ".concat(LG_DESKTOP_MIN, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 1440px
     */
    function isXlDesktop() {
        return window.matchMedia("(min-width: ".concat(XL_DESKTOP_MIN, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 1920px
     */
    function isMassiveDesktop() {
        return window.matchMedia("(min-width: ".concat(MASSIVE_DESKTOP_MIN, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 768px
     */
    function notMobile() {
        return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px)")).matches;
    }
    /**
     * @returns true when browser width >= 992px OR browser width <= 767px
     */
    function notTablet() {
        return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px), (min-width: ").concat(DESKTOP_MIN, "px)")).matches;
    }
    /**
     * @returns true when browser width < 992px
     */
    function notDesktop() {
        return window.matchMedia("(max-width: ".concat(TABLET_MAX, "px)")).matches;
    }
    /**
     * @returns true when browser width < 1200px
     */
    function notLargeDesktop() {
        return window.matchMedia("(max-width: ".concat(DESKTOP_MAX, "px)")).matches;
    }
    /**
     * @returns true when browser width < 1440px
     */
    function notXlDesktop() {
        return window.matchMedia("(max-width: ".concat(LG_DESKTOP_MAX, "px)")).matches;
    }
    /**
     * @returns true when browser width < 1920px
     */
    function notMassiveDesktop() {
        return window.matchMedia("(max-width: ".concat(XL_DESKTOP_MAX, "px)")).matches;
    }
    function isHighPixelDensity() {
        return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
    }
    /**
     * @returns true when the device supports hover
     */
    var canHover = function () {
        return window.matchMedia('(hover: hover)').matches;
    };

    /**
     * Return the next index in an array if it exists,
     * otherwise return 0. Commonly used in carousels.
     * @param {[]} arr input array
     * @param {number} index starting index
     */
    function nextIndex(arr, index) {
        if (index + 1 >= arr.length)
            return 0;
        return index + 1;
    }
    /**
     * Return the previous index in an array if it exists,
     * otherwise return the last index. Commonly used in carousels.
     * @param {[]} arr input array
     * @param {number} index starting index
     */
    function prevIndex(arr, index) {
        if (!arr[index] || index < 1)
            return arr.length - 1;
        return index - 1;
    }
    /**
     * Swap 2 elements in an array
     * @template T
     * @param {T[]} arr input array
     * @param {number} a index of first element to swap
     * @param {number} b index of second element to swap
     */
    function swapInPlace(arr, a, b) {
        if (arr[a] && arr[b]) {
            // eslint-disable-next-line no-param-reassign
            arr[a] = arr.splice(b, 1, arr[a])[0];
        }
    }
    /**
     * Jump an element to another spot in an array
     * @template T
     * @param {T[]} arr input array
     * @param {number} from index of second element to swap
     * @param {number} to index of first element to swap
     */
    function jumpInPlace(arr, from, to) {
        if (arr[from] && arr[to]) {
            arr.splice(to, 0, arr.splice(from, 1)[0]);
        }
    }

    /**
     * @see https://github.com/NewAmsterdamLabs/svc-user/blob/development/api/src/main/java/com/zola/userservice/api/user/AwarenessChannel.java
     */
    var userAwarenessChannelConstants;
    (function (userAwarenessChannelConstants) {
        userAwarenessChannelConstants["BLOGS_ARTICLES"] = "BLOGS_ARTICLES";
        userAwarenessChannelConstants["BOUGHT_GIFT"] = "BOUGHT_GIFT";
        userAwarenessChannelConstants["FACEBOOK"] = "FACEBOOK";
        userAwarenessChannelConstants["FRIEND_FAMILY"] = "FRIEND_FAMILY";
        userAwarenessChannelConstants["GOOGLE_SEARCH"] = "GOOGLE_SEARCH";
        userAwarenessChannelConstants["INFLUENCER"] = "INFLUENCER";
        userAwarenessChannelConstants["INSTAGRAM"] = "INSTAGRAM";
        userAwarenessChannelConstants["NEWS"] = "NEWS";
        userAwarenessChannelConstants["ONLINE_AD"] = "ONLINE_AD";
        userAwarenessChannelConstants["OTHER"] = "OTHER";
        userAwarenessChannelConstants["PINTEREST"] = "PINTEREST";
        userAwarenessChannelConstants["PODCAST"] = "PODCAST";
        userAwarenessChannelConstants["PUBLICATION"] = "PUBLICATION";
        userAwarenessChannelConstants["SUBWAY"] = "SUBWAY";
        userAwarenessChannelConstants["TIKTOK"] = "TIKTOK";
        userAwarenessChannelConstants["TV_COMMERCIAL"] = "TV_COMMERCIAL";
        userAwarenessChannelConstants["WEDDING_BLOG"] = "WEDDING_BLOG";
        userAwarenessChannelConstants["WEDDING_VENDOR"] = "WEDDING_VENDOR";
        userAwarenessChannelConstants["YOUTUBE"] = "YOUTUBE";
    })(userAwarenessChannelConstants || (userAwarenessChannelConstants = {}));
    var channels = userAwarenessChannelConstants;

    var getAwarenessChannelOptions = function (state) { return state.userAwareness.awarenessChannels; };
    var getAwarenessChannelOrder = function (state) { return state.userAwareness.randomAwarenessChannelsOrder; };
    var getSelectedAwarenessChannelsList = function (state) {
        return Object.entries(getAwarenessChannelOptions(state))
            .filter(function (_a) {
            var value = _a[1];
            return value;
        })
            .map(function (_a) {
            var key = _a[0];
            return key;
        });
    };
    var getChannelOtherText = function (state) { return state.userAwareness.channelOtherText; };
    var getChannelOtherState = function (state) {
        var isOtherSelected = getSelectedAwarenessChannelsList(state).indexOf(channels.OTHER) !== -1;
        var channelOtherText = getChannelOtherText(state);
        return isOtherSelected && channelOtherText !== '';
    };

    var userAwarenessSelectors = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getAwarenessChannelOptions: getAwarenessChannelOptions,
        getAwarenessChannelOrder: getAwarenessChannelOrder,
        getSelectedAwarenessChannelsList: getSelectedAwarenessChannelsList,
        getChannelOtherText: getChannelOtherText,
        getChannelOtherState: getChannelOtherState
    });

    var TOGGLE_CHANNEL_CHECKLED = 'zola/userAwareness/TOGGLE_CHANNEL_CHECKLED';
    var RESET_CHECKED_CHANNELS = 'zola/userAwareness/RESET_CHECKED_CHANNELS';
    var SET_CHANNEL_OTHER_TEXT = 'zola/userAwareness/SET_CHANNEL_OTHER_TEXT';
    // Actions
    var toggleChannelChecked = function (channel, isChecked) {
        return {
            type: TOGGLE_CHANNEL_CHECKLED,
            payload: {
                channel: channel,
                isChecked: isChecked,
            },
        };
    };
    var resetCheckedChannels = function () {
        return {
            type: RESET_CHECKED_CHANNELS,
        };
    };
    var setChannelOtherText = function (text) {
        return {
            type: SET_CHANNEL_OTHER_TEXT,
            payload: {
                channelOtherText: text,
            },
        };
    };

    var userAwarenessActions = /*#__PURE__*/Object.freeze({
        __proto__: null,
        TOGGLE_CHANNEL_CHECKLED: TOGGLE_CHANNEL_CHECKLED,
        RESET_CHECKED_CHANNELS: RESET_CHECKED_CHANNELS,
        SET_CHANNEL_OTHER_TEXT: SET_CHANNEL_OTHER_TEXT,
        toggleChannelChecked: toggleChannelChecked,
        resetCheckedChannels: resetCheckedChannels,
        setChannelOtherText: setChannelOtherText
    });

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
        length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    var _copyArray = copyArray;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeFloor = Math.floor,
      nativeRandom = Math.random;

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }
    var _baseRandom = baseRandom;

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
        length = array.length,
        lastIndex = length - 1;
      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = _baseRandom(index, lastIndex),
          value = array[rand];
        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }
    var _shuffleSelf = shuffleSelf;

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return _shuffleSelf(_copyArray(array));
    }
    var _arrayShuffle = arrayShuffle;

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return _shuffleSelf(values_1(collection));
    }
    var _baseShuffle = baseShuffle;

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray_1(collection) ? _arrayShuffle : _baseShuffle;
      return func(collection);
    }
    var shuffle_1 = shuffle;

    var sortOtherLast = function (first) {
        if (first === channels.OTHER)
            return 1;
        return -1;
    };
    var initialRandomAwarenessChannelsOrder = shuffle_1(Object.keys(channels)).sort(sortOtherLast);
    var initialAwarenessChannels = Object.keys(channels).reduce(function (acc, channel) {
        acc[channel] = false;
        return acc;
    }, {});
    var initialState$1 = {
        awarenessChannels: initialAwarenessChannels,
        randomAwarenessChannelsOrder: initialRandomAwarenessChannelsOrder,
        channelOtherText: '',
    };
    var userAwarenessReducer = function (state, action) {
        var _a;
        if (state === void 0) { state = initialState$1; }
        switch (action.type) {
            case TOGGLE_CHANNEL_CHECKLED:
                return __assign(__assign({}, state), { awarenessChannels: __assign(__assign({}, state.awarenessChannels), (_a = {}, _a[action.payload.channel] = action.payload.isChecked, _a)) });
            case RESET_CHECKED_CHANNELS:
                return __assign(__assign({}, state), { awarenessChannels: initialState$1.awarenessChannels });
            case SET_CHANNEL_OTHER_TEXT:
                return __assign(__assign({}, state), { channelOtherText: action.payload.channelOtherText });
            default:
                return state;
        }
    };

    // Action Types
    var SHOW_TOAST = 'zola/toasts/SHOW_TOAST';
    var HIDE_TOAST = 'zola/toasts/HIDE_TOAST';
    var CLEAR_TOASTS = 'zola/toasts/CLEAR_TOASTS';
    var ToastConstants;
    (function (ToastConstants) {
        ToastConstants["POSITIVE"] = "POSITIVE";
        ToastConstants["NEGATIVE"] = "NEGATIVE";
    })(ToastConstants || (ToastConstants = {}));

    var defaultToast = {
        headline: null,
        dek: null,
        type: null,
        autoDismissInSeconds: 3,
        dismissText: null,
        onDismiss: null,
        containerClass: null,
        className: null,
    };
    function show(opts, type) {
        if (opts === void 0) { opts = defaultToast; }
        if (type === void 0) { type = ToastConstants.POSITIVE; }
        var payload = Object.assign({}, defaultToast, opts, {
            id: new Date().valueOf(),
            type: type,
        });
        return {
            type: SHOW_TOAST,
            payload: payload,
        };
    }
    function positive(opts) {
        return show(opts, ToastConstants.POSITIVE);
    }
    function negative(opts) {
        return show(opts, ToastConstants.NEGATIVE);
    }
    function hide(id) {
        return {
            type: HIDE_TOAST,
            payload: id,
        };
    }
    function clear() {
        return { type: CLEAR_TOASTS };
    }

    var toastsActions = /*#__PURE__*/Object.freeze({
        __proto__: null,
        show: show,
        positive: positive,
        negative: negative,
        hide: hide,
        clear: clear
    });

    var initialState$2 = [];
    var toastsReducer = function (state, action) {
        if (state === void 0) { state = initialState$2; }
        switch (action.type) {
            case SHOW_TOAST:
                return __spreadArray(__spreadArray([], state, true), [action.payload], false);
            case HIDE_TOAST:
                return state.filter(function (toast) { return toast.id !== action.payload; });
            case CLEAR_TOASTS:
                return [];
            default:
                return state;
        }
    };

    /* eslint-disable no-bitwise */
    function hashStringToInt(str) {
        var hash = 0;
        var i;
        var chr;
        for (i = 0; i < str.length; i += 1) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return Math.abs(hash);
    }
    /* eslint-enable no-bitwise */

    function randomSeededArray(userId, arr) {
        var accumulator = {};
        // Create a map of the array at it's index values to replace in place later.
        var map = arr.reduce(function (acc, val, i) {
            acc[i] = val;
            return acc;
        }, accumulator);
        // Our new random array
        var shuffled = [];
        // We are not actually modifying the array so we maintain a proxy for the length.
        var length = arr.length;
        arr.forEach(function () {
            var userHash = hashStringToInt(md5(userId + length));
            var lastIndex = length - 1;
            var randomIndex = userHash % length;
            shuffled.push(map[randomIndex]);
            // Swap the random index with the number in the last index, so that it will not be selected again.
            map[randomIndex] = map[lastIndex];
            length -= 1;
        });
        return shuffled;
    }

    /**
     * If experiment logic to be determined server-side, use server/src/experiments.js
     */
    var NOT_IN_TEST = experimentStates.NOT_IN_TEST, CONTROL = experimentStates.CONTROL;
    /**
     * makes the environment-based defaults for a flag
     */
    var createExperimentFlags = function (development, staging, production) {
        if (development === void 0) { development = NOT_IN_TEST; }
        if (staging === void 0) { staging = NOT_IN_TEST; }
        if (production === void 0) { production = NOT_IN_TEST; }
        return {
            development: development,
            staging: staging,
            production: production,
        };
    };
    /**
     * Given an list of fallback variations for the flag, provide functions for
     * determining if a user is an experiment, in an A group, or in a B group.
     *
     * For simple A/B testing, where a user who is not in the test, is treated the
     * same as the control, you will only need to use `isUnderTest`.
     *
     * @param fallbackVariations
     * @example - A/B testing with the control and not-in-test treated the same
     *
     * // in your web-app-specific helper, define the flags.
     * // note, that if the default fallback for the flags are all NOT_IN_TEST, you can actually ommit
     * // the FALLBACK_VARIATIONS
     * // -- web-app/util/experimentFlags.js --
     * const FALLBACK_VARIATIONS = {
     * 'stanford-prison-experiment': experimentFlagsHelper.createExperimentFlags(NOT_IN_TEST, NOT_IN_TEST, NOT_IN_TEST),
     * };
     * export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
     *
     * // When you use the flags (in your web-app)
     * import { isUnderTest } from '~/util/experimentFlags`;
     * ...
     * const isUnderTest = experimentFlags.isUnderTest('stanford-prison-experiment', userContext);
     *
     * if (isUnderTest) {
     * ... user is in the B test (they are not control and they are in the experiment)
     * } else {
     * ... user is either the control or not in the test
     * }
     */
    var makeExperimentFlags = function (fallbackVariations) {
        var getFallbackVariation = function (flagOrExperimentName) {
            if (fallbackVariations[flagOrExperimentName]) {
                return fallbackVariations[flagOrExperimentName][getEnvironment()];
            }
            return NOT_IN_TEST;
        };
        /**
         * @param {string} experimentName
         *
         * returns override variation for a given experimentName, if set in localStorage
         * returns undefined, if no override set
         * @returns {ExperimentFlagsType | undefined}
         *
         * Note: never calls Custom Experiment Viewed event
         */
        var getOverrideVariation = function (experimentName) {
            var flagOverrides = getExperimentOverrides();
            return flagOverrides[experimentName];
        };
        /**
         * Returns the variation for the experiment / user / environment
         *
         * @example
         * getExperimentVariation('WEAR_A_MASK', userContext) => 'NOT_IN_TEST' // the user is not participating in the test
         * getExperimentVariation('WEAR_A_MASK', userContext) => 'TEST-0'      // the user is in the control group
         * getExperimentVariation('WEAR_A_MASK', userContext) => 'TEST-1'      // the user is in the first test group
         * getExperimentVariation('WEAR_A_MASK', userContext) => 'TEST-7'      // the user is in the seventh test group
         *
         * returns 'NOT_IN_TEST' if the user is not part of the experiment
         * returns 'TEST-0' if the user is in the control group
         * returns 'TEST-<N>' if the user is one of the test groups
         * @returns {string}
         */
        var getExperimentVariation = function (experimentName, userContext, triggerExperimentViewed) {
            if (triggerExperimentViewed === void 0) { triggerExperimentViewed = true; }
            var fallbackValue = getFallbackVariation(experimentName);
            if (getCookie('automatedTest')) {
                return NOT_IN_TEST;
            }
            // Return override only on dev & stage
            var isProduction = getEnvironment() === 'production';
            var overrideVariation = getOverrideVariation(experimentName);
            if (!isProduction && overrideVariation) {
                return overrideVariation;
            }
            return getUserExperimentVariation({
                experimentName: experimentName,
                userContext: userContext,
                fallbackValue: fallbackValue,
                triggerExperimentViewed: triggerExperimentViewed,
            });
        };
        var getFlag = function (experimentName, userContext) {
            return getExperimentVariation(experimentName, userContext, false) !== NOT_IN_TEST;
        };
        /**
         * Is the user in the experiement or not.  Being in the experiment you
         * are either control or a variant.  The alternative is that you aren't under
         * test.  If an experiement is setup as 100% in, 50% for control (a), 50% for
         * varient (b) then everybody is in the A/B test (isInExperiment is always true)
         */
        var isInExperiment = function (experimentKey, userContext, triggerExperimentViewed) {
            if (triggerExperimentViewed === void 0) { triggerExperimentViewed = true; }
            var experimentVariation = getExperimentVariation(experimentKey, userContext, triggerExperimentViewed);
            return experimentVariation !== NOT_IN_TEST;
        };
        /**
         * Is the user in the experiment and are they the control group
         */
        var isControl = function (experimentKey, userContext, triggerExperimentViewed) {
            if (triggerExperimentViewed === void 0) { triggerExperimentViewed = true; }
            return getExperimentVariation(experimentKey, userContext, triggerExperimentViewed) === CONTROL;
        };
        /**
         * Is the in the experiment and are they _not_ the control group.
         * If you have more than one variant (ie, and A/B/C test) instead
         * of a single variant (classic A/B test) you will need to check
         * the getExperimentVariation directly as you would have values such
         * as NOT_IN_TEST, TEST-0, TEST-1, and TEST-2.
         */
        var isUnderTest = function (experimentKey, userContext, triggerExperimentViewed) {
            if (triggerExperimentViewed === void 0) { triggerExperimentViewed = true; }
            var variant = getExperimentVariation(experimentKey, userContext, triggerExperimentViewed);
            return variant !== CONTROL && variant !== NOT_IN_TEST;
        };
        return {
            getFlag: getFlag,
            getExperimentVariation: getExperimentVariation,
            isInExperiment: isInExperiment,
            isControl: isControl,
            isUnderTest: isUnderTest,
        };
    };
    var experimentFlagsHelper = {
        makeExperimentFlags: makeExperimentFlags,
        createExperimentFlags: createExperimentFlags,
        experimentStates: experimentStates,
    };

    // @ts-check
    /**
     * Generate the error ID
     *
     * @returns {string}
     */
    var generateErrorId = function () { return new Date().getTime().toString(32).toUpperCase(); };
    /**
     * Log an error message with the Zola logger in Admin
     *
     * @param {string} errorMessage General error message
     * @param {object} payload Any additonal info to pass to the logger. Will accept any JSON object
     * @returns {string}
     */
    var log = function (errorMessage, payload) {
        var errorId = generateErrorId();
        var errorMeta = {
            id: errorId,
            message: errorMessage,
        };
        var body = {
            meta: errorMeta,
            data: payload,
        };
        // Don't wait for the response since there's not much we can do if it fails
        ApiService.post("/api/v0/log/".concat(errorId), body).catch(function () { return null; });
        // Return the error id to display for the user in case they contact CS
        return errorId;
    };
    var logService = {
        log: log,
    };

    /**
     *  MODAL
     */
    var OPEN_MODAL_EVENT = 'OPEN_MODAL_EVENT';
    var MODAL_TYPE_CART = 'CART_MODAL';
    var MODAL_TYPE_AUTH = 'AUTH';
    var MODAL_TYPE_PUBLISH_REGISTRY = 'PUBLISH_REGISTRY';
    var MODAL_TYPE_SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
    var MODAL_TYPE_SHIPPING_EXCLUSION = 'SHIPPING_EXCLUSION';
    var MODAL_TYPE_BOOKING_STATUS_REMINDER = 'BOOKING_STATUS_REMINDER';
    var MODAL_TYPE_TWOFA_ACTION = 'TWOFA_ACTION';
    // NOTE: Dispatched from 'Public Registry (web-registry)'
    var PUBLIC_REGISTRY_EVENT = 'PUBLIC_REGISTRY_EVENT';
    /**
     *  NAV V2
     */
    var NAV_LOADED = 'NAV_LOADED';
    /**
     * Custom event payload for indicating that a jewel should be shown on a menu item
     * in the nav. Cab be dispatched by web-** apps
     *
     * @example
     *   window.dispatchEvent(
     *     new CustomEvent<NavJewelEventPayload>(
     *       NAV_JEWEL_CUSTOM_EVENT,
     *       {
     *         detail: { showVendorsJewel: true }
     *       }
     *     )
     *   )
     */
    var NAV_JEWEL_CUSTOM_EVENT = 'NAV_JEWEL_CUSTOM_EVENT';
    /**
     * Custom event triggered when navigation data is available from a web-product
     * (marketplace/registry/wedding/etc) and the navigation menu needs to know about it
     *
     *
     * @example
     *     window.dispatchEvent(
     *       new CustomEvent(INIT_NAV_DATA, {
     *        detail: {
     *          secondaryData,
     *          userContext,
     *          activePrimaryLink,
     *          activeSecondaryLink,
     *        },
     *      })
     *    );
     *
     * @example
     *    window.dispatchEvent(
     *      new CustomEvent<InitNavDataEventPayload>(INIT_NAV_DATA, {
     *        detail: {
     *          secondaryData,
     *          userContext,
     *          activePrimaryLink,
     *          activeSecondaryLink,
     *        },
     *      })
     *    );
     *
     *  */
    var INIT_NAV_DATA = 'INIT_NAV_DATA';
    var NAV_PRIMARY_RENDERED = 'NAV_PRIMARY_RENDERED';
    var NAV_SECONDARY_RENDERED = 'NAV_SECONDARY_RENDERED';
    /**
     * Constants used in web-nav to segment feature flag toggles by product
     */
    var FeatureFlagsProductType;
    (function (FeatureFlagsProductType) {
        FeatureFlagsProductType["WEB_MARKETPLACE"] = "MARKETPLACE";
        FeatureFlagsProductType["WEB_NAV"] = "NAV";
        FeatureFlagsProductType["WEB_WEDDING"] = "WEDDING";
        FeatureFlagsProductType["WEB_REGISTRY"] = "REGISTRY";
        FeatureFlagsProductType["WEB_STORE"] = "STORE";
        FeatureFlagsProductType["WEB_PRE_AUTH"] = "PRE_AUTH";
    })(FeatureFlagsProductType || (FeatureFlagsProductType = {}));
    /**
     * Custom event for signaling that feature flags are available
     *
     * Custom Event should provide a payload of type FeatureFlagsAvailableEventPayload
     *
     * @example
     *    window.dispatchEvent(
     *      new CustomEvent(FEATURE_FLAGS_AVAILABLE, {
     *        detail: {
     *          domain: FeatureFlagProductType.MARKETPLACE,
     *          flags: [
     *             'best-feature-ever': { value: true, production: false, staging: true, development: false }
     *          ]
     *        },
     *      })
     *    );
     *
     * @example
     *    window.dispatchEvent(
     *      new CustomEvent<FeatureFlagsAvailableEventPayload>(FEATURE_FLAGS_AVAILABLE, {
     *        detail: featureFlagAvailablePayload,
     *      })
     *    );
     *
     */
    var FEATURE_FLAGS_AVAILABLE = 'FEATURE_FLAGS_AVAILABLE';
    var PrimaryNavIdentifier;
    (function (PrimaryNavIdentifier) {
        PrimaryNavIdentifier["ACCOUNT"] = "account";
        PrimaryNavIdentifier["ADVICE"] = "advice";
        PrimaryNavIdentifier["ADVISOR"] = "advisor";
        PrimaryNavIdentifier["ALBUMS"] = "albums";
        PrimaryNavIdentifier["BUDGET"] = "budget";
        PrimaryNavIdentifier["CAREERS"] = "careers";
        PrimaryNavIdentifier["CHECKLIST"] = "checklist";
        PrimaryNavIdentifier["COMMUNITY"] = "community";
        PrimaryNavIdentifier["FAVORITES"] = "favorites";
        PrimaryNavIdentifier["GUEST_LIST"] = "guestList";
        PrimaryNavIdentifier["HELP"] = "help";
        PrimaryNavIdentifier["OUR_STORY"] = "ourStory";
        PrimaryNavIdentifier["PAPER"] = "invites";
        PrimaryNavIdentifier["PRESS"] = "press";
        PrimaryNavIdentifier["REAL_WEDDINGS"] = "realWeddings";
        PrimaryNavIdentifier["REFER_A_FRIEND"] = "referAFriend";
        PrimaryNavIdentifier["REGISTRY"] = "registry";
        PrimaryNavIdentifier["RETURN_POLICY"] = "returnPolicy";
        PrimaryNavIdentifier["REVIEWS"] = "reviews";
        PrimaryNavIdentifier["SEATING"] = "seating";
        PrimaryNavIdentifier["TERMS_OF_USE"] = "termsOfUse";
        PrimaryNavIdentifier["TRACK_ORDER"] = "trackOrder";
        PrimaryNavIdentifier["VENDORS"] = "vendors";
        PrimaryNavIdentifier["WEB_ACCESSIBILITY"] = "webAccessibility";
        PrimaryNavIdentifier["WEBSITE"] = "website";
        PrimaryNavIdentifier["WEDDING_BOUTIQUE"] = "weddingBoutique";
        PrimaryNavIdentifier["YOUR_WEDDING"] = "yourWedding";
    })(PrimaryNavIdentifier || (PrimaryNavIdentifier = {}));
    var SecondaryNavIdentifier;
    (function (SecondaryNavIdentifier) {
        // REGISTRY
        SecondaryNavIdentifier["YOUR_REGISTRY"] = "your-registry";
        SecondaryNavIdentifier["NEW_ARRIVALS"] = "new-arrivals";
        SecondaryNavIdentifier["COLLECTIONS"] = "collections";
        SecondaryNavIdentifier["BRANDS"] = "brands";
        SecondaryNavIdentifier["EXPERIENCES"] = "experiences";
        SecondaryNavIdentifier["CASH_FUNDS"] = "cash-funds";
        SecondaryNavIdentifier["SALE"] = "sale";
        SecondaryNavIdentifier["REGISTRY_OVERVIEW"] = "registry-overview";
        SecondaryNavIdentifier["MANAGE_REGISTRY"] = "manage-registry";
        SecondaryNavIdentifier["CHECKLIST"] = "checklist";
        SecondaryNavIdentifier["GIFT_TRACKER"] = "gift-tracker";
        SecondaryNavIdentifier["ADD_GIFTS"] = "add-gifts";
        SecondaryNavIdentifier["POST_WEDDING_SHOP"] = "post-wedding-shop";
        // PAPER
        SecondaryNavIdentifier["DISNEY"] = "disney";
        SecondaryNavIdentifier["DAY_OF"] = "day-of-paper";
        SecondaryNavIdentifier["INVITATION"] = "invitations";
        SecondaryNavIdentifier["SAVE_THE_DATE"] = "save-the-date";
        SecondaryNavIdentifier["MATCHING_SUITES"] = "matching-suits";
        SecondaryNavIdentifier["DIGITAL_SAVE_THE_DATE"] = "digital-save-the-date";
        SecondaryNavIdentifier["CHANGE_THE_DATE"] = "change-the-date";
        SecondaryNavIdentifier["PLACE"] = "place-cards";
        SecondaryNavIdentifier["TABLE_NUMBER"] = "table-number";
        SecondaryNavIdentifier["THANK_YOU"] = "thank-you-cards";
        SecondaryNavIdentifier["MENU"] = "menus";
        SecondaryNavIdentifier["DETAILS"] = "enclosures";
        SecondaryNavIdentifier["PROGRAM"] = "programs";
        SecondaryNavIdentifier["HOLIDAY"] = "holiday-cards";
        SecondaryNavIdentifier["FREE_SAMPLES"] = "free-samples";
        SecondaryNavIdentifier["PROJECTS"] = "projects";
        SecondaryNavIdentifier["WEDDING_SHOWER_INVITATION"] = "wedding-shower";
        SecondaryNavIdentifier["PAPER_DRAFTS_AND_ORDERS"] = "paper-drafts-and-orders";
        SecondaryNavIdentifier["PAPER_SHOP"] = "paper-shop";
        SecondaryNavIdentifier["PAPER_ADD_ONS"] = "paper-add-ons";
        SecondaryNavIdentifier["DIY"] = "diy-cards";
        // GUEST_LIST
        SecondaryNavIdentifier["ALL_GUESTS"] = "guests";
        SecondaryNavIdentifier["EVENTS"] = "events";
        SecondaryNavIdentifier["BUILD"] = "build";
        SecondaryNavIdentifier["ENVELOPES"] = "envelopes";
        SecondaryNavIdentifier["TRACK_RSVPS"] = "rsvp-overview";
        SecondaryNavIdentifier["RSVP_REQUESTS"] = "rsvp-notifications";
        SecondaryNavIdentifier["SEATING"] = "seating";
        SecondaryNavIdentifier["SUPER_LINK"] = "super-link";
        // WEBSITE
        SecondaryNavIdentifier["MANAGE"] = "manange";
        SecondaryNavIdentifier["EDIT"] = "edit";
        SecondaryNavIdentifier["DESIGNS"] = "designs";
        SecondaryNavIdentifier["CUSTOMIZE"] = "customize";
        SecondaryNavIdentifier["BUDGET"] = "budget";
        // MARKETPLACE
        SecondaryNavIdentifier["EXPLORE_VENDORS"] = "marketplace-vendors";
        SecondaryNavIdentifier["VENDOR_CONNECTIONS"] = "marketplace-connections";
        SecondaryNavIdentifier["BOOKED_VENDORS"] = "marketplace-booked-vendors";
        SecondaryNavIdentifier["BECOME_VENDOR"] = "marketplace-become-vendor";
        SecondaryNavIdentifier["REAL_WEDDINGS"] = "real-weddings";
        SecondaryNavIdentifier["WEDDING_VENUES"] = "marketplace-wedding-venues";
        // FAVORITES
        SecondaryNavIdentifier["YOUR_FAVORITES"] = "your-favorites";
        // ALBUMS
        SecondaryNavIdentifier["ALBUMS_DRAFTS"] = "DRAFTS";
        SecondaryNavIdentifier["ALBUMS_SHOP"] = "SHOP";
        SecondaryNavIdentifier["ALBUMS_CLASSIC"] = "CLASSIC";
        SecondaryNavIdentifier["ALBUMS_PREMIER"] = "PREMIER";
        SecondaryNavIdentifier["ALBUMS_DELUXE"] = "DELUXE";
    })(SecondaryNavIdentifier || (SecondaryNavIdentifier = {}));
    var TertiaryNavIdentifier;
    (function (TertiaryNavIdentifier) {
        // GUEST_LIST
        TertiaryNavIdentifier["MANAGE_GUEST_LIST"] = "manage-guest-list";
        TertiaryNavIdentifier["INVITE_GUESTS"] = "invite-guests";
        TertiaryNavIdentifier["ADDRESS_ENVELOPES"] = "address-envelopes";
        TertiaryNavIdentifier["TRACK_RSVPS"] = "track-rsvps";
        // MARKETPLACE
        TertiaryNavIdentifier["VENUES"] = "wedding-venues";
        TertiaryNavIdentifier["PHOTOGRAPHERS"] = "wedding-photographers";
        TertiaryNavIdentifier["VIDEOGRAPHERS"] = "wedding-videographers";
        TertiaryNavIdentifier["CATERING"] = "wedding-catering";
        TertiaryNavIdentifier["FLORISTS"] = "wedding-florists";
        TertiaryNavIdentifier["HAIR_MAKEUP"] = "wedding-hair-makeup";
        TertiaryNavIdentifier["PLANNERS"] = "wedding-planners";
        TertiaryNavIdentifier["BANDS_DJS"] = "wedding-bands-djs";
        TertiaryNavIdentifier["CAKES_DESSERTS"] = "wedding-cakes-desserts";
        TertiaryNavIdentifier["BAR_SERVICES"] = "wedding-bar-services";
        // PAPER
        TertiaryNavIdentifier["COLLECTIONS_PAPER"] = "collections-paper";
        TertiaryNavIdentifier["SAVE_THE_DATE"] = "save-the-date";
        TertiaryNavIdentifier["CHANGE_THE_DATE"] = "change-the-date";
        TertiaryNavIdentifier["INVITATIONS"] = "invitations";
        TertiaryNavIdentifier["WEDDING_SHOWER_INVITATION"] = "wedding-shower-invitation";
        TertiaryNavIdentifier["ENCLOSURE"] = "enclosure";
        TertiaryNavIdentifier["MENU"] = "menu";
        TertiaryNavIdentifier["PROGRAM"] = "program";
        TertiaryNavIdentifier["PLACE"] = "place";
        TertiaryNavIdentifier["DAY_OF"] = "day-of";
        TertiaryNavIdentifier["THANK_YOUS"] = "thank-yous";
        TertiaryNavIdentifier["DIGITAL_SAVE_THE_DATE"] = "digital-save-the-date";
        TertiaryNavIdentifier["ALBUMS"] = "albums";
        TertiaryNavIdentifier["HOLIDAY"] = "holiday";
        TertiaryNavIdentifier["PAPER_ADD_ONS"] = "paper-add-ons";
        TertiaryNavIdentifier["BELLY_BANDS"] = "belly-bands";
        TertiaryNavIdentifier["VELLUM_JACKETS"] = "vellum-jackets";
        TertiaryNavIdentifier["WAX_SEALS"] = "wax-seals";
        TertiaryNavIdentifier["DIY"] = "diy-cards";
        TertiaryNavIdentifier["FREE_SAMPLES"] = "free-samples";
        // REGISTRY
        TertiaryNavIdentifier["NEW_REGISTRY"] = "new-registry";
        TertiaryNavIdentifier["COLLECTIONS_REGISTRY"] = "collections-registry";
        TertiaryNavIdentifier["BRANDS"] = "brands";
        TertiaryNavIdentifier["KITCHEN"] = "kitchen";
        TertiaryNavIdentifier["TABLETOP"] = "tabletop";
        TertiaryNavIdentifier["BED_BATH"] = "bed-bath";
        TertiaryNavIdentifier["FURNITURE"] = "furniture";
        TertiaryNavIdentifier["HOME"] = "home";
        TertiaryNavIdentifier["WEEKEND"] = "weekend";
        TertiaryNavIdentifier["EXPERIENCES"] = "experiences";
        TertiaryNavIdentifier["CASH_FUNDS"] = "cash-funds";
        // BOUTIQUE
        TertiaryNavIdentifier["NEW_BOUTIQUE"] = "new-boutique";
        TertiaryNavIdentifier["BRIDAL"] = "bridal";
        TertiaryNavIdentifier["WEDDING_PARTY"] = "wedding-party";
        TertiaryNavIdentifier["ACCESSORIES"] = "accessories";
        TertiaryNavIdentifier["JEWELRY"] = "jewelry";
        TertiaryNavIdentifier["PARTY_SUPPLIES_DECOR"] = "party-supplies-decor";
        TertiaryNavIdentifier["GIFTS_FAVORS"] = "gifts-favors";
        TertiaryNavIdentifier["INTIMATES"] = "intimates";
        TertiaryNavIdentifier["BEAUTY_WELLNESS"] = "beauty-wellness";
    })(TertiaryNavIdentifier || (TertiaryNavIdentifier = {}));
    var NAV_DATA = {
        PRIMARY: {
            REGISTRY: PrimaryNavIdentifier.REGISTRY,
            WEBSITE: PrimaryNavIdentifier.WEBSITE,
            PAPER: PrimaryNavIdentifier.PAPER,
            ALBUMS: PrimaryNavIdentifier.ALBUMS,
            GUEST_LIST: PrimaryNavIdentifier.GUEST_LIST,
            WEDDING_BOUTIQUE: PrimaryNavIdentifier.WEDDING_BOUTIQUE,
            ADVICE: PrimaryNavIdentifier.ADVICE,
            VENDORS: PrimaryNavIdentifier.VENDORS,
            ACCOUNT: PrimaryNavIdentifier.ACCOUNT,
            COMMUNITY: PrimaryNavIdentifier.COMMUNITY,
            FAVORITES: PrimaryNavIdentifier.FAVORITES,
            BUDGET: PrimaryNavIdentifier.BUDGET,
            CAREERS: PrimaryNavIdentifier.CAREERS,
            CHECKLIST: PrimaryNavIdentifier.CHECKLIST,
            HELP: PrimaryNavIdentifier.HELP,
            OUR_STORY: PrimaryNavIdentifier.OUR_STORY,
            PRESS: PrimaryNavIdentifier.PRESS,
            REAL_WEDDINGS: PrimaryNavIdentifier.REAL_WEDDINGS,
            SEATING: PrimaryNavIdentifier.SEATING,
            YOUR_WEDDING: PrimaryNavIdentifier.YOUR_WEDDING,
            REFER_A_FRIEND: PrimaryNavIdentifier.REFER_A_FRIEND,
            REVIEWS: PrimaryNavIdentifier.REVIEWS,
            TRACK_ORDER: PrimaryNavIdentifier.TRACK_ORDER,
            RETURN_POLICY: PrimaryNavIdentifier.RETURN_POLICY,
            TERMS_OF_USE: PrimaryNavIdentifier.TERMS_OF_USE,
            WEB_ACCESSIBILITY: PrimaryNavIdentifier.WEB_ACCESSIBILITY,
        },
        SECONDARY: {
            REGISTRY: {
                YOUR_REGISTRY: SecondaryNavIdentifier.YOUR_REGISTRY,
                NEW_ARRIVALS: SecondaryNavIdentifier.NEW_ARRIVALS,
                COLLECTIONS: SecondaryNavIdentifier.COLLECTIONS,
                BRANDS: SecondaryNavIdentifier.BRANDS,
                EXPERIENCES: SecondaryNavIdentifier.EXPERIENCES,
                CASH_FUNDS: SecondaryNavIdentifier.CASH_FUNDS,
                SALE: SecondaryNavIdentifier.SALE,
                REGISTRY_OVERVIEW: SecondaryNavIdentifier.REGISTRY_OVERVIEW,
                MANAGE_REGISTRY: SecondaryNavIdentifier.MANAGE_REGISTRY,
                CHECKLIST: SecondaryNavIdentifier.CHECKLIST,
                GIFT_TRACKER: SecondaryNavIdentifier.GIFT_TRACKER,
            },
            PAPER: {
                INVITATION: SecondaryNavIdentifier.INVITATION,
                SAVE_THE_DATE: SecondaryNavIdentifier.SAVE_THE_DATE,
                DIGITAL_SAVE_THE_DATE: SecondaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
                PLACE: SecondaryNavIdentifier.PLACE,
                TABLE_NUMBER: SecondaryNavIdentifier.TABLE_NUMBER,
                THANK_YOU: SecondaryNavIdentifier.THANK_YOU,
                MENU: SecondaryNavIdentifier.MENU,
                DETAILS: SecondaryNavIdentifier.DETAILS,
                PROGRAM: SecondaryNavIdentifier.PROGRAM,
                HOLIDAY: SecondaryNavIdentifier.HOLIDAY,
                FREE_SAMPLES: SecondaryNavIdentifier.FREE_SAMPLES,
                PROJECTS: SecondaryNavIdentifier.PROJECTS,
                YOUR_FAVORITES: SecondaryNavIdentifier.YOUR_FAVORITES,
                MATCHING_SUITES: SecondaryNavIdentifier.MATCHING_SUITES,
                WEDDING_SHOWER_INVITATION: SecondaryNavIdentifier.WEDDING_SHOWER_INVITATION,
                PAPER_DRAFTS_AND_ORDERS: SecondaryNavIdentifier.PAPER_DRAFTS_AND_ORDERS,
                PAPER_SHOP: SecondaryNavIdentifier.PAPER_SHOP,
                PAPER_ADD_ONS: SecondaryNavIdentifier.PAPER_ADD_ONS,
            },
            GUEST_LIST: {
                ALL_GUESTS: SecondaryNavIdentifier.ALL_GUESTS,
                EVENTS: SecondaryNavIdentifier.EVENTS,
                BUILD: SecondaryNavIdentifier.BUILD,
                ENVELOPES: SecondaryNavIdentifier.ENVELOPES,
                TRACK_RSVPS: SecondaryNavIdentifier.TRACK_RSVPS,
                RSVP_REQUESTS: SecondaryNavIdentifier.RSVP_REQUESTS,
                SEATING: SecondaryNavIdentifier.SEATING,
                SUPER_LINK: SecondaryNavIdentifier.SUPER_LINK,
            },
            WEBSITE: {
                MANAGE: SecondaryNavIdentifier.MANAGE,
                EDIT: SecondaryNavIdentifier.EDIT,
                CUSTOMIZE: SecondaryNavIdentifier.CUSTOMIZE,
                DESIGNS: SecondaryNavIdentifier.DESIGNS,
                BUDGET: SecondaryNavIdentifier.BUDGET,
            },
            MARKETPLACE: {
                EXPLORE_VENDORS: SecondaryNavIdentifier.EXPLORE_VENDORS,
                VENDOR_CONNECTIONS: SecondaryNavIdentifier.VENDOR_CONNECTIONS,
                BOOKED_VENDORS: SecondaryNavIdentifier.BOOKED_VENDORS,
                BECOME_VENDOR: SecondaryNavIdentifier.BECOME_VENDOR,
                REAL_WEDDINGS: SecondaryNavIdentifier.REAL_WEDDINGS,
                WEDDING_VENUES: SecondaryNavIdentifier.WEDDING_VENUES,
                YOUR_FAVORITES: SecondaryNavIdentifier.YOUR_FAVORITES,
            },
            ALBUMS: {
                DRAFTS: SecondaryNavIdentifier.ALBUMS_DRAFTS,
                SHOP: SecondaryNavIdentifier.ALBUMS_SHOP,
                CLASSIC: SecondaryNavIdentifier.ALBUMS_CLASSIC,
                PREMIER: SecondaryNavIdentifier.ALBUMS_PREMIER,
                DELUXE: SecondaryNavIdentifier.ALBUMS_DELUXE,
            },
        },
        TERTIARY: {
            GUEST_LIST: {
                MANAGE_GUEST_LIST: TertiaryNavIdentifier.MANAGE_GUEST_LIST,
                INVITE_GUESTS: TertiaryNavIdentifier.INVITE_GUESTS,
                ADDRESS_ENVELOPES: TertiaryNavIdentifier.ADDRESS_ENVELOPES,
                TRACK_RSVPS: TertiaryNavIdentifier.TRACK_RSVPS,
            },
            MARKETPLACE: {
                VENUES: TertiaryNavIdentifier.VENUES,
                PHOTOGRAPHERS: TertiaryNavIdentifier.PHOTOGRAPHERS,
                VIDEOGRAPHERS: TertiaryNavIdentifier.VIDEOGRAPHERS,
                CATERING: TertiaryNavIdentifier.CATERING,
                FLORISTS: TertiaryNavIdentifier.FLORISTS,
                HAIR_MAKEUP: TertiaryNavIdentifier.HAIR_MAKEUP,
                PLANNERS: TertiaryNavIdentifier.PLANNERS,
                BANDS_DJS: TertiaryNavIdentifier.BANDS_DJS,
                CAKES_DESSERTS: TertiaryNavIdentifier.CAKES_DESSERTS,
                BAR_SERVICES: TertiaryNavIdentifier.BAR_SERVICES,
            },
            PAPER: {
                COLLECTIONS_PAPER: TertiaryNavIdentifier.COLLECTIONS_PAPER,
                SAVE_THE_DATE: TertiaryNavIdentifier.SAVE_THE_DATE,
                INVITATIONS: TertiaryNavIdentifier.INVITATIONS,
                WEDDING_SHOWER_INVITATION: TertiaryNavIdentifier.WEDDING_SHOWER_INVITATION,
                ENCLOSURE: TertiaryNavIdentifier.ENCLOSURE,
                MENU: TertiaryNavIdentifier.MENU,
                PROGRAM: TertiaryNavIdentifier.PROGRAM,
                PLACE: TertiaryNavIdentifier.PLACE,
                DAY_OF: TertiaryNavIdentifier.DAY_OF,
                THANK_YOUS: TertiaryNavIdentifier.THANK_YOUS,
                DIGITAL_SAVE_THE_DATE: TertiaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
                ALBUMS: TertiaryNavIdentifier.ALBUMS,
                HOLIDAY: TertiaryNavIdentifier.HOLIDAY,
            },
            REGISTRY: {
                NEW_REGISTRY: TertiaryNavIdentifier.NEW_REGISTRY,
                COLLECTIONS_REGISTRY: TertiaryNavIdentifier.COLLECTIONS_REGISTRY,
                BRANDS: TertiaryNavIdentifier.BRANDS,
                KITCHEN: TertiaryNavIdentifier.KITCHEN,
                TABLETOP: TertiaryNavIdentifier.TABLETOP,
                BED_BATH: TertiaryNavIdentifier.BED_BATH,
                FURNITURE: TertiaryNavIdentifier.FURNITURE,
                HOME: TertiaryNavIdentifier.HOME,
                WEEKEND: TertiaryNavIdentifier.WEEKEND,
                EXPERIENCES: TertiaryNavIdentifier.EXPERIENCES,
                CASH_FUNDS: TertiaryNavIdentifier.CASH_FUNDS,
            },
            BOUTIQUE: {
                NEW_BOUTIQUE: TertiaryNavIdentifier.NEW_BOUTIQUE,
                BRIDAL: TertiaryNavIdentifier.BRIDAL,
                WEDDING_PARTY: TertiaryNavIdentifier.WEDDING_PARTY,
                ACCESSORIES: TertiaryNavIdentifier.ACCESSORIES,
                JEWELRY: TertiaryNavIdentifier.JEWELRY,
                PARTY_SUPPLIES_DECOR: TertiaryNavIdentifier.PARTY_SUPPLIES_DECOR,
                GIFTS_FAVORS: TertiaryNavIdentifier.GIFTS_FAVORS,
                INTIMATES: TertiaryNavIdentifier.INTIMATES,
                BEAUTY_WELLNESS: TertiaryNavIdentifier.BEAUTY_WELLNESS,
            },
        },
        EVENTS: {
            OPEN_MODAL_EVENT: OPEN_MODAL_EVENT,
            MODAL_TYPE_CART: MODAL_TYPE_CART,
            MODAL_TYPE_AUTH: MODAL_TYPE_AUTH,
            MODAL_TYPE_PUBLISH_REGISTRY: MODAL_TYPE_PUBLISH_REGISTRY,
            MODAL_TYPE_SET_SHIPPING_ADDRESS: MODAL_TYPE_SET_SHIPPING_ADDRESS,
            MODAL_TYPE_SHIPPING_EXCLUSION: MODAL_TYPE_SHIPPING_EXCLUSION,
            MODAL_TYPE_BOOKING_STATUS_REMINDER: MODAL_TYPE_BOOKING_STATUS_REMINDER,
            MODAL_TYPE_TWOFA_ACTION: MODAL_TYPE_TWOFA_ACTION,
            NAV_LOADED: NAV_LOADED,
            INIT_NAV_DATA: INIT_NAV_DATA,
            PUBLIC_REGISTRY_EVENT: PUBLIC_REGISTRY_EVENT,
            NAV_PRIMARY_RENDERED: NAV_PRIMARY_RENDERED,
            NAV_SECONDARY_RENDERED: NAV_SECONDARY_RENDERED,
            FEATURE_FLAGS_AVAILABLE: FEATURE_FLAGS_AVAILABLE,
            NAV_JEWEL_CUSTOM_EVENT: NAV_JEWEL_CUSTOM_EVENT,
        },
    };

    /** Where feature flag overrides get set in session storage */
    var FEATURE_FLAG_OVERRIDES = 'zola_feature_flag_overrides';
    /**
     * Gets a lookup of feature flag overrides from session storage
     *
     * @memberof client
     *
     * @returns {EnvironmentFlagOverride} - Lookup of overriden feature flags.
     */
    var getFeatureFlagOverrides = function () {
        try {
            return JSON.parse(getSessionStorage(FEATURE_FLAG_OVERRIDES) || '') || {};
        }
        catch (_a) {
            deleteSessionStorage(FEATURE_FLAG_OVERRIDES);
        }
        return {};
    };
    /**
     * Sets a feature flag override in session stroage
     *
     * @param {string} featureFlag - Name of the feature flag to override
     * @param {boolean} overrideValue - Value to set for the feature flag
     *
     * @memberof client
     * @returns {void}
     */
    var setFeatureFlagOverride = function (featureFlag, overrideValue) {
        if (!featureFlag)
            return;
        var overrides = getFeatureFlagOverrides();
        overrides[featureFlag] = overrideValue;
        setSessionStorage(FEATURE_FLAG_OVERRIDES, JSON.stringify(overrides));
    };
    /**
     * Creates an feature flag with fields for each environment
     *
     * @param {boolean} development
     * @param {boolean} staging
     * @param {boolean} production
     *
     * @returns {EnvironmentFlag}
     */
    var createEnvironmentFlags = function (development, staging, production) {
        if (development === void 0) { development = false; }
        if (staging === void 0) { staging = false; }
        if (production === void 0) { production = false; }
        return ({
            development: development,
            staging: staging,
            production: production,
        });
    };
    var environment = getEnvironment();
    /**
     * Gets the feature flag for the current environment.
     *
     * @param {FeatureFlags} flags - lookup of feature flags
     * @param {string} flag - flag to lookup
     *
     * @returns {boolean}
     */
    var getFlag = function (flags, flag) {
        if (flags[flag]) {
            var overriddenFlags = getFeatureFlagOverrides();
            if (overriddenFlags[flag] !== undefined) {
                return Boolean(overriddenFlags[flag]);
            }
            return Boolean(flags[flag][environment]);
        }
        return false;
    };
    var FEATURE_FLAGS_AVAILABLE$1 = NAV_DATA.EVENTS.FEATURE_FLAGS_AVAILABLE;
    /**
     * Publishes a set of feature flags, making them available for overrides
     * using the zola-ui feature flags component.
     *
     * @param flags
     */
    var publishFeatureFlagOverrides = function (productFeatureFlags, domain) {
        var flagSettings = Object.keys(productFeatureFlags).reduce(function (result, flag) {
            var _a;
            var flagSetting = __assign({ value: getFlag(productFeatureFlags, flag) }, productFeatureFlags[flag]);
            return __assign(__assign({}, result), (_a = {}, _a[flag] = flagSetting, _a));
        }, {});
        var featureFlagAvailablePayload = {
            domain: domain,
            flags: flagSettings,
        };
        window.dispatchEvent(new CustomEvent(FEATURE_FLAGS_AVAILABLE$1, {
            detail: featureFlagAvailablePayload,
        }));
    };

    function convertCurrencyFormat(amount, currency, minimumFractionDigits, maximumFractionDigits) {
        if (currency === void 0) { currency = 'USD'; }
        if (minimumFractionDigits === void 0) { minimumFractionDigits = 0; }
        if (maximumFractionDigits === void 0) { maximumFractionDigits = 0; }
        var maximumFractionCheck = minimumFractionDigits > maximumFractionDigits ? minimumFractionDigits : maximumFractionDigits;
        return amount.toLocaleString('en', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionCheck,
        });
    }

    /**
     * Enable or disable the users ability to scroll on the page
     */
    var lockPageScroll = function () {
        var rootEl = document.querySelector('html');
        var bodyEl = document.querySelector('body');
        if (rootEl && bodyEl) {
            var styles = {
                overflow: 'hidden',
                position: 'relative',
            };
            Object.assign(rootEl.style, styles);
            Object.assign(bodyEl.style, styles);
        }
    };
    var unlockPageScroll = function () {
        var rootEl = document.querySelector('html');
        var bodyEl = document.querySelector('body');
        if (rootEl && bodyEl) {
            rootEl.removeAttribute('style');
            bodyEl.removeAttribute('style');
        }
    };

    /**
     * Helper to generate a AccountSettingsLink from the slug/text and to set the
     * active flag based on the current page.
     *
     * @param slug
     * @param text
     * @param currentPage
     *
     * @returns AccountSettingsLink
     */
    var linkFor = function (slug, text, currentPage) {
        return {
            slug: slug,
            text: text,
            active: slug === currentPage,
            href: "/account/settings/".concat(slug),
        };
    };
    /**
     * Gets the meta-data for the account settings nav.  Returns an ordered set of
     * sections, each with a heading and number of links.  The sections are user
     * specific.
     *
     * @param userContext
     * @param featureFlags When you need a feature flagged account link add it as an
     * optional indexed string here then set the flag from the client
     *
     * https://github.com/NewAmsterdamLabs/zola-helpers/pull/222/files#diff-507a53cd596542e43d6c5be92daf71b1be0a45cff5d1de46840d81b3240ec32cR90-R92
     * ```typescript
     *   featureFlags?: { 'invites-from-vendors'?: boolean; }
     * ```
     *
     * https://github.com/NewAmsterdamLabs/web-registry/commit/16d4f94f01785b95ab52d3b422ceb80c0d9a3218#diff-058476176f5598d5d09414b07b301803777ee44bdbbcba78af0d0d4711cb7885R21-R23
     * ```typescript
     * const accountMenu = getAccountSettingsNav(userContext as UserContext, page, {
     *   'invites-from-vendors': featureFlags.get('invitesFromVendors'),
     * });
     *
     * @param currentPage
     * @returns
     */
    var getAccountSettingsNav = function (userContext, currentPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    featureFlags) {
        var isAccountOwner = get_1(userContext, 'user_role_account_weddings[0].role', null) === 'OWNER';
        var hasRegistryAccount = Boolean(userContext.has_registry);
        var hasWeddingAccount = Boolean(userContext.has_wedding_account);
        var hasCompletedOnboarding = Boolean(userContext.has_completed_onboarding);
        var hasMarketplaceAccount = Boolean(userContext.has_marketplace_account);
        var sections = [];
        var accountSection = {
            heading: 'Your account',
            links: [
                linkFor('info', 'Information', currentPage),
                linkFor('orders', "Orders you've placed", currentPage),
                linkFor('reviews', 'Ratings and reviews', currentPage),
                linkFor('credits', 'Zola store credit', currentPage),
                linkFor('notifications', 'Email preferences', currentPage),
                linkFor('password-security', 'Password & security', currentPage),
            ],
        };
        if (hasMarketplaceAccount) {
            accountSection.links.push(linkFor('hellos-from-vendors', 'Hellos from vendors', currentPage));
        }
        sections.push(accountSection);
        if (hasCompletedOnboarding) {
            var weddingSection = {
                heading: 'Your wedding',
                links: [linkFor('wedding', 'Wedding details', currentPage)],
            };
            if (isAccountOwner && (hasWeddingAccount || hasRegistryAccount)) {
                weddingSection.links.push(linkFor('invitepartner', 'Invite partner', currentPage));
            }
            if (hasRegistryAccount) {
                weddingSection.links.push(linkFor('shipping', 'Registry shipping address', currentPage));
                weddingSection.links.push(linkFor('bank', 'Bank account info', currentPage));
                weddingSection.links.push(linkFor('cash', 'Cash fund fee', currentPage));
                weddingSection.links.push(linkFor('other-registries', 'Other registries', currentPage));
            }
            sections.push(weddingSection);
            if (hasRegistryAccount || hasWeddingAccount) {
                sections.push({
                    heading: 'Your settings',
                    links: [linkFor('urls', 'URLs', currentPage), linkFor('privacy', 'Privacy', currentPage)],
                });
            }
        }
        return sections;
    };

    var _a$1;
    /**
     * Map that associates a vendor taxonomy key with an object of vendor words
     */
    var vendorWords = (_a$1 = {},
        _a$1[ACCESSORIES_TAXONOMY_KEY] = {
            singular: 'accessories',
            plural: 'accessories',
            instance: 'accessories',
            tracking: 'ACCESSORIES',
            category: 'Accessories',
            pill: 'Accessories',
        },
        _a$1[ACCOMMODATIONS_TAXONOMY_KEY] = {
            singular: 'accommodations',
            plural: 'accommodations',
            instance: 'accommodations',
            tracking: 'ACCOMMODATIONS',
            category: 'Accommodations',
            pill: 'Accommodations',
        },
        _a$1[ALTERATIONS_PRESERVATION_TAXONOMY_KEY] = {
            singular: 'alterations',
            plural: 'alterations',
            instance: 'alterations',
            tracking: 'ALTERATIONS_PRESERVATION',
            category: 'Alterations & Preservation',
            pill: 'Alterations',
        },
        _a$1[BANDS_DJS_TAXONOMY_KEY] = {
            singular: 'musician',
            plural: 'musicians',
            instance: 'a musician',
            tracking: 'MUSICIAN_DJ',
            category: 'Bands & DJs',
            pill: 'Bands and DJs',
        },
        _a$1[BAR_SERVICES_TAXONOMY_KEY] = {
            singular: 'bar services & beverages',
            plural: 'bar services & beverages',
            instance: 'bar services & beverages',
            tracking: 'BAR_SERVICES',
            category: 'Bar Services & Beverages',
            pill: 'Bar and beverage',
        },
        _a$1[BRIDAL_SHOPS_TAXONOMY_KEY] = {
            singular: 'bridal shop',
            plural: 'bridal shops',
            instance: 'a bridal shop',
            tracking: 'BRIDAL_SHOP',
            category: 'Bridal Shops',
            pill: 'Bridal shops',
        },
        _a$1[CAKES_DESSERTS_TAXONOMY_KEY] = {
            singular: 'baker',
            plural: 'bakers',
            instance: 'a baker',
            tracking: 'BAKER',
            category: 'Cakes & Desserts',
            pill: 'Cakes and desserts',
        },
        _a$1[CATERING_TAXONOMY_KEY] = {
            singular: 'caterer',
            plural: 'caterers',
            instance: 'a caterer',
            tracking: 'CATERER',
            category: 'Catering',
            pill: 'Catering',
        },
        _a$1[CELEBRANTS_OFFICIANTS_TAXONOMY_KEY] = {
            singular: 'officiant',
            plural: 'officiants',
            instance: 'an officiant',
            tracking: 'CELEBRANT_OFFICIANT',
            category: 'Celebrants & Officiants',
            pill: 'Officiants',
        },
        _a$1[CHILDCARE_SERVICES_TAXONOMY_KEY] = {
            singular: 'childcare services',
            plural: 'childcare services',
            instance: 'childcare services',
            tracking: 'CHILDCARE_SERVICES',
            category: 'Childcare Services',
            pill: 'Childcare services',
        },
        _a$1[CLOTHING_RENTALS_TAXONOMY_KEY] = {
            singular: 'attire rentals',
            plural: 'attire rentals',
            instance: 'attire rentals',
            tracking: 'ATTIRE',
            category: 'Clothing Rentals',
            pill: 'Clothing rentals',
        },
        _a$1[FLORISTS_TAXONOMY_KEY] = {
            singular: 'florist',
            plural: 'florists',
            instance: 'a florist',
            tracking: 'FLORIST',
            category: 'Florists',
            pill: 'Florists',
        },
        _a$1[GENERAL_SERVICES_TAXONOMY_KEY] = {
            singular: 'general services',
            plural: 'general services',
            instance: 'general services',
            tracking: 'GENERAL_SERVICES',
            category: 'General Services',
            pill: 'General services',
        },
        _a$1[GIFT_FAVORS_TAXONOMY_KEY] = {
            singular: 'gifts & favors',
            plural: 'gifts & favors',
            instance: 'gifts & favors',
            tracking: 'GIFTS_FAVORS',
            category: 'Gifts & Favors',
            pill: 'Gifts and favors',
        },
        _a$1[HAIR_MAKEUP_TAXONOMY_KEY] = {
            singular: 'beauty professional',
            plural: 'beauty professionals',
            instance: 'a beauty professional',
            tracking: 'HAIR_MAKEUP',
            category: 'Beauty Professionals',
            pill: 'Beauty',
        },
        _a$1[INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY] = {
            singular: 'calligrapher',
            plural: 'calligraphers',
            instance: 'a calligrapher',
            tracking: 'CALLIGRAPHER',
            category: 'Calligraphers',
            pill: 'Calligraphers',
        },
        _a$1[JEWELERS_TAXONOMY_KEY] = {
            singular: 'jewelry',
            plural: 'jewelry',
            instance: 'a jeweler',
            tracking: 'JEWELER',
            category: 'Jewelers',
            pill: 'Jewelers',
        },
        _a$1[LIGHTING_AV_TAXONOMY_KEY] = {
            singular: 'lighting',
            plural: 'lighting',
            instance: 'lighting',
            tracking: 'LIGHTING_AV',
            category: 'Lighting & AV',
            pill: 'Lighting and AV',
        },
        _a$1[PHOTOBOOTHS_TAXONOMY_KEY] = {
            singular: 'photo booth',
            plural: 'photo booths',
            instance: 'a photo booth',
            tracking: 'PHOTO_BOOTH',
            category: 'Photo Booths',
            pill: 'Photo booths',
        },
        _a$1[PHOTOGRAPHERS_TAXONOMY_KEY] = {
            singular: 'photographer',
            plural: 'photographers',
            instance: 'a photographer',
            tracking: 'PHOTOGRAPHER',
            category: 'Photographers',
            pill: 'Photographers',
        },
        _a$1[PLANNERS_TAXONOMY_KEY] = {
            singular: 'planner',
            plural: 'planners',
            instance: 'a wedding planner',
            tracking: 'PLANNER',
            category: 'Planners',
            pill: 'Planners',
        },
        _a$1[SERVICE_STAFF_TAXONOMY_KEY] = {
            singular: 'service staff',
            plural: 'service staff',
            instance: 'service staff',
            tracking: 'SERVICE_STAFF',
            category: 'Service Staff',
            pill: 'Service staff',
        },
        _a$1[RENTALS_DECOR_TAXONOMY_KEY] = {
            singular: 'decor',
            plural: 'decor',
            instance: 'decor',
            tracking: 'RENTAL_DECOR',
            category: 'Rentals & Decor',
            pill: 'Rentals and decor',
        },
        _a$1[TRANSPORTATION_PROVIDERS_TAXONOMY_KEY] = {
            singular: 'transportation',
            plural: 'transportation',
            instance: 'transportation',
            tracking: 'TRANSPORTATION',
            category: 'Transportation',
            pill: 'Transportation',
        },
        _a$1[VARIETY_ACTS_TAXONOMY_KEY] = {
            singular: 'entertainment',
            plural: 'entertainment',
            instance: 'entertainment',
            tracking: 'VARIETY_ACT',
            category: 'Variety Acts',
            pill: 'Variety acts',
        },
        _a$1[VENUES_TAXONOMY_KEY] = {
            singular: 'venue',
            plural: 'venues',
            instance: 'a venue',
            tracking: 'VENUE',
            category: 'Venues',
            pill: 'Venues',
        },
        _a$1[VIDEOGRAPHERS_TAXONOMY_KEY] = {
            singular: 'videographer',
            plural: 'videographers',
            instance: 'a videographer',
            tracking: 'VIDEOGRAPHER',
            category: 'Videographers',
            pill: 'Videographers',
        },
        _a$1);
    var defaultVendorWords = {
        singular: 'vendor',
        plural: 'vendors',
        instance: 'a vendor',
        tracking: 'VENDOR',
        category: 'Vendors',
        pill: 'Vendors',
    };
    var getVendorWords = function (vendorTaxonomyKey) {
        if (!vendorTaxonomyKey) {
            return defaultVendorWords;
        }
        return getVendorTaxonomySwitchFunc(vendorWords)(vendorTaxonomyKey);
    };
    /**
     * Get the singular name for a vendor category
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The singular name
     */
    var getVendorWordSingular = function (categoryString) {
        return getVendorWords(getVendorTaxonomyKey(categoryString)).singular;
    };
    /**
     * Get the plural name for a vendor category
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The plural name
     */
    var getVendorWordPlural = function (categoryString) {
        return getVendorWords(getVendorTaxonomyKey(categoryString)).plural;
    };
    /**
     * Get a phrase for an instance for a vendor category
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns A phrase for an instance, e.g. "a photographer"
     */
    var getVendorWordInstance = function (categoryString) {
        return getVendorWords(getVendorTaxonomyKey(categoryString)).instance;
    };
    /**
     * Get the capitalized category name for a vendor category
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The capitalized category name
     */
    var getVendorWordCategory = function (categoryString) {
        return getVendorWords(getVendorTaxonomyKey(categoryString)).category;
    };
    /**
     * Get the short-form category name for a vendor category
     *
     * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
     * @returns The short-form category name
     */
    var getVendorWordPill = function (categoryString) {
        return getVendorWords(getVendorTaxonomyKey(categoryString)).pill;
    };

    exports.ACCESSORIES_TAXONOMY_KEY = ACCESSORIES_TAXONOMY_KEY;
    exports.ACCOMMODATIONS_TAXONOMY_KEY = ACCOMMODATIONS_TAXONOMY_KEY;
    exports.ALTERATIONS_PRESERVATION_TAXONOMY_KEY = ALTERATIONS_PRESERVATION_TAXONOMY_KEY;
    exports.ApiService = ApiService;
    exports.BANDS_DJS_TAXONOMY_KEY = BANDS_DJS_TAXONOMY_KEY;
    exports.BAR_SERVICES_TAXONOMY_KEY = BAR_SERVICES_TAXONOMY_KEY;
    exports.BRIDAL_SHOPS_TAXONOMY_KEY = BRIDAL_SHOPS_TAXONOMY_KEY;
    exports.CAKES_DESSERTS_TAXONOMY_KEY = CAKES_DESSERTS_TAXONOMY_KEY;
    exports.CATERING_TAXONOMY_KEY = CATERING_TAXONOMY_KEY;
    exports.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY = CELEBRANTS_OFFICIANTS_TAXONOMY_KEY;
    exports.CHILDCARE_SERVICES_TAXONOMY_KEY = CHILDCARE_SERVICES_TAXONOMY_KEY;
    exports.CLOTHING_RENTALS_TAXONOMY_KEY = CLOTHING_RENTALS_TAXONOMY_KEY;
    exports.CTA_TYPES = CTA_TYPES;
    exports.DESKTOP_MAX = DESKTOP_MAX;
    exports.DESKTOP_MIN = DESKTOP_MIN;
    exports.FLORISTS_TAXONOMY_KEY = FLORISTS_TAXONOMY_KEY;
    exports.GENERAL_SERVICES_TAXONOMY_KEY = GENERAL_SERVICES_TAXONOMY_KEY;
    exports.GIFT_FAVORS_TAXONOMY_KEY = GIFT_FAVORS_TAXONOMY_KEY;
    exports.HAIR_MAKEUP_TAXONOMY_KEY = HAIR_MAKEUP_TAXONOMY_KEY;
    exports.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY = INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY;
    exports.JEWELERS_TAXONOMY_KEY = JEWELERS_TAXONOMY_KEY;
    exports.LG_DESKTOP_MAX = LG_DESKTOP_MAX;
    exports.LG_DESKTOP_MIN = LG_DESKTOP_MIN;
    exports.LIGHTING_AV_TAXONOMY_KEY = LIGHTING_AV_TAXONOMY_KEY;
    exports.LogService = logService;
    exports.MASSIVE_DESKTOP_MIN = MASSIVE_DESKTOP_MIN;
    exports.MOBILE_MAX = MOBILE_MAX;
    exports.ONBOARDABLE_VENDOR_TAXONOMY_KEYS = ONBOARDABLE_VENDOR_TAXONOMY_KEYS;
    exports.OVERRIDES_KEY = OVERRIDES_KEY;
    exports.PHOTOBOOTHS_TAXONOMY_KEY = PHOTOBOOTHS_TAXONOMY_KEY;
    exports.PHOTOGRAPHERS_TAXONOMY_KEY = PHOTOGRAPHERS_TAXONOMY_KEY;
    exports.PLANNERS_TAXONOMY_KEY = PLANNERS_TAXONOMY_KEY;
    exports.RENTALS_DECOR_TAXONOMY_KEY = RENTALS_DECOR_TAXONOMY_KEY;
    exports.SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS = SEARCHABLE_TOP_LEVEL_VENDOR_TAXONOMY_KEYS;
    exports.SEARCHABLE_VENDOR_TAXONOMY_KEYS = SEARCHABLE_VENDOR_TAXONOMY_KEYS;
    exports.SERVICE_STAFF_TAXONOMY_KEY = SERVICE_STAFF_TAXONOMY_KEY;
    exports.STATUS_CODES = STATUS_CODES;
    exports.TABLET_MAX = TABLET_MAX;
    exports.TABLET_MIN = TABLET_MIN;
    exports.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY = TRANSPORTATION_PROVIDERS_TAXONOMY_KEY;
    exports.VARIETY_ACTS_TAXONOMY_KEY = VARIETY_ACTS_TAXONOMY_KEY;
    exports.VENDOR_TAXONOMY_KEYS = VENDOR_TAXONOMY_KEYS;
    exports.VENUES_TAXONOMY_KEY = VENUES_TAXONOMY_KEY;
    exports.VIDEOGRAPHERS_TAXONOMY_KEY = VIDEOGRAPHERS_TAXONOMY_KEY;
    exports.XL_DESKTOP_MAX = XL_DESKTOP_MAX;
    exports.XL_DESKTOP_MIN = XL_DESKTOP_MIN;
    exports.XS_MOBILE_MAX = XS_MOBILE_MAX;
    exports.camelize = camelize$1;
    exports.canHover = canHover;
    exports.capitalizeAll = capitalizeAll$1;
    exports.capitalizeFirst = capitalizeFirst$1;
    exports.checkWAFErrors = checkWAFErrors;
    exports.clearExperimentStorage = clearExperimentStorage;
    exports.convertCurrencyFormat = convertCurrencyFormat;
    exports.createEnvironmentFlags = createEnvironmentFlags;
    exports.deleteAllStorage = deleteAllStorage;
    exports.deleteCookie = deleteCookie;
    exports.deleteLocalStorage = deleteLocalStorage;
    exports.deleteSessionStorage = deleteSessionStorage;
    exports.detectAndroid = detectAndroid;
    exports.detectIOS = detectIOS;
    exports.detectMobileDevice = detectMobileDevice;
    exports.detectTouchScreen = detectTouchScreen;
    exports.experimentFlagsHelper = experimentFlagsHelper;
    exports.experimentStates = experimentStates;
    exports.getAccountSettingsNav = getAccountSettingsNav;
    exports.getAllStorage = getAllStorage;
    exports.getBusinessCategory = getBusinessCategory;
    exports.getCookie = getCookie;
    exports.getDetailedMessage = getDetailedMessage;
    exports.getExperimentOverrides = getExperimentOverrides;
    exports.getFeatureFlagOverrides = getFeatureFlagOverrides;
    exports.getFlag = getFlag;
    exports.getLocalStorage = getLocalStorage;
    exports.getMobileOperatingSystem = getMobileOperatingSystem;
    exports.getPageContext = getPageContext;
    exports.getQueryParam = getQueryParam;
    exports.getRecommendedBookingWindow = getRecommendedBookingWindow;
    exports.getSessionStorage = getSessionStorage;
    exports.getUserExperimentVariation = getUserExperimentVariation;
    exports.getVendorTaxonomyId = getVendorTaxonomyId;
    exports.getVendorTaxonomyKey = getVendorTaxonomyKey;
    exports.getVendorTaxonomyKeyFromId = getVendorTaxonomyKeyFromId;
    exports.getVendorTaxonomyKeyFromVendorType = getVendorTaxonomyKeyFromVendorType;
    exports.getVendorTaxonomySwitchFunc = getVendorTaxonomySwitchFunc;
    exports.getVendorType = getVendorType;
    exports.getVendorWordCategory = getVendorWordCategory;
    exports.getVendorWordInstance = getVendorWordInstance;
    exports.getVendorWordPill = getVendorWordPill;
    exports.getVendorWordPlural = getVendorWordPlural;
    exports.getVendorWordSingular = getVendorWordSingular;
    exports.getVendorWords = getVendorWords;
    exports.hasTriggeredExperiment = hasTriggeredExperiment;
    exports.insertInArrayIf = insertInArrayIf;
    exports.isDesktop = isDesktop;
    exports.isHighPixelDensity = isHighPixelDensity;
    exports.isLargeDesktop = isLargeDesktop;
    exports.isMassiveDesktop = isMassiveDesktop;
    exports.isMobile = isMobile;
    exports.isTablet = isTablet;
    exports.isVendorTaxonomyKey = isVendorTaxonomyKey;
    exports.isXlDesktop = isXlDesktop;
    exports.isXsMobile = isXsMobile;
    exports.jumpInPlace = jumpInPlace;
    exports.loadSrc = loadSrc;
    exports.lockPageScroll = lockPageScroll;
    exports.loginFailure = loginFailure;
    exports.loginRequest = loginRequest;
    exports.loginSuccess = loginSuccess;
    exports.logout = logout;
    exports.nextIndex = nextIndex;
    exports.notDesktop = notDesktop;
    exports.notLargeDesktop = notLargeDesktop;
    exports.notMassiveDesktop = notMassiveDesktop;
    exports.notMobile = notMobile;
    exports.notTablet = notTablet;
    exports.notXlDesktop = notXlDesktop;
    exports.onboardTrackingConstants = onboardTrackingConstants;
    exports.pascalize = pascalize$1;
    exports.pluralize = pluralize$1;
    exports.prevIndex = prevIndex;
    exports.publishFeatureFlagOverrides = publishFeatureFlagOverrides;
    exports.randomSeededArray = randomSeededArray;
    exports.removeSubString = removeSubString$1;
    exports.renderIf = renderIf;
    exports.send2FAResendActionRequest = send2FAResendActionRequest;
    exports.send2FAResendRequest = send2FAResendRequest;
    exports.send2FAVerifyActionRequest = send2FAVerifyActionRequest;
    exports.send2FAVerifyRequest = send2FAVerifyRequest;
    exports.sendAppleLoginRequest = sendAppleLoginRequest;
    exports.sendFacebookLoginRequest = sendFacebookLoginRequest;
    exports.sendLoginRequest = sendLoginRequest;
    exports.sendResetPassword = sendResetPassword;
    exports.sendSignOutRequest = sendSignOutRequest;
    exports.sendSignupRequest = sendSignupRequest;
    exports.setAllStorage = setAllStorage;
    exports.setCookie = setCookie;
    exports.setExperimentOverrides = setExperimentOverrides;
    exports.setFeatureFlagOverride = setFeatureFlagOverride;
    exports.setGTMLoggedIn = setGTMLoggedIn;
    exports.setGTMLoggedOut = setGTMLoggedOut;
    exports.setLocalStorage = setLocalStorage;
    exports.setSessionStorage = setSessionStorage;
    exports.swapInPlace = swapInPlace;
    exports.toastsActions = toastsActions;
    exports.toastsReducer = toastsReducer;
    exports.trackCtaClicked = trackCtaClicked;
    exports.trackCtaListViewed = trackCtaListViewed;
    exports.trackCtaViewed = trackCtaViewed;
    exports.trackEvent = trackEvent;
    exports.trackFlowCompleted = trackFlowCompleted;
    exports.trackFlowStarted = trackFlowStarted;
    exports.trackFlowStepCompleted = trackFlowStepCompleted;
    exports.trackFlowStepSkipped = trackFlowStepSkipped;
    exports.trackFlowStepViewed = trackFlowStepViewed;
    exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;
    exports.trackGoogleTagManagerEvent = trackGoogleTagManagerEvent;
    exports.trackIdentifyUser = trackIdentifyUser;
    exports.trackOnboardingCompleted = trackOnboardingCompleted;
    exports.trackOnboardingStarted = trackOnboardingStarted;
    exports.trackOnboardingStepCompleted = trackOnboardingStepCompleted;
    exports.trackOnboardingStepSkipped = trackOnboardingStepSkipped;
    exports.trackOnboardingStepViewed = trackOnboardingStepViewed;
    exports.trackProduct = trackProduct;
    exports.trackProductAdded = trackProductAdded;
    exports.trackProductClicked = trackProductClicked;
    exports.trackProductDismissed = trackProductDismissed;
    exports.trackProductListViewed = trackProductListViewed;
    exports.trackProductViewed = trackProductViewed;
    exports.trackRegistryItemAdded = trackRegistryItemAdded;
    exports.trackUserCreated = trackUserCreated;
    exports.truncate = truncate$1;
    exports.unlockPageScroll = unlockPageScroll;
    exports.userActions = userActions;
    exports.userAwarenessActions = userAwarenessActions;
    exports.userAwarenessChannelConstants = channels;
    exports.userAwarenessReducer = userAwarenessReducer;
    exports.userAwarenessSelectors = userAwarenessSelectors;
    exports.userReducer = userReducer;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=zola-helpers-client.js.map
